import * as tr from "react";
import n, { useRef as Re, useState as R, useEffect as j, useMemo as ge, useImperativeHandle as Fi, useCallback as Ne, forwardRef as Ft } from "react";
import { useForm as ce, Controller as k, useFormContext as vt, useFormState as Br, FormProvider as jl } from "react-hook-form";
import { PipoProvider as I, getImageSize as Ai, on as Hi, off as Vn, chunkString as qi, CCDC_PAYMENT_METHOD_TYPE as Ll, cnpj as nr, pickNumeric as Rl, cpf as ar, validator as K, formatAmount as Ui, SUPPORT_BANK_MAP as un, SUPPORT_TOSS_BANK_MAP as gr, SUPPORT_PAYMENT_METHODS_ID_MAP as or, boldText as Fl, PAYMENT_CODE_CONFIG as Ar, setDisplayBankIcon as vn, banktransferBankIcon as Al, PrivacyPolicyText as Yi, formatValue as jn, ibanValidInput as zi, formatCursor as Xi, ISOCodeToCountry as Gi, countryToISOCode as Ki, pickNumericAlphabet as Wi, getAddressTexts as Ji, callingCode as ue, generateCommonPaymentParams as Dr, BOLETO_PAYMENT_PARAMS_MAP as Zi, BOLETO_PAYMENT_METHOD as dr, sendBlurEvent as ie, cardTypeMap as Qi, CCDC_PAYMENT_PARAMS_MAP as es, OVO_DIRECT_PAYMENT_METHOD as Hr, validateStatus as gn, OVO_REDIRECT_PAYMENT_METHOD as qr, PAYCELL_PAYMENT_METHOD as jt, TODITO_CASH_PAYMENT_METHOD as Lt, getStarlingKeyByUnavailableCode as En, DAILYYAMAZAKI_PAYMENT_METHOD as Ur, SEVENELEVEN_PAYMENT_METHOD as Yr, LAWSON_PAYMENT_METHOD as zr, MINISTOP_PAYMENT_METHOD as Xr, SEICOMART_PAYMENT_METHOD as Gr, FAMILYMART_PAYMENT_METHOD as Kr, OXXO_PAYMENT_PARAMS_MAP as ts, OXXO_PAYMENT_METHOD as _r, PAYEASY_PAYMENT_METHOD as ct, IBANBanktransferValidator as rs, onBankIbanChange as Hl, errorMessage as ql, bankList as ns, BANKTRANSFER_PAYMENT_METHOD as Wr, BANKTRANSFER_TOSS_PAYMENT_METHOD as Jr, SHOPEEPAY_PAYMENT_METHOD as Zr, QIWI_PAYMENT_METHOD as Qr, MERCADOPAGO_PAYMENT_METHOD as en, GOPAY_DIRECT_PAYMENT_METHOD as tn, chooseFormByModel as Ul, PIX_PAYMENT_PARAMS_MAP as as, PIX_PAYMENT_METHOD as ur, IBANInternetValidator as os, internetBankList as ls, internetBankIcon as is, OTHER_NEED_VALIDATE_LIST as ss, STORED_NEED_VALIDATE_LIST as cs, DIRECT_DEBIT_PAYMENT_METHODS_ID_LIST as ps, isCurrentMergedItemAlreadySelected as yn, getItemLabel as Yl, generateMarketingTextList as Ln, isConfigurationOtherItem as hn, getItemMaskedIdentity as $t, generateExtraPaymentParams as ms, generatePaymentParams as fn, isItemExpired as ds, isConfigurationStoredItem as zl, seeMoreClickEvent as _s, AKULAKU_PAYMENT_METHOD as rn, isGeneralCCDC as Xl, hasPiListForm as us } from "@pipo-lib/utils";
import { PipoProvider as ev } from "@pipo-lib/utils";
import { useControlled as Q, useCountdownTimer as ys, useVoucher as hs, useUIVoucher as Vr, useExpiryDate as fs, useTouchedErrors as de, useAddress as vs, useAddressAutocomplete as gs, usePostalCode as Es, useSubmittingState as Rt, usePipoRouter as sr, useProxyType as Pn, useCardNumber as Ps, useExpiryDateError as bs, useSecurityCode as Gl, useCCDCFormConfig as xs, useElementFormSubmit as Ms, useFormatPayment as Kl, useUIPaymentMethods as Wl, useSelectPayment as Jl, useDefaultSelect as Os } from "@pipo-lib/hooks";
import { IconChevronLeftLTR as Cs, IconScan as ws, IconXMarkCircleFill as $s, IconExclamationMarkTriangleFill as Ss, IconDocOnDoc as Zl, TUXIconExclamationMarkCircle as ks, TUXIconTickCircle as Ts, TUXIconClock as Is, TUXIconChevronDown as jr, TUXIconArrowLeftRightCircle as Ns, TUXIconPhone as Bs, TUXIconBankCard as Ds, IconChevronDown as Vs, IconXMarkSmall as Ql, IconMagnifyingGlass as js, TUXIconChevronRightLTR as Ls, IconExclamationMarkCircle as Rs, IconChevronRightLTR as Fs } from "@byted-tiktok/tux-icons";
import ae from "clsx";
import { TUXDialog as ei, TUXTextFieldWIP as We, TUXButton as St, TUXSeparator as lr, TUXProvider as As, TUXToast as Hs, TUXSingleSelectSheetWIP as qs, TUXCheckbox as Us, TUXRadio as bn, TUXLoading as Ys, TUXSheetWIP as ti, TUXAppBar as ri, TUXSelectField as zs } from "@byted-tiktok/tux-components";
import { useRequest as Xs, useControlled as cr, useMultiSelect as Gs, useTimer as ni, useBoolean as xn } from "@byted/hooks";
import pr from "lodash.omit";
import { FlashOn as Ks, FlashOff as Ws, MarkCircle as Js, Pci as Zs, SearchBig as Qs, SelectedBackground as ai, Selected as oi, Star as ec, Remove as tc, Link as rc, ArrowDown as nc, ArrowUp as ac } from "@pipo-lib/icon";
import oc from "lodash.groupby";
const Rn = 4 * 1024 * 1024, Fn = 319, An = 204, lc = (t) => {
  const { onDismiss: e, onResult: r, setIsVideoVisible: a, isVideoStop: o } = t, { t: i } = I.useContext(), { innerHeight: l, innerWidth: c } = window, s = Re(null), [p, _] = R(!1), [m, d] = R(null), [f, g] = R(!1), [h, y] = R(!1), [u, v] = R(!1), P = (E) => {
    const { videoWidth: O, videoHeight: T } = E, W = l > c ? l / T : c / O, re = (O - Fn / W) / 2, J = (T - An / W) / 2, F = Fn / W, ee = An / W;
    return {
      sx: re,
      sy: J,
      sWidth: F,
      sHeight: ee
    };
  }, $ = () => {
    const E = s.current;
    if (!!E) {
      E.setAttribute("autoplay", ""), E.setAttribute("muted", ""), E.setAttribute("playsinline", "");
      try {
        navigator == null || navigator.mediaDevices.getUserMedia({
          audio: !1,
          video: {
            facingMode: "environment"
          }
        }).then((O) => {
          d(O), E.srcObject = O;
          const T = O == null ? void 0 : O.getVideoTracks()[0];
          if (T && typeof T.getCapabilities == "function") {
            const W = T.getCapabilities();
            W != null && W.torch && y(!0);
          }
          return E.play().then(() => {
            v(!0), window.addEventListener("popstate", (W) => {
              C();
            });
          });
        }).catch((O) => {
          console.log(`An error occurred: ${String(O)}`), e(!0);
        });
      } catch (O) {
        console.log(`An error occurred: ${String(O)}`), e(!0);
      }
    }
  }, x = (E) => {
    if (!s.current)
      return;
    const T = m == null ? void 0 : m.getVideoTracks()[0];
    if (T && typeof T.getCapabilities == "function") {
      const W = T.getCapabilities();
      W != null && W.torch && T.applyConstraints({
        advanced: [
          { fillLightMode: E ? "off" : "flash", torch: !E }
        ]
      }).then((re) => {
        g(!E);
      }).catch((re) => {
        console.log(`Controll torch error: ${String(re)}`);
      });
    }
  }, N = () => {
    x(f);
  }, C = () => {
    const E = s.current;
    !E || (h && f && x(!0), v(!1), m == null || m.getVideoTracks().forEach((O) => O.stop()), _(!1), E.srcObject = null, E.src = "", E.paused || E.pause(), a(!1));
  }, M = () => {
    const E = s.current;
    if (!E || E.paused)
      return;
    const O = document.createElement("canvas"), T = O.getContext("2d"), { sx: W, sy: re, sWidth: J, sHeight: F } = P(E);
    O.width = J, O.height = F, T == null || T.drawImage(E, W, re, J, F, 0, 0, J, F);
    const ee = O.toDataURL("image/png"), pe = Ai(ee);
    if (pe > Rn) {
      const _e = parseFloat((Rn / pe).toFixed(2)) + 0.01, G = O.toDataURL("image/png", _e);
      r(G);
    } else
      r(ee);
  };
  function b() {
    return new Promise((E) => {
      E(M());
    });
  }
  return Xs(b, {
    auto: !0,
    pollingInterval: 1e3,
    defaultParams: [],
    refreshDeps: []
  }), j(
    () => {
      $();
    },
    []
  ), j(
    () => {
      o && C();
    },
    [o]
  ), /* @__PURE__ */ n.createElement("div", {
    className: "card-scanner__container"
  }, /* @__PURE__ */ n.createElement("video", {
    ref: s,
    className: "card-scanner__video",
    onCanPlay: () => {
      !s.current || p || _(!0);
    }
  }, "Video stream not available."), u && /* @__PURE__ */ n.createElement("span", {
    className: "card-scanner__close-button",
    onClick: () => {
      C(), e();
    }
  }, /* @__PURE__ */ n.createElement(Cs, {
    fontSize: 20,
    color: "white"
  })), u && /* @__PURE__ */ n.createElement("div", {
    className: "card-scanner__scan-box"
  }, /* @__PURE__ */ n.createElement("div", {
    className: "card-scanner__scan-box-container"
  }, /* @__PURE__ */ n.createElement("span", {
    className: "card-scanner__card-number H1-Regular"
  }, "8888 8888 8888 8888"), /* @__PURE__ */ n.createElement("span", {
    className: "card-scanner__expiry-date P1-Regular"
  }, "MM/YY"), /* @__PURE__ */ n.createElement("div", {
    className: "card-scanner__chip"
  }))), u && /* @__PURE__ */ n.createElement("span", {
    className: "card-scanner__remind H4-Regular"
  }, i("pipo_payin_dropin_cashier_bindcard_cardnumber_ocrremind")), h && /* @__PURE__ */ n.createElement("span", {
    className: "card-scanner__flash-button",
    onClick: N
  }, f ? /* @__PURE__ */ n.createElement(Ks, null) : /* @__PURE__ */ n.createElement(Ws, null)));
}, ic = /* @__PURE__ */ n.createElement("svg", {
  width: "12",
  height: "4",
  viewBox: "0 0 12 4",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /* @__PURE__ */ n.createElement("path", {
  d: "M0 0C3.5 4.47039e-07 5 4 6 4C7 4 8.5 4.47039e-07 12 0H0Z",
  fill: "#4B4B4B"
})), sc = ({
  children: t,
  content: e,
  position: r,
  contentOffsetH: a = 0,
  arrowOffsetH: o = 0
}) => {
  const { isFlip: i } = I.useContext(), l = n.useRef(null), [c, s] = n.useState(
    r.horizontal || "top"
  ), [p] = n.useState(
    r.vertical || "middle"
  ), [_, m] = n.useState("hidden"), d = n.useCallback((y) => {
    l.current && (l.current.contains(y.target) || m("hidden"));
  }, []);
  n.useEffect(
    () => {
      _ === "invisible" ? Hi(document, "mousedown", d) : _ === "hidden" && Vn(document, "mousedown", d);
    },
    [_]
  ), n.useEffect(
    () => () => {
      Vn(document, "mousedown", d);
    },
    []
  ), n.useEffect(() => {
    if (_ === "invisible") {
      if (l.current) {
        const { top: y, bottom: u } = l.current.getBoundingClientRect();
        c === "top" ? y < 0 && s("bottom") : c === "bottom" && u > document.body.clientHeight && s("top");
      }
      m("visible");
    }
  }, [_, c]);
  const f = n.useMemo(() => {
    const y = p === "middle" ? {
      marginLeft: "50%",
      transform: "translateX(-50%)"
    } : {};
    return c === "top" ? y.bottom = "100%" : (y.flexDirection = "column-reverse", y.top = "100%"), i ? y.left = -15 : y.right = -15, y;
  }, [c, p, i]), g = n.useMemo(() => {
    const y = {
      margin: "0 auto",
      lineHeight: "0",
      paddingBottom: "5px"
    };
    return o && p === "left" && (i ? (y.marginLeft = -o + 15, y.marginRight = "auto") : (y.marginRight = -o + 15, y.marginLeft = "auto")), c === "bottom" && (y.transform = "rotate(0.5turn)", y.transformOrigin = "center"), y;
  }, [c, p, o, i]), h = n.useCallback(() => {
    m(_ === "hidden" ? "invisible" : "hidden");
  }, [_]);
  return /* @__PURE__ */ n.createElement("div", {
    ref: l,
    className: `relative flex ${p === "left" ? "justify-end" : ""}`
  }, /* @__PURE__ */ n.createElement("div", {
    className: `flex-col flex absolute ${_}`,
    style: f
  }, /* @__PURE__ */ n.createElement("div", {
    style: {
      marginLeft: a
    }
  }, e), /* @__PURE__ */ n.createElement("div", {
    style: g
  }, ic)), /* @__PURE__ */ n.createElement("div", {
    onClick: h
  }, t));
}, cc = n.memo(sc);
const pc = () => /* @__PURE__ */ n.createElement("div", {
  className: "w-32 h-20 pipo-mobile-card-number-icon-list-item icon-list-dots"
}, /* @__PURE__ */ n.createElement("div", {
  className: "icon-list-dot"
}), /* @__PURE__ */ n.createElement("div", {
  className: "icon-list-dot"
}), /* @__PURE__ */ n.createElement("div", {
  className: "icon-list-dot"
}));
var mc = Object.defineProperty, dc = Object.defineProperties, _c = Object.getOwnPropertyDescriptors, Hn = Object.getOwnPropertySymbols, uc = Object.prototype.hasOwnProperty, yc = Object.prototype.propertyIsEnumerable, qn = (t, e, r) => e in t ? mc(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, hc = (t, e) => {
  for (var r in e || (e = {}))
    uc.call(e, r) && qn(t, r, e[r]);
  if (Hn)
    for (var r of Hn(e))
      yc.call(e, r) && qn(t, r, e[r]);
  return t;
}, fc = (t, e) => dc(t, _c(e));
const nn = [
  {
    title: "pipo_payin_dropin_cashier_error_camera",
    message: "pipo_payin_dropin_cashier_error_camera_statement",
    actionText: "pipo_common_payin_mobile_address_popup1_confirm"
  },
  {
    title: "pipo_payin_dropin_cashier_networkerror",
    message: "pipo_payin_dropin_cashier_networkerror_statement",
    actionText: "pipo_common_payin_mobile_address_popup1_confirm"
  }
], vc = (t, e) => {
  const {
    title: r,
    hasError: a,
    errorMessage: o,
    placeholder: i,
    value: l,
    maxLength: c,
    cardBrands: s,
    currentCardBrand: p,
    onChange: _,
    onScanCard: m,
    onSendEvent: d,
    setIsAfterOCR: f,
    onScanBlur: g
  } = t, { isFlip: h, state: y, t: u } = I.useContext(), { config: v = {}, amount: P } = y, { ccdc: $ = {} } = v, { showCardImage: x = !0 } = $, N = Re(), [C, M] = R(!0), [b, E] = R(!1), [O, T] = R(!1), [W, re] = R(!1), [J, F] = R(
    nn[0]
  ), ee = Re(null), pe = Re(null), _e = Re(!1), [G, q] = R(""), z = Re(0), H = () => l ? l.length > 4 ? qi(l, 4).join(" ") : l : "", Ee = () => {
    _e.current = !0, z.current = 0, re(!1), M(!1), E(!0), d && d({
      name: P != null && P.value ? "fp_sdk_checkout_dropin_element_click" : "fp_sdk_checkout_pi_management_click",
      categories: {
        click_scenario: "ocr_card_number",
        pi_type_1: Ll.paymentMethodType
      }
    });
  }, ke = (D) => {
    !m || !_e.current || m(D).then((B) => {
      B.code === 1 && _e.current && (_e.current = !1, _(B.number), q(B.image), re(!0), M(!0), f && f("1"), g && g()), B.code === 2 && (z.current = z.current + 1, z.current === 5 && (re(!0), M(!0), F(nn[1]), T(!0)));
    }).catch((B) => {
      console.log(B);
    });
  }, { titleIconList: oe, contentIconList: ve } = ge(() => {
    var D, B;
    const L = {
      titleIconList: [],
      contentIconList: []
    };
    if (!ee.current || !pe.current)
      return L;
    const U = (D = ee.current) == null ? void 0 : D.offsetWidth, Z = (B = pe.current) == null ? void 0 : B.offsetWidth;
    return s.forEach((xe, $e) => {
      const Be = xe.paymentMethod.icon.iconUrl, Ze = Math.floor((U - Z) / 33.1);
      $e < Ze ? L.titleIconList.push(Be) : ($e === Ze && L.contentIconList.push(L.titleIconList.pop() || ""), L.contentIconList.push(Be));
    }), L;
  }, [s, pe.current, ee.current]);
  return j(
    () => {
      var D;
      _(l), l === "" && q(""), (D = N.current) == null || D.setInnerValue(H());
    },
    [l]
  ), /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", {
    className: `absolute pt-16 pipo-mobile-card-number-icon-list ${h ? "left-0" : "right-0"}`
  }, /* @__PURE__ */ n.createElement("div", {
    className: `pipo-mobile-card-number-icon-list-container ${h ? "transform-origin-left" : "transform-origin-right"}`
  }, oe.map((D) => /* @__PURE__ */ n.createElement("img", {
    src: D,
    key: D,
    className: `w-32 h-20 ${h ? "ml-75" : "mr-75"}`
  })), ve.length > 0 && /* @__PURE__ */ n.createElement(cc, {
    position: { horizontal: "top", vertical: "left" },
    arrowOffsetH: -10,
    content: /* @__PURE__ */ n.createElement("div", {
      className: "pipo-mobile-card-number-icon-list-popover-content",
      style: {
        width: Math.min(ve.length, 7) * 39.5 + 22.5,
        padding: h ? "15px 15px 7.5px 7.5px" : "15px 7.5px 7.5px 15px"
      }
    }, ve.map((D) => /* @__PURE__ */ n.createElement("img", {
      src: D,
      key: D,
      className: `w-32 h-20 pipo-mobile-card-number-icon-list-item ${h ? "ml-75" : "mr-75"}`
    })))
  }, /* @__PURE__ */ n.createElement(pc, null)))), /* @__PURE__ */ n.createElement(At, fc(hc({}, pr(t, [
    "cardBrands",
    "currentCardBrand",
    "onScanCard",
    "onSendEvent"
  ])), {
    ref: e,
    handleRef: N,
    type: "number",
    hasBottomBorder: !0,
    hasError: a,
    errorMessage: o,
    placeholder: i,
    title: /* @__PURE__ */ n.createElement("div", {
      className: "flex justify-between items-center w-full",
      ref: ee
    }, /* @__PURE__ */ n.createElement("span", {
      className: h ? "ml-2" : "mr-2",
      ref: pe
    }, r)),
    hasClearButton: !0,
    maxLength: c,
    append: /* @__PURE__ */ n.createElement("div", {
      className: "flex items-center justify-end",
      style: { width: "min-intrinsic" }
    }, p && /* @__PURE__ */ n.createElement("img", {
      className: "w-32 h-20 mr-2 rounded-2",
      src: p == null ? void 0 : p.paymentMethod.icon.iconUrl
    }), m && C && /* @__PURE__ */ n.createElement("div", {
      className: "ml-8",
      onClick: Ee
    }, /* @__PURE__ */ n.createElement(ws, {
      fontSize: 20
    }))),
    footer: G !== "" && l !== "" && x && /* @__PURE__ */ n.createElement("img", {
      src: G,
      className: "h-48 w-full"
    }),
    value: l,
    onChange: (D) => _(D.target.value)
  })), b && /* @__PURE__ */ n.createElement(lc, {
    onDismiss: (D = !1) => {
      M(!D), re(!0), D && (F(nn[0]), T(!0));
    },
    onResult: ke,
    setIsVideoVisible: E,
    isVideoStop: W
  }), /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement(ei, {
    isVisible: O,
    title: u(J.title) || J.title,
    message: u(J.message) || J.message,
    actionVariant: "text",
    actions: [
      {
        variant: "primary",
        text: u(J.actionText) || J.actionText,
        onClick: () => {
          T(!1);
        }
      }
    ]
  })));
}, gc = n.forwardRef(vc);
var Ec = Object.defineProperty, Pc = Object.defineProperties, bc = Object.getOwnPropertyDescriptors, Un = Object.getOwnPropertySymbols, xc = Object.prototype.hasOwnProperty, Mc = Object.prototype.propertyIsEnumerable, Yn = (t, e, r) => e in t ? Ec(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Oc = (t, e) => {
  for (var r in e || (e = {}))
    xc.call(e, r) && Yn(t, r, e[r]);
  if (Un)
    for (var r of Un(e))
      Mc.call(e, r) && Yn(t, r, e[r]);
  return t;
}, Cc = (t, e) => Pc(t, bc(e));
function li(t) {
  const { title: e, placeholder: r, errorMessage: a, hasError: o, onBlur: i } = t, [l, c] = Q(t), s = Re();
  return j(
    () => {
      var p;
      (p = s.current) == null || p.setInnerValue(l), c(l);
    },
    [l]
  ), /* @__PURE__ */ n.createElement(At, Cc(Oc({}, t), {
    hasBottomBorder: !0,
    type: "number",
    handleRef: s,
    value: l,
    onChange: (p) => c(p.target.value),
    placeholder: r,
    title: /* @__PURE__ */ n.createElement("div", {
      className: "flex items-center"
    }, /* @__PURE__ */ n.createElement("span", {
      className: "mr-4"
    }, e)),
    append: /* @__PURE__ */ n.createElement("img", {
      src: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/cvvIcon_add216.svg"
    }),
    hasError: o,
    maxLength: 4,
    errorMessage: a,
    hasClearButton: !0,
    onBlur: i
  }));
}
var wc = Object.defineProperty, $c = Object.defineProperties, Sc = Object.getOwnPropertyDescriptors, Er = Object.getOwnPropertySymbols, ii = Object.prototype.hasOwnProperty, si = Object.prototype.propertyIsEnumerable, zn = (t, e, r) => e in t ? wc(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Xn = (t, e) => {
  for (var r in e || (e = {}))
    ii.call(e, r) && zn(t, r, e[r]);
  if (Er)
    for (var r of Er(e))
      si.call(e, r) && zn(t, r, e[r]);
  return t;
}, kc = (t, e) => $c(t, Sc(e)), Tc = (t, e) => {
  var r = {};
  for (var a in t)
    ii.call(t, a) && e.indexOf(a) < 0 && (r[a] = t[a]);
  if (t != null && Er)
    for (var a of Er(t))
      e.indexOf(a) < 0 && si.call(t, a) && (r[a] = t[a]);
  return r;
};
const Ic = (t, e) => {
  const r = t, {
    title: a,
    clear: o = !0,
    isRtl: i = !0,
    type: l,
    formatValue: c,
    formatCursor: s,
    onClear: p,
    handleRef: _,
    append: m,
    start: d,
    end: f,
    footer: g,
    style: h,
    hasBottomBorder: y = !0,
    className: u,
    errorMessage: v,
    hasClearButton: P = !0,
    hasError: $,
    validInput: x
  } = r, N = Tc(r, [
    "title",
    "clear",
    "isRtl",
    "type",
    "formatValue",
    "formatCursor",
    "onClear",
    "handleRef",
    "append",
    "start",
    "end",
    "footer",
    "style",
    "hasBottomBorder",
    "className",
    "errorMessage",
    "hasClearButton",
    "hasError",
    "validInput"
  ]);
  let C = l;
  l === "number" ? C = "tel" : l === "character" && (C = "text");
  const { isFlip: M } = I.useContext(), [b, E] = R(!1), [O, T] = R(
    t.value || t.defaultValue || ""
  ), [W, re] = R(0), J = ge(() => i && M && l !== "number", [M, l, i]);
  j(
    () => {
      var G;
      O && (e == null ? void 0 : e.current) && ((G = e.current) == null || G.setSelectionRange(
        W,
        W
      ));
    },
    [O]
  ), Fi(_, () => ({
    clear: () => {
      ee();
    },
    setInnerValue: (G) => {
      T(G);
    }
  })), j(
    () => {
      const G = c ? c(t.value || "") : t.value || "";
      T(G), G && F({ target: { value: G } });
    },
    [t.value]
  );
  const F = (G) => {
    var q;
    e && re(
      ((q = e == null ? void 0 : e.current) == null ? void 0 : q.selectionStart) || 0
    );
    let z = G.target.value;
    if (z) {
      if (l === "number" && (!/^[0-9\s]+$/.test(z) || (z.includes(" ") && (z = z == null ? void 0 : z.replace(/\s/g, "")), t.max && Number(z) > t.max)) || x && !x.test(z))
        return;
      t.maxLength && z.length > t.maxLength && (z = z.slice(0, t.maxLength)), c && (s && re(
        (H) => s(O.toString(), z, H)
      ), z = c(z));
    }
    T(z), t.onChange && t.onChange(G);
  }, ee = () => {
    T(""), F({ target: { value: "" } }), t.onBlur && t.onBlur({ target: { value: "" } }), t.onClear && t.onClear();
  }, pe = (G) => {
    setTimeout(() => E(!1)), t.onBlur && t.onBlur(G);
  }, _e = (G) => {
    setTimeout(() => E(!0)), t.onFocus && t.onFocus(G);
  };
  return /* @__PURE__ */ n.createElement(n.Fragment, null, a && /* @__PURE__ */ n.createElement("header", {
    className: "flex flex-col pt-16 pb-8"
  }, /* @__PURE__ */ n.createElement("div", {
    className: "flex H4-SemiBold text-color-TextPrimary"
  }, a)), /* @__PURE__ */ n.createElement("div", {
    className: "flex items-center relative",
    style: Xn({
      padding: "15px 0px",
      direction: J ? "rtl" : "ltr"
    }, h)
  }, d, /* @__PURE__ */ n.createElement("input", kc(Xn({
    className: ae(
      u,
      "pipo-custom-input tt-text-field--input H4-Regular text-color-TextPrimary w-full appearance-none background-color-transparent p-0 m-0 overflow-ellipsis",
      { "mr-24": Boolean(m) && !J },
      { "ml-24": Boolean(m) && J }
    ),
    ref: e,
    spellCheck: "false"
  }, N), {
    type: C,
    value: O,
    onChange: F,
    onFocus: _e,
    onBlur: pe
  })), /* @__PURE__ */ n.createElement("div", {
    className: "absolute flex items-center",
    style: {
      right: J ? "unset" : 0,
      left: J ? 0 : "unset",
      color: "var(--pipo-mobile-color-text-primary)"
    }
  }, b && o && O && P && /* @__PURE__ */ n.createElement($s, {
    className: "text-color-TextQuaternary mx-8",
    style: { fontSize: 18 },
    onClick: ee,
    onMouseDown: (G) => {
      G.preventDefault();
    }
  }), m), f), y && /* @__PURE__ */ n.createElement("div", {
    className: ae("tt-text-field--divider background-color-LineInput", {
      "background-color-Negative": Boolean($)
    })
  }), $ && /* @__PURE__ */ n.createElement("div", {
    className: "mt-8 text-color-Negative flex items-center P1-Regular"
  }, /* @__PURE__ */ n.createElement(Ss, {
    className: "self-start",
    style: {
      fontSize: "16px"
    }
  }), /* @__PURE__ */ n.createElement("span", {
    className: "mx-8"
  }, v)), g && /* @__PURE__ */ n.createElement("div", {
    className: "mt-8 P2-Regular text-color-TextTertiary"
  }, g));
}, At = n.forwardRef(Ic);
var Nc = Object.defineProperty, Bc = Object.defineProperties, Dc = Object.getOwnPropertyDescriptors, Gn = Object.getOwnPropertySymbols, Vc = Object.prototype.hasOwnProperty, jc = Object.prototype.propertyIsEnumerable, Kn = (t, e, r) => e in t ? Nc(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Lc = (t, e) => {
  for (var r in e || (e = {}))
    Vc.call(e, r) && Kn(t, r, e[r]);
  if (Gn)
    for (var r of Gn(e))
      jc.call(e, r) && Kn(t, r, e[r]);
  return t;
}, Rc = (t, e) => Bc(t, Dc(e));
const Mn = (t) => {
  const { title: e, error: r, errorMessage: a, onBlur: o } = t, [i, l] = Q(t), c = ge(
    () => (l(i), nr.formatter(i)),
    [i]
  ), s = (p) => {
    const _ = Rl(p);
    l(_);
  };
  return /* @__PURE__ */ n.createElement("div", {
    "data-sel": "pipo-mobile-pi-boleto-input-cnpj"
  }, /* @__PURE__ */ n.createElement(We, Rc(Lc({}, t), {
    hasBottomBorder: !0,
    type: "text",
    value: c || "",
    placeholder: nr.placeholder,
    title: e,
    hasError: Boolean(r),
    errorMessage: a,
    onChange: (p) => s(p.target.value),
    maxLength: 18,
    hasClearButton: !0,
    onBlur: o
  })));
};
var Fc = Object.defineProperty, Ac = Object.defineProperties, Hc = Object.getOwnPropertyDescriptors, Wn = Object.getOwnPropertySymbols, qc = Object.prototype.hasOwnProperty, Uc = Object.prototype.propertyIsEnumerable, Jn = (t, e, r) => e in t ? Fc(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Yc = (t, e) => {
  for (var r in e || (e = {}))
    qc.call(e, r) && Jn(t, r, e[r]);
  if (Wn)
    for (var r of Wn(e))
      Uc.call(e, r) && Jn(t, r, e[r]);
  return t;
}, zc = (t, e) => Ac(t, Hc(e));
const On = (t) => {
  const { title: e, error: r, errorMessage: a, onBlur: o } = t, [i, l] = Q(t), c = ge(
    () => (l(i), ar.formatter(i)),
    [i]
  ), s = (p) => {
    const _ = Rl(p);
    l(_);
  };
  return /* @__PURE__ */ n.createElement("div", {
    "data-sel": "pipo-mobile-pi-boleto-input-cpf"
  }, /* @__PURE__ */ n.createElement(We, zc(Yc({}, t), {
    hasBottomBorder: !0,
    type: "text",
    value: c || "",
    placeholder: ar.placeholder,
    title: e,
    hasError: Boolean(r),
    errorMessage: a,
    onChange: (p) => s(p.target.value),
    maxLength: 14,
    hasClearButton: !0,
    onBlur: o
  })));
}, pt = (t) => {
  const { countryCode: e, onChange: r } = t;
  return j(
    () => {
      r == null || r(e);
    },
    [e]
  ), /* @__PURE__ */ n.createElement("div", {
    style: { display: "none" }
  });
};
var Xc = Object.defineProperty, Gc = Object.defineProperties, Kc = Object.getOwnPropertyDescriptors, Zn = Object.getOwnPropertySymbols, Wc = Object.prototype.hasOwnProperty, Jc = Object.prototype.propertyIsEnumerable, Qn = (t, e, r) => e in t ? Xc(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Zc = (t, e) => {
  for (var r in e || (e = {}))
    Wc.call(e, r) && Qn(t, r, e[r]);
  if (Zn)
    for (var r of Zn(e))
      Jc.call(e, r) && Qn(t, r, e[r]);
  return t;
}, Qc = (t, e) => Gc(t, Kc(e));
const we = (t) => {
  const {
    title: e,
    placeholder: r,
    maxLength: a = 128,
    error: o,
    errorMessage: i,
    onBlur: l
  } = t, [c, s] = Q(t);
  return j(
    () => {
      s(c);
    },
    [c]
  ), /* @__PURE__ */ n.createElement(We, Qc(Zc({}, t), {
    hasBottomBorder: !0,
    placeholder: r,
    value: c || "",
    title: e,
    hasError: Boolean(o),
    errorMessage: i,
    hasClearButton: !0,
    onChange: (p) => s(p.target.value),
    maxLength: a,
    onBlur: l
  }));
};
var ep = Object.defineProperty, tp = Object.defineProperties, rp = Object.getOwnPropertyDescriptors, ea = Object.getOwnPropertySymbols, np = Object.prototype.hasOwnProperty, ap = Object.prototype.propertyIsEnumerable, ta = (t, e, r) => e in t ? ep(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, op = (t, e) => {
  for (var r in e || (e = {}))
    np.call(e, r) && ta(t, r, e[r]);
  if (ea)
    for (var r of ea(e))
      ap.call(e, r) && ta(t, r, e[r]);
  return t;
}, lp = (t, e) => tp(t, rp(e));
const Fe = (t) => {
  const {
    title: e,
    placeholder: r,
    error: a,
    errorMessage: o,
    countryOrRegion: i = "",
    countryCode: l = "",
    addBefore: c,
    footer: s,
    minLength: p,
    maxLength: _ = 11,
    autoFocus: m,
    onBlur: d
  } = t, [f, g] = cr(t), h = Re();
  return j(
    () => {
      var y;
      !isNaN(Number(f)) && !K.noWhitespaceRegex.test(f) && ((y = h.current) == null || y.setInnerValue(f), g(f, l));
    },
    [f, l]
  ), /* @__PURE__ */ n.createElement(At, lp(op({}, pr(t, ["error"])), {
    hasBottomBorder: !0,
    type: "number",
    handleRef: h,
    value: f || "",
    onChange: (y) => g(y.target.value, l),
    placeholder: r,
    title: e,
    hasError: Boolean(a),
    start: c || i || l ? /* @__PURE__ */ n.createElement("div", {
      className: "flex text-color-TextPrimary"
    }, /* @__PURE__ */ n.createElement("span", {
      className: "H4-Regular",
      style: { width: "max-content" }
    }, c || `${i} +${l}`), /* @__PURE__ */ n.createElement("div", {
      className: "mx-8 h-10 mt-4"
    }, /* @__PURE__ */ n.createElement(fe, {
      direction: "vertical"
    }))) : void 0,
    errorMessage: o,
    maxLength: _,
    minLength: p,
    hasClearButton: !0,
    footer: s,
    autoFocus: m,
    onBlur: d
  }));
};
var ip = (t, e, r) => new Promise((a, o) => {
  var i = (s) => {
    try {
      c(r.next(s));
    } catch (p) {
      o(p);
    }
  }, l = (s) => {
    try {
      c(r.throw(s));
    } catch (p) {
      o(p);
    }
  }, c = (s) => s.done ? a(s.value) : Promise.resolve(s.value).then(i, l);
  c((r = r.apply(t, e)).next());
});
const Lr = (t) => {
  const { t: e, state: r, paymentType: a, renewType: o } = I.useContext(), { amount: i, locale: l } = r, {
    isValid: c,
    disabled: s = !1,
    isLoading: p,
    onClick: _,
    toExtend: m = !1,
    selectedType: d = "others"
  } = t, f = Boolean(i == null ? void 0 : i.value), g = f ? Ui({
    amount: i == null ? void 0 : i.value,
    currency: i == null ? void 0 : i.currency,
    locale: l
  }) : "", h = f ? /* @__PURE__ */ n.createElement("div", {
    className: "flex mb-8 justify-between"
  }, /* @__PURE__ */ n.createElement("span", {
    className: "H3-SemiBold text-color-TextPrimary"
  }, e("pipo_payin_total_amount"), ":"), /* @__PURE__ */ n.createElement("span", {
    className: "H3-SemiBold text-color-TextPrimary"
  }, g)) : null, y = ge(() => e(a === "agreement" || a === "subscription" && o === "auto" ? d === "stored" || a === "subscription" ? "pipo_payin_confirm" : "pipo_payin_payandbind" : m ? "pipo_common_payin_token_expire_extendandconfirm" : f ? "pipo_payin_btn_pay" : "pipo_payin_confirm"), [m, f, a, o, d, e]), u = Boolean(!c || s), [v, P] = R(), $ = (x) => ip(void 0, null, function* () {
    P(!0), x.preventDefault(), yield _ == null ? void 0 : _(x), P(!1);
  });
  return /* @__PURE__ */ n.createElement("div", {
    className: "pipo-mobile-submit-button"
  }, /* @__PURE__ */ n.createElement(fe, null), /* @__PURE__ */ n.createElement("div", {
    className: "pt-12 pb-12 pl-16 pr-16"
  }, h, /* @__PURE__ */ n.createElement(St, {
    disabled: u,
    text: y,
    isLoading: p !== void 0 ? p : v,
    onClick: $
  })));
};
function sp({ children: t }) {
  return /* @__PURE__ */ n.createElement("div", {
    className: "H4-Regular px-16 pb-8"
  }, t);
}
var cp = Object.defineProperty, Pr = Object.getOwnPropertySymbols, ci = Object.prototype.hasOwnProperty, pi = Object.prototype.propertyIsEnumerable, ra = (t, e, r) => e in t ? cp(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, pp = (t, e) => {
  for (var r in e || (e = {}))
    ci.call(e, r) && ra(t, r, e[r]);
  if (Pr)
    for (var r of Pr(e))
      pi.call(e, r) && ra(t, r, e[r]);
  return t;
}, mp = (t, e) => {
  var r = {};
  for (var a in t)
    ci.call(t, a) && e.indexOf(a) < 0 && (r[a] = t[a]);
  if (t != null && Pr)
    for (var a of Pr(t))
      e.indexOf(a) < 0 && pi.call(t, a) && (r[a] = t[a]);
  return r;
};
function dp(t) {
  const e = t, { prefixCls: r, content: a, className: o, extra: i } = e, l = mp(e, ["prefixCls", "content", "className", "extra"]), c = ae(r && `${r}-footer`, o);
  return /* @__PURE__ */ tr.createElement("div", pp({
    className: c
  }, l), /* @__PURE__ */ tr.createElement("div", {
    className: r && `${r}-footer-content`
  }, a), i && /* @__PURE__ */ tr.createElement("div", {
    className: r && `${r}-footer-extra`
  }, i));
}
var _p = Object.defineProperty, br = Object.getOwnPropertySymbols, mi = Object.prototype.hasOwnProperty, di = Object.prototype.propertyIsEnumerable, na = (t, e, r) => e in t ? _p(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, up = (t, e) => {
  for (var r in e || (e = {}))
    mi.call(e, r) && na(t, r, e[r]);
  if (br)
    for (var r of br(e))
      di.call(e, r) && na(t, r, e[r]);
  return t;
}, yp = (t, e) => {
  var r = {};
  for (var a in t)
    mi.call(t, a) && e.indexOf(a) < 0 && (r[a] = t[a]);
  if (t != null && br)
    for (var a of br(t))
      e.indexOf(a) < 0 && di.call(t, a) && (r[a] = t[a]);
  return r;
};
function hp(t) {
  const e = t, {
    prefixCls: r,
    className: a,
    title: o,
    thumb: i,
    thumbStyle: l,
    extra: c
  } = e, s = yp(e, [
    "prefixCls",
    "className",
    "title",
    "thumb",
    "thumbStyle",
    "extra"
  ]);
  return /* @__PURE__ */ n.createElement("div", up({
    className: "flex items-center H4-SemiBold px-16 pb-12 pt-20"
  }, s), /* @__PURE__ */ n.createElement("div", null, typeof i == "string" ? /* @__PURE__ */ n.createElement("img", {
    style: l,
    src: i
  }) : i, o), c ? /* @__PURE__ */ n.createElement("div", null, c) : null);
}
var fp = Object.defineProperty, xr = Object.getOwnPropertySymbols, _i = Object.prototype.hasOwnProperty, ui = Object.prototype.propertyIsEnumerable, aa = (t, e, r) => e in t ? fp(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, vp = (t, e) => {
  for (var r in e || (e = {}))
    _i.call(e, r) && aa(t, r, e[r]);
  if (xr)
    for (var r of xr(e))
      ui.call(e, r) && aa(t, r, e[r]);
  return t;
}, gp = (t, e) => {
  var r = {};
  for (var a in t)
    _i.call(t, a) && e.indexOf(a) < 0 && (r[a] = t[a]);
  if (t != null && xr)
    for (var a of xr(t))
      e.indexOf(a) < 0 && ui.call(t, a) && (r[a] = t[a]);
  return r;
};
class be extends tr.Component {
  render() {
    const e = this.props, { full: r, className: a } = e, o = gp(e, ["full", "className"]);
    return /* @__PURE__ */ tr.createElement("div", vp({
      className: r ? "w-full" : ""
    }, o));
  }
}
be.Header = hp;
be.Body = sp;
be.Footer = dp;
var Ep = Object.defineProperty, Pp = Object.defineProperties, bp = Object.getOwnPropertyDescriptors, Mr = Object.getOwnPropertySymbols, yi = Object.prototype.hasOwnProperty, hi = Object.prototype.propertyIsEnumerable, oa = (t, e, r) => e in t ? Ep(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, xp = (t, e) => {
  for (var r in e || (e = {}))
    yi.call(e, r) && oa(t, r, e[r]);
  if (Mr)
    for (var r of Mr(e))
      hi.call(e, r) && oa(t, r, e[r]);
  return t;
}, Mp = (t, e) => Pp(t, bp(e)), Op = (t, e) => {
  var r = {};
  for (var a in t)
    yi.call(t, a) && e.indexOf(a) < 0 && (r[a] = t[a]);
  if (t != null && Mr)
    for (var a of Mr(t))
      e.indexOf(a) < 0 && hi.call(t, a) && (r[a] = t[a]);
  return r;
};
const Cp = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAzMiAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC4yNSIgeT0iMC4yNSIgd2lkdGg9IjMxLjUiIGhlaWdodD0iMTkuNSIgcng9IjEuNzUiIHN0cm9rZT0iIzE2MTgyMyIgc3Ryb2tlLW9wYWNpdHk9IjAuMTIiIHN0cm9rZS13aWR0aD0iMC41Ii8+CjxnIG9wYWNpdHk9IjAuMzQiPgo8cmVjdCB4PSI3IiB5PSI0IiB3aWR0aD0iMTgiIGhlaWdodD0iMTIiIHJ4PSIxIiBzdHJva2U9IiMxNjE4MjMiIHN0cm9rZS13aWR0aD0iMS41Ii8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjUgNy41SDdWOUgyNVY3LjVaTTIyIDExLjVIMThWMTNIMjJWMTEuNVoiIGZpbGw9IiMxNjE4MjMiLz4KPC9nPgo8L3N2Zz4K", Cn = (t) => {
  const e = t, { src: r, alt: a, backupUrl: o } = e, i = Op(e, ["src", "alt", "backupUrl"]), l = (c) => {
    const s = c.target, p = o || Cp;
    s && p && s.setAttribute("src", p);
  };
  return /* @__PURE__ */ n.createElement("img", Mp(xp({}, i), {
    src: r,
    alt: a,
    onError: l
  }));
}, fi = (t) => {
  var e, r, a, o;
  const { t: i, isFlip: l } = I.useContext(), { data: c } = t, { paymentMethodInfo: s, config: p, complicated: _ } = c, { bankId: m, paymentMethodId: d } = s, { holderName: f } = _, g = m ? ((e = un[m || ""]) == null ? void 0 : e.i18nKey) || ((r = gr[m || ""]) == null ? void 0 : r.i18nKey) : or[d].paymentMethod.starling_key, h = m ? ((a = un[m || ""]) == null ? void 0 : a.icon.iconUrl) || ((o = gr[m || ""]) == null ? void 0 : o.icon.iconUrl) : or[d].paymentMethod.icon.iconUrl;
  return /* @__PURE__ */ n.createElement(be, {
    full: !0
  }, (p == null ? void 0 : p.paymentInfoTitle) && /* @__PURE__ */ n.createElement(be.Header, {
    title: p.paymentInfoTitle
  }), /* @__PURE__ */ n.createElement(be.Body, null, /* @__PURE__ */ n.createElement("div", {
    className: "flex items-end"
  }, h && /* @__PURE__ */ n.createElement(Cn, {
    className: `w-32 h-20 ${l ? "ml-12" : "mr-12"}`,
    src: h
  }), /* @__PURE__ */ n.createElement("span", null, i(g)))), f && /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(be.Header, {
    title: i("pipo_common_payin_boleto_name")
  }), /* @__PURE__ */ n.createElement(be.Body, null, /* @__PURE__ */ n.createElement("div", {
    className: "flex items-end"
  }, /* @__PURE__ */ n.createElement("span", null, f)))));
}, vi = (t) => {
  const { t: e } = I.useContext(), {
    isExpired: r,
    onCopyCode: a,
    status: o,
    data: i,
    onSendEvent: l,
    simpleExtra: c = !1
  } = t, { type: s, simple: p, complicated: _, config: m } = i, d = Ne(
    (g) => {
      if (!p.hasCopyButton)
        return;
      const h = "H4-Regular flex items-center justify-center h-48";
      return g === "success" ? /* @__PURE__ */ n.createElement("div", {
        className: h,
        style: { opacity: 0.95 }
      }, e("pipo_payin_paymentcode_waitingforpayment_copynumber_success")) : r ? /* @__PURE__ */ n.createElement("div", {
        className: h,
        style: { opacity: 0.95 }
      }, e("pipo_payin_paymentcode_waitingforpayment_copynumber_fail")) : /* @__PURE__ */ n.createElement("div", {
        className: h,
        style: { opacity: 0.95 },
        onClick: a
      }, /* @__PURE__ */ n.createElement(Zl, {
        style: { margin: "0 8px" }
      }), e(c ? "pipo_payin_state_cashier_title_copyacct" : "pipo_payin_paymentcode_waitingforpayment_copynumber_wait"));
    },
    [a, r, l, p.hasCopyButton]
  ), f = r || o === "failed";
  return /* @__PURE__ */ n.createElement(be, {
    full: !0
  }, /* @__PURE__ */ n.createElement(be.Header, {
    title: m.codeTitle
  }), /* @__PURE__ */ n.createElement(be.Body, null, /* @__PURE__ */ n.createElement("div", {
    className: ae(
      "flex-1 px-16 pt-16 rounded-8 text-center background-color-ConstBGInverse text-color-ConstTextInverse",
      {
        "background-color-BGInput2": f,
        "background-color-ConstBGInverse": o === "success"
      }
    ),
    style: { maxHeight: 144 }
  }, (s === "simple" || c) && /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", {
    className: "H1-SemiBold text-center mt-20 h-20"
  }, p.formatCode || _.formatPaymentCode), /* @__PURE__ */ n.createElement("div", {
    className: "h-32"
  }), /* @__PURE__ */ n.createElement(fe, null), d(o)), s === "complicated" && /* @__PURE__ */ n.createElement("div", {
    className: "pt-20",
    style: { paddingBottom: 36 }
  }, _.formatCustomerNo && /* @__PURE__ */ n.createElement("div", {
    className: "flex justify-between content-center mb-16"
  }, /* @__PURE__ */ n.createElement("span", {
    className: "P1-Regular"
  }, e("pipo_common_payin_customernumber")), /* @__PURE__ */ n.createElement("span", {
    className: "H2-SemiBold"
  }, _.formatCustomerNo)), _.formatPaymentCode && /* @__PURE__ */ n.createElement("div", {
    className: "flex justify-between content-center"
  }, /* @__PURE__ */ n.createElement("span", {
    className: "P1-Regular"
  }, e("pipo_common_payin_paymentcode")), /* @__PURE__ */ n.createElement("span", {
    className: "H2-SemiBold"
  }, _.formatPaymentCode))))));
}, la = /\{[0-9a-zA-Z]+\}/, an = (t) => {
  const { number: e, unit: r, last: a = !1 } = t;
  if (e === "00" || e === "0")
    return "";
  const o = a ? "" : " ";
  let i = e;
  return e.startsWith("0") && (i = e.substring(1)), `${i}${r}${o}`;
}, Ht = (t) => {
  const { t: e, isFlip: r } = I.useContext(), {
    amount: a,
    orderStatus: o,
    expirationTime: i = "",
    onTimeUp: l,
    orderAmount: c,
    transactionAmount: s,
    totalAmount: p
  } = t, _ = ys({
    expirationTime: i,
    onTimeUp: l
  }), { hours: m = "", minutes: d = "", seconds: f = "" } = _, g = () => {
    switch (o) {
      case "init":
        return {
          icon: /* @__PURE__ */ n.createElement(Is, {
            size: 20,
            color: "TextPrimary"
          }),
          title: e("pipo_payin_paymentcode_paymentstatu_waitingforpayment"),
          subTitle: e("pipo_payin_paymentcode_subtitle_waitingforpayment")
        };
      case "success":
        return {
          icon: /* @__PURE__ */ n.createElement(Ts, {
            size: 20,
            color: "Positive"
          }),
          title: e("pipo_payin_paymentcode_paymentstatu_success"),
          subTitle: e("pipo_payin_paymentcode_subtitle_success")
        };
      case "expired":
        return {
          icon: /* @__PURE__ */ n.createElement(ks, {
            size: 20,
            color: "Negative"
          }),
          title: e("pipo_payin_paymentcode_paymentstatu_expired"),
          subTitle: e("pipo_payin_paymentcode_subtitle_expired")
        };
      case "failed":
      case "closed":
        return {
          icon: /* @__PURE__ */ n.createElement(Js, {
            fontSize: "20",
            color: "#FE2C55"
          }),
          title: e("pipo_payin_paymentcode_paymentstatu_failed"),
          subTitle: e("pipo_payin_paymentcode_subtitle_failed")
        };
      default:
        return {};
    }
  }, { icon: h, title: y, subTitle: u = "" } = g(), v = /* @__PURE__ */ n.createElement("div", {
    className: `flex items-center ${r ? "ml-8" : "mr-8"}`
  }, h, /* @__PURE__ */ n.createElement("div", {
    className: "H3-SemiBold ml-8 text-color-TextPrimary"
  }, y)), P = /* @__PURE__ */ n.createElement("div", {
    className: "mt-16"
  }, c && /* @__PURE__ */ n.createElement("div", {
    className: "mb-6"
  }, /* @__PURE__ */ n.createElement("span", {
    className: "P2-Regular text-color-TextTertiary"
  }, e("pipo_payin_order_summary")), /* @__PURE__ */ n.createElement("span", {
    className: "P2-Regular text-color-TextSecondary ml-6"
  }, c)), s && /* @__PURE__ */ n.createElement("div", {
    className: "mb-6"
  }, /* @__PURE__ */ n.createElement("span", {
    className: "P2-Regular text-color-TextTertiary"
  }, e("pipo_common_payin_transactionfee")), /* @__PURE__ */ n.createElement("span", {
    className: "P2-Regular text-color-TextSecondary ml-6"
  }, s)), /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("span", {
    className: "P2-Regular text-color-TextTertiary"
  }, e("pipo_payin_total_amount")), /* @__PURE__ */ n.createElement("span", {
    className: "P2-Regular text-color-TextSecondary ml-6"
  }, p || a))), $ = m === "0" && d === "00" ? `${an({ number: f, unit: "s", last: !0 })}` : `${an({ number: m, unit: "h" })}${an({
    number: d,
    unit: "m"
  })}`, x = o === "init" && la.exec(u), [N, C] = u.split(la), M = x ? /* @__PURE__ */ n.createElement("div", {
    className: "mt-6"
  }, /* @__PURE__ */ n.createElement("span", {
    className: "P2-Regular text-color-TextTertiary"
  }, N), /* @__PURE__ */ n.createElement("span", {
    className: "text-color-Primary mx-2"
  }, $), /* @__PURE__ */ n.createElement("span", {
    className: "P2-Regular text-color-TextTertiary"
  }, C)) : /* @__PURE__ */ n.createElement("div", {
    className: "mt-6"
  }, /* @__PURE__ */ n.createElement("span", {
    className: "P2-Regular text-color-TextTertiary"
  }, u));
  return /* @__PURE__ */ n.createElement("div", {
    className: "background-color-BGView px-16 py-20"
  }, v, P, M);
}, wp = () => {
  const { t } = I.useContext(), e = t("pipo_payin_paymentcode_remind"), r = Fl(e);
  return /* @__PURE__ */ n.createElement("div", {
    className: "px-16 mb-8 P2-Regular text-color-TextPrimary",
    dangerouslySetInnerHTML: {
      __html: r
    }
  });
}, $p = (t) => {
  const { children: e, header: r, icon: a, onExpand: o } = t, i = {
    right: /* @__PURE__ */ n.createElement(Ns, {
      color: "TextTertiary",
      size: 20
    }),
    phone: /* @__PURE__ */ n.createElement(Bs, {
      color: "TextTertiary",
      size: 20
    }),
    bank: /* @__PURE__ */ n.createElement(Ds, {
      color: "TextTertiary",
      size: 20
    })
  }, [l, c] = R(!1), s = () => {
    const _ = !l;
    c(_), o && o(_);
  }, { isFlip: p } = I.useContext();
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", {
    className: "flex items-center justify-between py-16",
    onClick: s
  }, /* @__PURE__ */ n.createElement("div", {
    className: "flex items-center"
  }, a && /* @__PURE__ */ n.createElement("div", {
    className: p ? "ml-8" : "mr-8"
  }, i[a]), /* @__PURE__ */ n.createElement("span", {
    className: "mt-4"
  }, r)), /* @__PURE__ */ n.createElement("div", {
    className: "flex items-center justify-center",
    style: {
      transform: `rotateZ(${l ? "180deg" : "0"})`,
      transition: "all 0.3s"
    }
  }, /* @__PURE__ */ n.createElement(jr, null))), l && e, /* @__PURE__ */ n.createElement(fe, null));
}, Sp = "pipo_payin_paymentcode", kp = (t) => {
  if (!t)
    return null;
  const e = Fl(t), r = e == null ? void 0 : e.replace(/\/\/\//g, "");
  return /* @__PURE__ */ n.createElement("p", {
    key: t,
    dangerouslySetInnerHTML: { __html: r },
    className: "mb-6"
  });
}, ia = (t) => {
  const e = t == null ? void 0 : t.replace(/\\n[\r\n]?/g, "///");
  return e == null ? void 0 : e.split("///").map(kp);
}, wn = (t) => {
  const { paymentMethodInfo: e, onSendEvent: r, platform: a, method: o } = t, {
    bankId: i,
    paymentMethodId: l,
    paymentMethodType: c
  } = e, { t: s } = I.useContext(), p = s("pipo_payin_paymentcode_howtomakepayment"), _ = or[l].paymentMethod.paymentMethod, m = o || (i ? c : _), d = i ? `${i}_` : `${_ == null ? void 0 : _.toLowerCase()}_`, f = (h) => {
    r && r({
      name: "fp_sdk_checkout_payment_code_click",
      categories: {
        click_method: h ? "expand_guide" : "hide_guid",
        pi_type_1: e.paymentMethodType,
        pi_type_2: e.paymentMethod,
        pi_type_3: e.bankId || "",
        pm_id: e.paymentMethodId
      }
    });
  }, g = Ne(
    () => {
      try {
        if (!m)
          return m;
        const h = Ar[m].methods.filter(
          (y) => y.platform === a || !y.platform
        );
        return h == null ? void 0 : h.map((y, u) => {
          const v = `${Sp}_${d}${y.contentStarlingKey}`, P = s(v);
          if (P) {
            if (Ar[m].collapsable) {
              const $ = y.starlingKey ? s(y.starlingKey) : "";
              return /* @__PURE__ */ n.createElement($p, {
                key: u,
                header: $,
                icon: y.mobileIcon,
                onExpand: f
              }, ia(P));
            }
            return /* @__PURE__ */ n.createElement("div", {
              className: "pipo-mobile-collapse-content"
            }, ia(P));
          }
          return null;
        });
      } catch (h) {
        console.log(h);
      }
      return "";
    },
    [m, d, s, f]
  );
  return /* @__PURE__ */ n.createElement("div", null, m && Ar[m] && /* @__PURE__ */ n.createElement(be, {
    full: !0
  }, /* @__PURE__ */ n.createElement(be.Header, {
    title: p
  }), /* @__PURE__ */ n.createElement(be.Body, null, g())));
}, Tp = (t) => {
  const { onCopyCode: e, shopperDetails: r, onClickPaymentLink: a } = t, { t: o } = I.useContext();
  return /* @__PURE__ */ n.createElement("div", {
    className: "text-color-TextPrimary H4-semibold"
  }, /* @__PURE__ */ n.createElement("div", {
    className: "flex items-center py-12 pl-16"
  }, /* @__PURE__ */ n.createElement("span", null, o("pipo_common_payin_boleto_code"))), /* @__PURE__ */ n.createElement("div", {
    className: "flex items-end px-16 pb-8 H4-Regular"
  }, /* @__PURE__ */ n.createElement("div", {
    style: { width: "100%" }
  }, /* @__PURE__ */ n.createElement("img", {
    className: "w-full",
    style: { height: "34px" },
    src: r == null ? void 0 : r.bar_code,
    alt: "barcode"
  }), /* @__PURE__ */ n.createElement("div", {
    className: "P1-bold text-center mt-8 truncate",
    style: {
      letterSpacing: "0.04em",
      height: "34px",
      direction: "ltr"
    }
  }, r == null ? void 0 : r.payment_code))), /* @__PURE__ */ n.createElement("div", {
    className: "flex justify-between mt-20"
  }, /* @__PURE__ */ n.createElement("div", {
    className: "background-color-BGPrimary",
    style: { flexBasis: "48%" }
  }, /* @__PURE__ */ n.createElement(St, {
    variant: "secondary",
    onClick: e,
    text: o("pipo_common_payin_boleto_copy")
  })), /* @__PURE__ */ n.createElement("div", {
    className: "background-color-BGPrimary",
    style: { flexBasis: "48%" }
  }, /* @__PURE__ */ n.createElement(St, {
    variant: "secondary",
    onClick: a,
    text: o("pipo_common_payin_boleto_link")
  }))));
}, gi = (t) => {
  const { onCopyCode: e, shopperDetails: r, onDownloadQRCode: a } = t, { t: o } = I.useContext();
  return /* @__PURE__ */ n.createElement("div", {
    className: "text-color-TextPrimary H4-semibold"
  }, /* @__PURE__ */ n.createElement("div", {
    className: "flex items-center py-12 pl-16"
  }, /* @__PURE__ */ n.createElement("span", null, o("pipo_common_payin_boleto_code"))), /* @__PURE__ */ n.createElement("div", {
    className: "flex items-end px-16 pb-8 H4-Regular"
  }, /* @__PURE__ */ n.createElement("div", {
    style: { width: "100%" }
  }, /* @__PURE__ */ n.createElement("div", {
    className: "text-center"
  }, /* @__PURE__ */ n.createElement("img", {
    style: { width: 247 },
    src: r == null ? void 0 : r.qr_code,
    alt: "qrcode"
  }), /* @__PURE__ */ n.createElement("div", {
    className: "P1-bold text-center m-auto mt-8 overflow-ellipsis",
    style: {
      letterSpacing: "0.04em",
      overflow: "hidden",
      width: "247px",
      height: "34px",
      direction: "ltr"
    }
  }, r == null ? void 0 : r.payment_code)), /* @__PURE__ */ n.createElement("div", {
    className: "mt-24"
  }, /* @__PURE__ */ n.createElement("div", {
    className: "background-color-BGPrimary"
  }, e ? /* @__PURE__ */ n.createElement(St, {
    variant: "secondary",
    onClick: e,
    text: o("pipo_payin_copyPixcode") || "Copy Pix Code"
  }) : /* @__PURE__ */ n.createElement(St, {
    variant: "secondary",
    onClick: () => {
      a && a(r == null ? void 0 : r.qr_code);
    },
    text: o("pipo_payin_paymentcode_button_download") || "Download the QRcode"
  }))))));
}, Ip = (t) => {
  const { instructionUrl: e, paymentMethodInfo: r, onSendEvent: a } = t, { t: o } = I.useContext();
  return /* @__PURE__ */ n.createElement("div", null, e && /* @__PURE__ */ n.createElement("div", {
    className: "pt-12 pb-12 pl-16 pr-16"
  }, /* @__PURE__ */ n.createElement(St, {
    onClick: () => {
      a && a({
        name: "fp_sdk_checkout_payment_code_click",
        categories: {
          click_method: "read_instruction",
          pi_type_1: r.paymentMethodType,
          pi_type_2: r.paymentMethod,
          pi_type_3: r.bankId || "",
          pm_id: r.paymentMethodId
        }
      }), window.location.href = e;
    },
    text: o("pipo_common_payin_instruction")
  })));
}, Np = (t) => {
  const { t: e } = I.useContext(), {
    shopperDetails: r,
    status: a,
    isExpired: o,
    onCopyCode: i,
    onSendEvent: l,
    onCopyBankIban: c,
    userIban: s
  } = t, [p, _] = R("");
  j(() => {
    _(vn(r == null ? void 0 : r.iban, Al));
  }, [r]);
  const m = Ne(
    (f, g, h) => {
      const y = "H4-Regular flex items-center justify-center h-48";
      return f === "success" ? /* @__PURE__ */ n.createElement("div", {
        className: y,
        style: { opacity: 0.95 }
      }, e("pipo_payin_paymentcode_waitingforpayment_copynumber_success")) : o ? /* @__PURE__ */ n.createElement("div", {
        className: y,
        style: { opacity: 0.95 }
      }, e("pipo_payin_paymentcode_waitingforpayment_copynumber_fail")) : /* @__PURE__ */ n.createElement("div", {
        className: y,
        style: { opacity: 0.95 },
        onClick: g
      }, /* @__PURE__ */ n.createElement(Zl, {
        style: { margin: "0 8px" }
      }), h);
    },
    [i, o, l, c]
  ), d = o || a === "failed";
  return /* @__PURE__ */ n.createElement(be, {
    full: !0
  }, /* @__PURE__ */ n.createElement(be.Header, {
    title: e("pipo_common_payin_referencecode")
  }), /* @__PURE__ */ n.createElement(be.Body, null, /* @__PURE__ */ n.createElement("div", {
    className: ae(
      "flex-1 px-16 pt-16 rounded-8 text-center background-color-ConstBGInverse text-color-ConstTextInverse",
      {
        "background-color-BGInput2": d,
        "background-color-ConstBGInverse": a === "success"
      }
    ),
    style: { maxHeight: 144 }
  }, /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", {
    className: "H1-SemiBold text-center mt-20 h-20"
  }, r == null ? void 0 : r.payment_code), /* @__PURE__ */ n.createElement("div", {
    className: "h-32"
  }), /* @__PURE__ */ n.createElement(lr, {
    color: "ConstLineInverse",
    direction: "horizontal"
  }), m(
    a,
    i,
    e("pipo_payin_instruction_copy") + " " + e("pipo_common_payin_referencecode")
  )))), /* @__PURE__ */ n.createElement(be.Header, {
    title: e("pipo_payin_state_payment_result_Birlesik_Odeme_bankiban")
  }), /* @__PURE__ */ n.createElement(be.Body, null, /* @__PURE__ */ n.createElement("div", {
    className: ae(
      "flex-1 px-16 pt-16 rounded-8 text-center background-color-ConstBGInverse text-color-ConstTextInverse",
      {
        "background-color-BGInput2": d,
        "background-color-ConstBGInverse": a === "success"
      }
    ),
    style: { maxHeight: 144 }
  }, /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", {
    className: "H2-SemiBold text-center mt-20 h-20"
  }, r == null ? void 0 : r.iban), /* @__PURE__ */ n.createElement("div", {
    className: "h-32"
  }), /* @__PURE__ */ n.createElement(lr, {
    color: "ConstLineInverse",
    direction: "horizontal"
  }), m(
    a,
    c,
    e("pipo_payin_instruction_copy") + " " + e("pipo_payin_state_payment_result_Birlesik_Odeme_bankiban")
  )))), /* @__PURE__ */ n.createElement("div", {
    className: "text-color-TextPrimary H4-semibold"
  }, /* @__PURE__ */ n.createElement("div", {
    className: "flex items-center px-16 py-12 text-color-TextPrimary H4-semibold"
  }, /* @__PURE__ */ n.createElement("span", null, e("pipo_payin_state_payment_result_Birlesik_Odeme_useriban"))), /* @__PURE__ */ n.createElement("div", {
    className: "flex items-end px-16 pb-8 P1-Bold"
  }, /* @__PURE__ */ n.createElement("div", {
    style: { width: "100%" }
  }, /* @__PURE__ */ n.createElement("img", {
    style: {
      height: "34px",
      verticalAlign: "middle",
      marginRight: "20px"
    },
    src: p,
    alt: "bankLogo"
  }), /* @__PURE__ */ n.createElement("span", {
    className: "P1-Bold text-center truncate",
    style: {
      letterSpacing: "0.04em",
      height: "34px",
      lineHeight: "34px",
      direction: "ltr"
    }
  }, s)))));
};
var Bp = Object.defineProperty, sa = Object.getOwnPropertySymbols, Dp = Object.prototype.hasOwnProperty, Vp = Object.prototype.propertyIsEnumerable, ca = (t, e, r) => e in t ? Bp(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, xt = (t, e) => {
  for (var r in e || (e = {}))
    Dp.call(e, r) && ca(t, r, e[r]);
  if (sa)
    for (var r of sa(e))
      Vp.call(e, r) && ca(t, r, e[r]);
  return t;
};
const jp = ({
  paymentDetail: t,
  onQueryOrder: e,
  onSendEvent: r
}) => {
  var a;
  const o = (a = t.payment_method_info) == null ? void 0 : a.payment_method_id, { isFlip: i, theme: l, t: c } = I.useContext(), s = () => {
    Hs.success(c("pipo_payin_state_paymentdetail_status_copied"));
  }, { defaultVoucherProps: p } = hs(
    t,
    e,
    r,
    s
  ), { state: _ } = I.useContext(), { countryOrRegion: m } = _;
  j(
    () => {
      const f = p.paymentDetail.payment_method_info, g = p.paymentDetail.present_to_shopper_details;
      r == null || r({
        name: "fp_sdk_checkout_payment_code_show",
        categories: {
          pi_type_1: (f == null ? void 0 : f.payment_method_type) || "",
          pi_type_2: (f == null ? void 0 : f.payment_method) || "",
          pi_type_3: (g == null ? void 0 : g.bank_code) || "",
          pm_id: (f == null ? void 0 : f.payment_method_id) || ""
        }
      });
    },
    []
  );
  const d = () => {
    switch (o) {
      case "pm_pi_cp_boleto_c_d":
        return /* @__PURE__ */ n.createElement(Lp, xt({}, p));
      case "pm_pi_bap_pix_c_d":
        return /* @__PURE__ */ n.createElement(Rp, xt({}, p));
      case "pm_pi_bap_promptpay_c_r":
        return /* @__PURE__ */ n.createElement(Fp, xt({}, p));
      case "pm_pi_bt_banktransfer_c_d":
        switch (m) {
          case "TR":
            return /* @__PURE__ */ n.createElement(Ap, xt({}, p));
        }
        return /* @__PURE__ */ n.createElement(pa, xt({}, p));
      case "pm_pi_bt_banktransfertoss_c_d":
        return /* @__PURE__ */ n.createElement(Hp, xt({}, p));
      default:
        return /* @__PURE__ */ n.createElement(pa, xt({}, p));
    }
  };
  return /* @__PURE__ */ n.createElement("div", {
    className: "pipo-mobile"
  }, /* @__PURE__ */ n.createElement(As, {
    dir: i ? "rtl" : "ltr",
    theme: l
  }, /* @__PURE__ */ n.createElement(d, null)));
}, pa = (t) => {
  var e, r;
  const {
    amount: a,
    expired: o,
    status: i,
    formatCode: l,
    payment_method_info: c,
    present_to_shopper_details: s,
    currency: p,
    charge_details: _
  } = t.paymentDetail, { payment_method_id: m } = c, { store_code: d } = s, f = t.paymentDetail.pay_expiration_time || t.paymentDetail.expiration_time, { onExpire: g, onCopyCode: h, onSendEvent: y } = t, u = Vr({
    formatCode: l,
    amount: a,
    currency: p,
    paymentMethodId: m,
    shopperDetails: s,
    chargeDetails: _
  }), { isFlip: v, state: P } = I.useContext(), { config: $ = {} } = P, { showReminder: x = !1 } = $, [N, C] = R("init");
  return j(() => {
    C(t.paymentDetail.orderStatus);
  }, [t.paymentDetail.orderStatus]), /* @__PURE__ */ n.createElement("div", {
    className: "pipo-mobile-payment-code h-full w-full relative",
    style: { direction: v ? "rtl" : "ltr" }
  }, /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(Ht, {
    orderStatus: N,
    expirationTime: f,
    amount: a,
    onTimeUp: g,
    orderAmount: (e = u.complicated) == null ? void 0 : e.formatOrderFee,
    transactionAmount: (r = u.complicated) == null ? void 0 : r.formatTransactionFee,
    totalAmount: u.complicated.formatTotalFee
  }), /* @__PURE__ */ n.createElement(vi, {
    isExpired: i === "closed" || i === "expired" || o,
    status: i,
    onCopyCode: h,
    data: u,
    onSendEvent: y
  }), x && /* @__PURE__ */ n.createElement(wp, null), /* @__PURE__ */ n.createElement(fi, {
    data: u
  }), /* @__PURE__ */ n.createElement(wn, {
    paymentMethodInfo: u.paymentMethodInfo,
    storeCode: d,
    onSendEvent: y
  }), /* @__PURE__ */ n.createElement("div", {
    className: "w-full absolute",
    style: { bottom: 0 }
  }, /* @__PURE__ */ n.createElement(Ip, {
    instructionUrl: u.instructionUrl,
    paymentMethodInfo: u.paymentMethodInfo,
    onSendEvent: y
  }))));
}, Lp = (t) => {
  const {
    amount: e,
    expired: r,
    status: a,
    present_to_shopper_details: o
  } = t.paymentDetail, i = t.paymentDetail.pay_expiration_time || t.paymentDetail.expiration_time, { onExpire: l, onCopyCode: c, onClickPaymentLink: s } = t, [p, _] = R("init");
  j(() => {
    _(t.paymentDetail.orderStatus);
  }, [t.paymentDetail.orderStatus]);
  const { isFlip: m } = I.useContext();
  return /* @__PURE__ */ n.createElement("div", {
    className: "pipo-mobile-payment-code",
    style: { direction: m ? "rtl" : "ltr" }
  }, /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(Ht, {
    orderStatus: p,
    expirationTime: i,
    amount: e,
    onTimeUp: l
  }), /* @__PURE__ */ n.createElement(Tp, {
    isExpired: a === "closed" || a === "expired" || r,
    status: a,
    onCopyCode: c,
    shopperDetails: o,
    onClickPaymentLink: s
  })));
}, Rp = (t) => {
  const {
    amount: e,
    expired: r,
    status: a,
    present_to_shopper_details: o
  } = t.paymentDetail, i = t.paymentDetail.pay_expiration_time || t.paymentDetail.expiration_time, { onExpire: l, onCopyCode: c, onClickPaymentLink: s } = t, [p, _] = R("init");
  return j(() => {
    _(t.paymentDetail.orderStatus);
  }, [t.paymentDetail.orderStatus]), /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(Ht, {
    orderStatus: p,
    expirationTime: i,
    amount: e,
    onTimeUp: l
  }), /* @__PURE__ */ n.createElement(gi, {
    isExpired: a === "closed" || a === "expired" || r,
    status: a,
    onCopyCode: c,
    shopperDetails: o,
    onClickPaymentLink: s
  }));
}, Fp = (t) => {
  const {
    amount: e,
    expired: r,
    status: a,
    present_to_shopper_details: o,
    payment_method_info: i,
    formatCode: l,
    currency: c,
    charge_details: s
  } = t.paymentDetail, { payment_method_id: p } = i, _ = t.paymentDetail.pay_expiration_time || t.paymentDetail.expiration_time, m = Vr({
    formatCode: l,
    amount: e,
    currency: c,
    paymentMethodId: p,
    shopperDetails: o,
    chargeDetails: s
  }), { onExpire: d, onClickPaymentLink: f, onDownloadQRCode: g, onSendEvent: h } = t, [y, u] = R("init");
  return j(() => {
    u(t.paymentDetail.orderStatus);
  }, [t.paymentDetail.orderStatus]), /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(Ht, {
    orderStatus: y,
    expirationTime: _,
    amount: e,
    onTimeUp: d
  }), /* @__PURE__ */ n.createElement(gi, {
    isExpired: a === "closed" || a === "expired" || r,
    status: a,
    shopperDetails: o,
    onClickPaymentLink: f,
    onDownloadQRCode: g
  }), /* @__PURE__ */ n.createElement(wn, {
    paymentMethodInfo: m.paymentMethodInfo,
    onSendEvent: h,
    platform: "mobile"
  }));
};
function Ap(t) {
  const {
    amount: e,
    formatCode: r,
    payment_method_info: a,
    present_to_shopper_details: o,
    currency: i,
    status: l,
    expired: c,
    userIban: s,
    charge_details: p
  } = t.paymentDetail, { payment_method_id: _ } = a, m = t.paymentDetail.pay_expiration_time || t.paymentDetail.expiration_time, d = Vr({
    amount: e,
    currency: i,
    formatCode: r,
    paymentMethodId: _,
    shopperDetails: o,
    chargeDetails: p
  }), { onExpire: f, onCopyCode: g, onSendEvent: h, onCopyBankIban: y } = t, [u, v] = R("init"), { isFlip: P } = I.useContext();
  return j(() => {
    v(t.paymentDetail.orderStatus);
  }, [t.paymentDetail.orderStatus]), /* @__PURE__ */ n.createElement("div", {
    className: "pipo-mobile-payment-code h-full w-full relative",
    style: { direction: P ? "rtl" : "ltr" }
  }, /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(Ht, {
    orderStatus: u,
    expirationTime: m,
    amount: e,
    onTimeUp: f
  }), /* @__PURE__ */ n.createElement(Np, {
    isExpired: l === "closed" || l === "expired" || c,
    status: l,
    shopperDetails: o,
    onCopyCode: g,
    onSendEvent: h,
    onCopyBankIban: y,
    userIban: s
  }), /* @__PURE__ */ n.createElement(wn, {
    paymentMethodInfo: d.paymentMethodInfo,
    onSendEvent: h,
    method: "BOBANKTRANSFER"
  })));
}
const Hp = (t) => {
  var e, r;
  const {
    amount: a,
    expired: o,
    status: i,
    formatCode: l,
    payment_method_info: c,
    present_to_shopper_details: s,
    currency: p,
    charge_details: _
  } = t.paymentDetail, { payment_method_id: m } = c, d = t.paymentDetail.pay_expiration_time || t.paymentDetail.expiration_time, { onExpire: f, onCopyCode: g, onSendEvent: h } = t, y = Vr({
    formatCode: l,
    amount: a,
    currency: p,
    paymentMethodId: m,
    shopperDetails: s,
    chargeDetails: _
  }), { isFlip: u } = I.useContext(), [v, P] = R("init");
  return j(() => {
    P(t.paymentDetail.orderStatus);
  }, [t.paymentDetail.orderStatus]), /* @__PURE__ */ n.createElement("div", {
    className: "pipo-mobile-payment-code h-full w-full relative",
    style: { direction: u ? "rtl" : "ltr" }
  }, /* @__PURE__ */ n.createElement(Ht, {
    orderStatus: v,
    expirationTime: d,
    amount: a,
    onTimeUp: f,
    orderAmount: (e = y.complicated) == null ? void 0 : e.formatOrderFee,
    transactionAmount: (r = y.complicated) == null ? void 0 : r.formatTransactionFee,
    totalAmount: y.complicated.formatTotalFee
  }), /* @__PURE__ */ n.createElement(vi, {
    isExpired: i === "closed" || i === "expired" || o,
    status: i,
    onCopyCode: g,
    data: y,
    onSendEvent: h,
    simpleExtra: !0
  }), /* @__PURE__ */ n.createElement(fi, {
    data: y
  }));
};
var qp = Object.defineProperty, Up = Object.defineProperties, Yp = Object.getOwnPropertyDescriptors, ma = Object.getOwnPropertySymbols, zp = Object.prototype.hasOwnProperty, Xp = Object.prototype.propertyIsEnumerable, da = (t, e, r) => e in t ? qp(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Gp = (t, e) => {
  for (var r in e || (e = {}))
    zp.call(e, r) && da(t, r, e[r]);
  if (ma)
    for (var r of ma(e))
      Xp.call(e, r) && da(t, r, e[r]);
  return t;
}, Kp = (t, e) => Up(t, Yp(e));
const Wp = (t) => {
  const {
    title: e,
    placeholder: r = "",
    error: a,
    errorMessage: o,
    onBlur: i,
    value: l,
    onChange: c
  } = t, { month: s, year: p } = l, { formatExpiryValue: _, handleExpiryDateChange: m } = fs({
    value: l,
    onChange: c
  });
  return j(
    () => {
      c(s, p);
    },
    [s, p]
  ), /* @__PURE__ */ n.createElement("div", {
    "data-sel": "pipo-mobile-comp-expiry-date"
  }, /* @__PURE__ */ n.createElement(We, Kp(Gp({}, t), {
    hasBottomBorder: !0,
    type: "text",
    inputMode: "numeric",
    value: _,
    placeholder: r,
    title: e,
    hasError: Boolean(a),
    errorMessage: o,
    onChange: m,
    hasClearButton: !0,
    onBlur: i
  })));
}, _a = "https://f-p-va.isnssdk.com/pp/7136672003776314", qt = (t) => {
  const { type: e, onRedirectPP: r } = t, { t: a } = I.useContext(), { linkText: o, headText: i, tailText: l } = Yi(), c = (s) => {
    r && (s.preventDefault(), r(_a));
  };
  return /* @__PURE__ */ n.createElement("div", {
    className: "pipo-mobile-pp mt-16"
  }, e === "bind" && /* @__PURE__ */ n.createElement("div", {
    className: "pipo-mobile-pci-description"
  }, /* @__PURE__ */ n.createElement(Zs, {
    className: "mr-2",
    style: { marginBottom: -3 }
  }), /* @__PURE__ */ n.createElement("span", {
    className: "mt-40 P2-Regular text-color-TextQuaternary w-full"
  }, a("pipo_common_payin_pci_compliance"))), /* @__PURE__ */ n.createElement("div", {
    className: "pipo-mobile-privacy-policy mt-12 P2-Regular text-color-TextSecondary w-full"
  }, i, /* @__PURE__ */ n.createElement("a", {
    className: "font-bold",
    onClick: c,
    href: _a
  }, o), l));
}, $n = (t) => {
  const { show: e, title: r, proxyTypeValidator: a, "data-sel": o = "" } = t, { t: i } = I.useContext(), [l, c] = R(!1), [s, p] = Q(t), _ = [
    {
      title: i("pipo_common_payin_individual"),
      value: "individual"
    },
    {
      title: i("pipo_common_payin_company"),
      value: "company"
    }
  ], m = ge(
    () => {
      const d = _.find((f) => f.value === s);
      return a(s) && p(s), (d == null ? void 0 : d.title) || "";
    },
    [s]
  );
  return e ? /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("div", {
    "data-sel": o,
    onClick: () => c(!0)
  }, /* @__PURE__ */ n.createElement(We, {
    value: m,
    title: r
  })), /* @__PURE__ */ n.createElement(qs, {
    title: r,
    value: s,
    isVisible: l,
    options: _,
    onDismiss: () => c(!1),
    onSubmit: (d) => {
      p(d), c(!1);
    }
  })) : /* @__PURE__ */ n.createElement(n.Fragment, null);
}, Jp = (t) => {
  const { text: e } = t;
  return /* @__PURE__ */ n.createElement("div", {
    className: "ml-8 flex box-border justify-center items-center background-color-BGInput text-color-TextTertiary P2-Regular rounded-2",
    style: { padding: "1px 5px" }
  }, e);
}, mt = (t) => {
  const { title: e } = t, { isFlip: r } = I.useContext(), [a, o] = Q(t);
  return /* @__PURE__ */ n.createElement("div", {
    className: "flex items-center mb-12 mt-8 py-16 H4-Regular"
  }, /* @__PURE__ */ n.createElement("div", {
    className: ae("flex items-center", r ? "ml-8" : "mr-8")
  }, /* @__PURE__ */ n.createElement(Us, {
    size: "small",
    checked: a,
    onChange: (i) => o(i.target.checked)
  })), /* @__PURE__ */ n.createElement("div", {
    onClick: () => o(!a)
  }, /* @__PURE__ */ n.createElement("span", {
    className: "text-color-TextPrimary"
  }, e)));
};
var Zp = Object.defineProperty, Qp = Object.defineProperties, em = Object.getOwnPropertyDescriptors, ua = Object.getOwnPropertySymbols, tm = Object.prototype.hasOwnProperty, rm = Object.prototype.propertyIsEnumerable, ya = (t, e, r) => e in t ? Zp(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, nm = (t, e) => {
  for (var r in e || (e = {}))
    tm.call(e, r) && ya(t, r, e[r]);
  if (ua)
    for (var r of ua(e))
      rm.call(e, r) && ya(t, r, e[r]);
  return t;
}, am = (t, e) => Qp(t, em(e));
const Ae = (t) => {
  const { title: e, placeholder: r, error: a, errorMessage: o, footer: i, onBlur: l } = t, [c, s] = Q(t);
  return j(
    () => {
      s(c);
    },
    [c]
  ), /* @__PURE__ */ n.createElement(We, am(nm({}, t), {
    value: c || "",
    onChange: (p) => s(p.target.value),
    hasBottomBorder: !0,
    type: "text",
    placeholder: r,
    title: e,
    hasError: Boolean(a),
    errorMessage: o,
    hasClearButton: !0,
    maxLength: 128,
    footer: i,
    onBlur: l
  }));
}, Je = (t) => {
  var e;
  const { onClick: r, intro: a, disabled: o = !1, isLoading: i } = t, { t: l, state: c } = I.useContext(), s = Boolean((e = c.amount) == null ? void 0 : e.value);
  return /* @__PURE__ */ n.createElement("div", {
    className: "mb-16 pipo-mobile-bind-button"
  }, a && /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement(fe, null), /* @__PURE__ */ n.createElement("p", {
    className: "H4-Regular text-color-TextPrimary text-center my-12"
  }, l("pipo_common_link_ewallet_with_no_info"))), /* @__PURE__ */ n.createElement("div", {
    className: "P2-Regular text-center text-color-TextTertiary pb-8"
  }, l("pipo_common_link_ewallet_with_statement")), /* @__PURE__ */ n.createElement(St, {
    onClick: (p) => {
      p.preventDefault(), r();
    },
    text: l(s ? "pipo_common_link_ewallet_confirm" : "pipo_payin_bind"),
    disabled: o,
    isLoading: i
  }));
};
var om = Object.defineProperty, lm = Object.defineProperties, im = Object.getOwnPropertyDescriptors, ha = Object.getOwnPropertySymbols, sm = Object.prototype.hasOwnProperty, cm = Object.prototype.propertyIsEnumerable, fa = (t, e, r) => e in t ? om(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, pm = (t, e) => {
  for (var r in e || (e = {}))
    sm.call(e, r) && fa(t, r, e[r]);
  if (ha)
    for (var r of ha(e))
      cm.call(e, r) && fa(t, r, e[r]);
  return t;
}, mm = (t, e) => lm(t, im(e));
const Ei = Ft(
  (t, e) => {
    const {
      title: r,
      error: a,
      errorMessage: o,
      onBlur: i,
      placeholder: l,
      bankList: c,
      setDisplayBankIcon: s,
      supportBank: p
    } = t, [_, m] = Q(t), [d, f] = R(""), g = Re(), { isFlip: h } = I.useContext();
    return j(
      () => {
        var y;
        m(_), (y = g.current) == null || y.setInnerValue(jn(_));
      },
      [_]
    ), /* @__PURE__ */ n.createElement(At, mm(pm({}, pr(t, ["error"])), {
      ref: e,
      handleRef: g,
      type: "text",
      hasBottomBorder: !0,
      hasError: Boolean(a),
      errorMessage: o,
      placeholder: l,
      hasClearButton: !0,
      maxLength: 32,
      append: d && /* @__PURE__ */ n.createElement("img", {
        className: "w-32 h-20 mr-2 rounded-2",
        src: d
      }),
      title: /* @__PURE__ */ n.createElement("div", {
        className: "flex justify-between items-center w-full"
      }, /* @__PURE__ */ n.createElement("span", {
        className: h ? "ml-2" : "mr-2"
      }, r), /* @__PURE__ */ n.createElement("div", {
        className: "flex flex-wrap"
      }, c.map((y) => /* @__PURE__ */ n.createElement("img", {
        className: "pipo-mobile-cardbrand-icon ml-2 mr-2 rounded-2",
        key: y,
        src: y
      })))),
      value: _,
      onChange: (y) => {
        m(y.target.value), f(s(y.target.value, p));
      },
      onBlur: i,
      validInput: zi,
      formatValue: jn,
      formatCursor: Xi
    }));
  }
);
var dm = Object.defineProperty, _m = Object.defineProperties, um = Object.getOwnPropertyDescriptors, va = Object.getOwnPropertySymbols, ym = Object.prototype.hasOwnProperty, hm = Object.prototype.propertyIsEnumerable, ga = (t, e, r) => e in t ? dm(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, fm = (t, e) => {
  for (var r in e || (e = {}))
    ym.call(e, r) && ga(t, r, e[r]);
  if (va)
    for (var r of va(e))
      hm.call(e, r) && ga(t, r, e[r]);
  return t;
}, vm = (t, e) => _m(t, um(e));
const Sn = (t) => {
  const { title: e, error: r, errorMessage: a, onBlur: o, placeholder: i } = t, [l, c] = Q(t);
  return j(
    () => {
      c(l);
    },
    [l]
  ), /* @__PURE__ */ n.createElement(We, vm(fm({}, t), {
    hasBottomBorder: !0,
    type: "number",
    value: l || "",
    placeholder: i,
    title: e,
    hasError: Boolean(r),
    errorMessage: a,
    onChange: (s) => c(s.target.value),
    maxLength: 11,
    hasClearButton: !0,
    onBlur: o
  }));
};
function gm(t, e) {
  const r = Re(null), a = Re(0), [o, i] = R(""), l = Ne(
    (m) => {
      var d;
      const f = Number(((d = r.current) == null ? void 0 : d.offsetHeight) || 0) / t.length, g = Math.floor(
        (m - a.current) / f
      );
      return t[g];
    },
    [t]
  ), c = Ne(
    (m) => {
      if (m === o)
        return !1;
      i(m);
      const d = m ? document.getElementById(`${st}-${e}-${m}`) : null;
      d == null || d.scrollIntoView();
    },
    [o]
  ), s = Ne(
    (m) => {
      m.preventDefault(), m.stopPropagation();
      const d = l(m.touches[0].clientY);
      c(d);
    },
    [l, c]
  ), p = Ne(
    (m) => {
      m.preventDefault(), m.stopPropagation();
      const d = l(m.touches[0].clientY);
      c(d);
    },
    [l, c]
  ), _ = Ne((m) => {
    m.preventDefault(), m.stopPropagation(), i("");
  }, []);
  return j(() => {
    const m = r.current;
    if (m)
      return a.current = m.getBoundingClientRect().top, m.addEventListener("touchstart", s), m.addEventListener("touchmove", p, {
        passive: !1
      }), m.addEventListener("touchend", _), () => {
        m.removeEventListener("touchstart", s), m.removeEventListener("touchmove", p), m.removeEventListener("touchend", _);
      };
  }, [r.current, p]), {
    charBarRef: r,
    selectedChar: o
  };
}
const Ea = (t) => {
  const e = [];
  let r = [];
  if (Array.isArray(t) && t.length > 0) {
    const a = oc(t, (i) => {
      const { name: l } = i;
      return l.slice(0, 1).toUpperCase();
    }), o = Object.keys(a).sort();
    r = o, o.forEach((i) => {
      e.push({
        isLabel: !0,
        label: i,
        key: i
      }), a[i].forEach((l) => {
        e.push({
          data: l,
          key: String(l.geoname_id)
        });
      });
    });
  }
  return {
    listData: e,
    navigationData: r
  };
}, Em = (t) => {
  const { options: e, level: r, onChange: a } = t, [o, i] = R(!1), [l, c] = R(!1), [s, p] = R(), _ = ge(() => {
    if (!s)
      return Ea(e);
    const u = e == null ? void 0 : e.filter((v) => {
      var P, $, x, N;
      const C = (s == null ? void 0 : s.toLowerCase()) || "", M = (($ = (P = v.name) == null ? void 0 : P.toString()) == null ? void 0 : $.toLowerCase()) || "", b = ((N = (x = v.code) == null ? void 0 : x.toString()) == null ? void 0 : N.toLowerCase()) || "";
      return b && r === "country" ? M.indexOf(C) >= 0 || b.indexOf(C) >= 0 : M.indexOf(C) >= 0;
    });
    return Ea(u);
  }, [e, s]), m = _.listData.filter((u) => !u.isLabel).map((u) => {
    var v;
    return (v = u.data) == null ? void 0 : v.name;
  }), { isSelected: d, select: f } = Gs(m, {
    isMulti: !1
  }), g = (u) => {
    u == null || u.preventDefault(), i(!1), p("");
  }, h = (u) => {
    f(u), a(u), g();
  }, y = (u) => {
    p(u);
  };
  return {
    renderList: _.listData,
    navigationBarOptions: _.navigationData,
    visible: o,
    select: f,
    showCancelBtn: l,
    searchValue: s,
    setVisible: i,
    onDismissHandler: g,
    isSelected: d,
    setShowCancelBtn: c,
    handleSelect: h,
    handleSearch: y
  };
}, Pm = (t) => {
  const { content: e, checked: r } = t;
  return /* @__PURE__ */ n.createElement("div", {
    className: "box-border",
    style: { top: 0, left: 0, right: 0 }
  }, /* @__PURE__ */ n.createElement("header", {
    className: "flex items-center overflow-hidden relative background-color-BGSecondary",
    role: "navigation",
    style: { height: "52px" }
  }, /* @__PURE__ */ n.createElement("div", {
    className: "inline-flex items-center justify-start flex-1 h-full"
  }, /* @__PURE__ */ n.createElement("button", {
    className: "tux-nav-bar-text-action h-40 p-0 H4-Regular text-color-TextPrimary"
  }, e)), /* @__PURE__ */ n.createElement("div", {
    className: "truncate flex-3 px-4 text-center H3-Bold text-color-TextPrimary",
    style: { lineHeight: "52px" }
  }), /* @__PURE__ */ n.createElement("div", {
    className: "inline-flex items-center justify-end h-full"
  }, /* @__PURE__ */ n.createElement("button", {
    className: "tux-nav-bar-icon-action h-40 w-40 p-0 text-color-TextPrimary flex items-center justify-center"
  }, /* @__PURE__ */ n.createElement(bn, {
    checked: r,
    size: "medium"
  }))), /* @__PURE__ */ n.createElement("div", {
    className: "absolute",
    style: { bottom: 0, left: 0, right: 0 }
  }, /* @__PURE__ */ n.createElement(fe, null))));
}, st = "pipo-mobile-cascader", kn = (t) => {
  const {
    options: e,
    title: r,
    loading: a,
    placeholder: o,
    value: i,
    level: l,
    hasError: c,
    errorMessage: s,
    disabled: p,
    header: _,
    showSearch: m = !0,
    onChange: d
  } = t, { state: f, t: g, isFlip: h } = I.useContext(), { config: y } = f, {
    renderList: u,
    navigationBarOptions: v,
    visible: P,
    select: $,
    showCancelBtn: x,
    searchValue: N,
    setVisible: C,
    onDismissHandler: M,
    isSelected: b,
    setShowCancelBtn: E,
    handleSelect: O,
    handleSearch: T
  } = Em({ options: e, level: l, onChange: d }), { charBarRef: W, selectedChar: re } = gm(
    v,
    l
  ), J = ge(
    () => a ? /* @__PURE__ */ n.createElement(Ys, null) : u.length === 0 ? /* @__PURE__ */ n.createElement("div", {
      className: "flex flex-col items-center justify-center h-full"
    }, /* @__PURE__ */ n.createElement(Qs, null), /* @__PURE__ */ n.createElement("div", {
      className: "H3-SemiBold text-color-TextPrimary pt-20 pb-12"
    }, g("pipo_common_payin_mobile_address_inside7")), /* @__PURE__ */ n.createElement("div", {
      className: "P1-Regular text-color-TextSecondary"
    }, g("pipo_common_payin_mobile_address_inside8"))) : /* @__PURE__ */ n.createElement("div", {
      className: ae(
        `${st}-content-panel-list`,
        `${a ? "" : `${st}-content-panel-list-withBtn`}`
      )
    }, u.map((F, ee) => {
      var pe, _e;
      if (F.isLabel) {
        const { label: G = "" } = F;
        return /* @__PURE__ */ n.createElement("label", {
          id: `${st}-${l}-${G}`,
          className: "block H4-Regular pt-16 pb-8",
          key: F.key
        }, G);
      }
      return F.data ? /* @__PURE__ */ n.createElement("div", {
        key: ee,
        onClick: (G) => {
          var q;
          G == null || G.preventDefault(), (q = F.data) != null && q.name && O(F.data.name);
        }
      }, /* @__PURE__ */ n.createElement(Pm, {
        content: (pe = F.data) == null ? void 0 : pe.name,
        checked: b((_e = F.data) == null ? void 0 : _e.name)
      })) : "";
    })),
    [a, u, O]
  );
  return j(
    () => {
      if ($(i), i && P) {
        const F = i[0], ee = F ? document.getElementById(`${st}-${l}-${F}`) : null;
        ee == null || ee.scrollIntoView();
      }
    },
    [i, P]
  ), /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("div", {
    style: { opacity: p ? "0.34" : "1" }
  }, /* @__PURE__ */ n.createElement(We, {
    title: r,
    placeholder: o,
    value: i || "",
    disabled: p,
    hasError: c,
    errorMessage: s,
    onReadOnlyClick: () => !p && C(!0),
    end: /* @__PURE__ */ n.createElement(Vs, null),
    readOnly: !0
  })), /* @__PURE__ */ n.createElement(ti, {
    header: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(ri, {
      title: _,
      endActions: {
        actionVariant: "icon",
        icon: /* @__PURE__ */ n.createElement(Ql, null),
        onClick: () => C(!1)
      },
      showSeparator: !0
    }), m && /* @__PURE__ */ n.createElement("div", {
      className: "flex items-center justify-start py-12 px-16"
    }, /* @__PURE__ */ n.createElement("div", {
      className: "flex-1 rounded-2 pipo-mobile-cascader-search-control"
    }, /* @__PURE__ */ n.createElement(We, {
      placeholder: g("pipo_common_payin_mobile_address_inside2"),
      onFocus: () => E(!0),
      onBlur: () => E(!1),
      start: /* @__PURE__ */ n.createElement(js, {
        className: "mx-8"
      }),
      hasClearButton: !0,
      hasBottomBorder: !1,
      value: N,
      onChange: (F) => T(F.target.value)
    })), /* @__PURE__ */ n.createElement("div", {
      className: ae(
        "text-color-Primary",
        `${x ? "" : "hidden"}`,
        `${h ? "mr-16" : "ml-16"}`
      ),
      onClick: (F) => F.stopPropagation()
    }, g("pipo_common_payin_mobile_address_inside6")))),
    isVisible: P,
    onDismiss: M,
    minHeight: y == null ? void 0 : y.popupHeight
  }, /* @__PURE__ */ n.createElement("div", {
    className: "px-16 pt-8 text-color-TextSecondary h-full flex flex-col"
  }, /* @__PURE__ */ n.createElement("div", {
    className: ae(
      "relative",
      "flex-1",
      `${a ? "flex justify-center items-center" : ""}`
    ),
    style: {
      overflow: "auto"
    }
  }, J), /* @__PURE__ */ n.createElement("ul", {
    className: ae(
      `${e.length === 0 ? "hidden" : ""}`,
      `${st}-sidebar`,
      "absolute w-12 text-color-TextTertiary",
      h ? `${st}-sidebar-flip` : ""
    ),
    ref: W
  }, v.map((F, ee) => /* @__PURE__ */ n.createElement("li", {
    className: `${st}-sidebar-item`,
    key: ee
  }, F))), /* @__PURE__ */ n.createElement("div", {
    className: ae(
      "fixed",
      `${st}-sidebar-tip`,
      `${re ? "" : "hidden"}`
    )
  }, re))));
};
var bm = Object.defineProperty, xm = Object.defineProperties, Mm = Object.getOwnPropertyDescriptors, Pa = Object.getOwnPropertySymbols, Om = Object.prototype.hasOwnProperty, Cm = Object.prototype.propertyIsEnumerable, ba = (t, e, r) => e in t ? bm(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, wm = (t, e) => {
  for (var r in e || (e = {}))
    Om.call(e, r) && ba(t, r, e[r]);
  if (Pa)
    for (var r of Pa(e))
      Cm.call(e, r) && ba(t, r, e[r]);
  return t;
}, $m = (t, e) => xm(t, Mm(e));
const Sm = (t) => {
  const { value: e, options: r, onChange: a } = t, o = ge(
    () => {
      if (!(!e || r.length === 0))
        return a(e), Gi(e, r);
    },
    [e, r]
  ), i = (l) => {
    if (!l || r.length === 0)
      a(void 0);
    else {
      const c = Ki(l, r);
      a(c);
    }
  };
  return /* @__PURE__ */ n.createElement(kn, $m(wm({}, t), {
    level: "country",
    value: o,
    onChange: i
  }));
};
var km = Object.defineProperty, Tm = Object.defineProperties, Im = Object.getOwnPropertyDescriptors, xa = Object.getOwnPropertySymbols, Nm = Object.prototype.hasOwnProperty, Bm = Object.prototype.propertyIsEnumerable, Ma = (t, e, r) => e in t ? km(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Dm = (t, e) => {
  for (var r in e || (e = {}))
    Nm.call(e, r) && Ma(t, r, e[r]);
  if (xa)
    for (var r of xa(e))
      Bm.call(e, r) && Ma(t, r, e[r]);
  return t;
}, Vm = (t, e) => Tm(t, Im(e));
const jm = (t) => /* @__PURE__ */ n.createElement(kn, Vm(Dm({}, t), {
  level: "state"
}));
var Lm = Object.defineProperty, Rm = Object.defineProperties, Fm = Object.getOwnPropertyDescriptors, Oa = Object.getOwnPropertySymbols, Am = Object.prototype.hasOwnProperty, Hm = Object.prototype.propertyIsEnumerable, Ca = (t, e, r) => e in t ? Lm(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, qm = (t, e) => {
  for (var r in e || (e = {}))
    Am.call(e, r) && Ca(t, r, e[r]);
  if (Oa)
    for (var r of Oa(e))
      Hm.call(e, r) && Ca(t, r, e[r]);
  return t;
}, Um = (t, e) => Rm(t, Fm(e));
const Ym = (t) => /* @__PURE__ */ n.createElement(kn, Um(qm({}, t), {
  level: "city"
}));
var zm = Object.defineProperty, Xm = Object.defineProperties, Gm = Object.getOwnPropertyDescriptors, wa = Object.getOwnPropertySymbols, Km = Object.prototype.hasOwnProperty, Wm = Object.prototype.propertyIsEnumerable, $a = (t, e, r) => e in t ? zm(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Jm = (t, e) => {
  for (var r in e || (e = {}))
    Km.call(e, r) && $a(t, r, e[r]);
  if (wa)
    for (var r of wa(e))
      Wm.call(e, r) && $a(t, r, e[r]);
  return t;
}, Zm = (t, e) => Xm(t, Gm(e));
const Qm = (t) => {
  const {
    title: e,
    placeholder: r,
    errorMessage: a,
    hasError: o,
    onBlur: i,
    validInput: l = /[a-zA-Z0-9]/,
    formatValue: c = (d) => d
  } = t, s = Re(), [p, _] = Q(t);
  j(
    () => {
      var d;
      (d = s.current) == null || d.setInnerValue(c(p) || ""), _(p);
    },
    [p]
  );
  const m = (d) => {
    l.test(d) && _(Wi(d));
  };
  return /* @__PURE__ */ n.createElement(At, Zm(Jm({}, pr(t, ["formatter"])), {
    hasBottomBorder: !0,
    placeholder: r,
    handleRef: s,
    title: e,
    hasError: o,
    errorMessage: a,
    hasClearButton: !0,
    value: p || "",
    dir: "ltr",
    onChange: (d) => m(d.target.value),
    onBlur: i
  }));
}, ed = (t) => {
  const { dropList: e, children: r, popupVisible: a = !1, popupWidth: o } = t;
  return /* @__PURE__ */ n.createElement("div", {
    className: "pipo-dropdown"
  }, r, e && /* @__PURE__ */ n.createElement("div", {
    className: "pipo-dropdown-content",
    style: {
      display: a ? "" : "none",
      width: o || "100%"
    }
  }, e));
}, on = (t) => {
  const { key: e, content: r, onClick: a } = t;
  return /* @__PURE__ */ n.createElement("div", {
    className: "pipo-dropdown-item",
    key: e,
    onClick: a,
    onMouseDown: (o) => o.preventDefault()
  }, /* @__PURE__ */ n.createElement("p", {
    className: "pipo-dropdown-item-content"
  }, r));
};
var td = Object.defineProperty, rd = Object.defineProperties, nd = Object.getOwnPropertyDescriptors, Sa = Object.getOwnPropertySymbols, ad = Object.prototype.hasOwnProperty, od = Object.prototype.propertyIsEnumerable, ka = (t, e, r) => e in t ? td(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, ld = (t, e) => {
  for (var r in e || (e = {}))
    ad.call(e, r) && ka(t, r, e[r]);
  if (Sa)
    for (var r of Sa(e))
      od.call(e, r) && ka(t, r, e[r]);
  return t;
}, id = (t, e) => rd(t, nd(e));
const sd = (t) => {
  const {
    title: e,
    placeholder: r,
    hasError: a,
    errorMessage: o,
    onBlur: i,
    autoCompleteDisabled: l,
    autoCompleteLoading: c,
    autoCompleteList: s,
    onClickAutoComplete: p
  } = t, [_, m] = Q(t), [d, f] = R(!1), { t: g } = I.useContext(), h = Re(null), y = ge(
    () => l || c ? null : !c && (s == null ? void 0 : s.length) === 0 ? _.length < 4 ? /* @__PURE__ */ n.createElement(on, {
      key: "Not long enough",
      content: g("pipo_payin_instruction_addressinput")
    }) : /* @__PURE__ */ n.createElement(on, {
      key: "Not found",
      content: g("pipo_payin_instruction_addressinput_notfound")
    }) : s == null ? void 0 : s.map((v) => /* @__PURE__ */ n.createElement(on, {
      key: v.id,
      content: v.desc,
      onClick: () => {
        p && p(v.id), f(!1);
      }
    })),
    [
      l,
      c,
      s,
      _,
      p
    ]
  ), u = ge(() => {
    var v;
    return (v = h.current) == null ? void 0 : v.offsetWidth;
  }, [h]);
  return j(
    () => {
      m(_);
    },
    [_]
  ), /* @__PURE__ */ n.createElement(ed, {
    dropList: y,
    popupVisible: d,
    popupWidth: u
  }, /* @__PURE__ */ n.createElement(We, id(ld({}, t), {
    ref: h,
    value: _ || "",
    onChange: (v) => m(v.target.value),
    autoSize: !0,
    type: "multiline",
    lines: 1,
    maxLines: 10,
    hasBottomBorder: !0,
    hasCounter: !0,
    maxLength: 300,
    placeholder: r,
    title: e,
    hasError: a,
    onFocus: () => f(!0),
    errorMessage: o,
    hasClearButton: !0,
    isValidating: c,
    onBlur: (v) => {
      f(!1), i && i(v);
    }
  })));
};
var cd = Object.defineProperty, pd = Object.defineProperties, md = Object.getOwnPropertyDescriptors, Ta = Object.getOwnPropertySymbols, dd = Object.prototype.hasOwnProperty, _d = Object.prototype.propertyIsEnumerable, Ia = (t, e, r) => e in t ? cd(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, qe = (t, e) => {
  for (var r in e || (e = {}))
    dd.call(e, r) && Ia(t, r, e[r]);
  if (Ta)
    for (var r of Ta(e))
      _d.call(e, r) && Ia(t, r, e[r]);
  return t;
}, Ue = (t, e) => pd(t, md(e));
const Tn = (t) => {
  const {
    onFetchDistrict: e,
    onValidate: r,
    handleBlur: a,
    hasBillingAddressCountry: o = !0,
    hasBillingAddressState: i = !0,
    hasBillingAddressCity: l = !0,
    hasBillingAddressStreet: c = !0,
    hasPostalCode: s = !0
  } = t, [p = {}, _] = Q(t), {
    control: m,
    trigger: d,
    setValue: f,
    clearErrors: g,
    formState: { errors: h, isValid: y, touchedFields: u }
  } = ce({
    mode: "all"
  }), v = de({
    touchedFields: u,
    errors: h
  }), { state: P, t: $, getErrorText: x } = I.useContext(), { countryOrRegion: N = "" } = P, { region: C, province: M, city: b, street: E, postalCode: O } = Ji(
    N,
    $
  ), { list: T } = vs({
    onFetchDistrict: e,
    setValue: f,
    trigger: d,
    clearErrors: g,
    countryOrRegion: N,
    value: {
      region: p.billing_country_region || N,
      state: p.billing_state,
      city: p.billing_city
    },
    onChange: (q) => {
      _(Ue(qe({}, p), {
        billing_country_region: q.region,
        billing_state: q.state,
        billing_city: q.city
      }));
    }
  }), {
    autoCompleteDisabled: W,
    autoCompleteLoading: re,
    autoCompleteList: J,
    onClickAutoComplete: F
  } = gs(Ue(qe({}, t), {
    value: p,
    onChange: _
  })), {
    postalCodeValidator: ee,
    postalCodeFormatter: pe,
    postalCodeMaxLength: _e,
    postalValidInput: G
  } = Es(N);
  return j(
    () => {
      _(p), r(y);
    },
    [p, y]
  ), /* @__PURE__ */ n.createElement(n.Fragment, null, o && /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0 },
    name: "billing_country_region",
    control: m,
    render: ({ field: q }) => {
      var z;
      return /* @__PURE__ */ n.createElement(Sm, Ue(qe({}, q), {
        title: C.title,
        placeholder: C.placeholder,
        header: C.header,
        hasError: Boolean(v.billing_country_region),
        errorMessage: x(
          (z = v.billing_country_region) == null ? void 0 : z.type,
          C.title
        ),
        value: p.billing_country_region,
        onChange: (H) => {
          q.onChange(H), _(Ue(qe({}, p), { billing_country_region: H }));
        },
        loading: T[0].loading,
        options: T[0].list,
        disabled: T[0].disabled
      }));
    }
  }), c && /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0 },
    name: "billing_street",
    control: m,
    render: ({ field: q, fieldState: z }) => {
      var H;
      return /* @__PURE__ */ n.createElement(sd, Ue(qe({}, q), {
        title: E.title,
        placeholder: E.placeholder,
        autoCompleteDisabled: W,
        autoCompleteLoading: re,
        autoCompleteList: J,
        onClickAutoComplete: F,
        value: p.billing_street,
        onChange: (Ee) => {
          q.onChange(Ee), _(Ue(qe({}, p), { billing_street: Ee }));
        },
        hasError: Boolean(v.billing_street),
        errorMessage: x(
          (H = v.billing_street) == null ? void 0 : H.type,
          $("pipo_common_payin_address")
        ),
        onBlur: () => {
          q.onBlur(), a && a("billing_street", z);
        }
      }));
    }
  }), i && /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0 },
    name: "billing_state",
    control: m,
    render: ({ field: q }) => {
      var z;
      return /* @__PURE__ */ n.createElement(jm, Ue(qe({}, q), {
        title: M.title,
        placeholder: M.placeholder,
        header: M.header,
        hasError: Boolean(v.billing_state),
        errorMessage: x(
          (z = v.billing_state) == null ? void 0 : z.type,
          M.title
        ),
        value: p.billing_state,
        onChange: (H) => {
          q.onChange(H), _(Ue(qe({}, p), { billing_state: H }));
        },
        loading: T[1].loading,
        options: T[1].list,
        disabled: T[1].disabled
      }));
    }
  }), l && /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0 },
    name: "billing_city",
    control: m,
    render: ({ field: q }) => {
      var z;
      return /* @__PURE__ */ n.createElement(Ym, Ue(qe({}, q), {
        title: b.title,
        placeholder: b.placeholder,
        header: b.header,
        hasError: Boolean(v.billing_city),
        errorMessage: x((z = v.billing_city) == null ? void 0 : z.type, b.title),
        value: p.billing_city,
        onChange: (H) => {
          q.onChange(H), _(Ue(qe({}, p), { billing_city: H }));
        },
        loading: T[2].loading,
        options: T[2].list,
        disabled: T[2].disabled
      }));
    }
  }), s && /* @__PURE__ */ n.createElement(k, {
    rules: ee,
    name: "billing_postal_code",
    control: m,
    render: ({ field: q, fieldState: z }) => {
      var H;
      return /* @__PURE__ */ n.createElement(Qm, Ue(qe({}, q), {
        title: O.title,
        placeholder: O.placeholder,
        value: p.billing_postal_code,
        onChange: (Ee) => {
          q.onChange(Ee), _(Ue(qe({}, p), { billing_postal_code: Ee }));
        },
        maxLength: _e,
        validInput: G,
        formatValue: pe,
        hasError: Boolean(v.billing_postal_code),
        errorMessage: x(
          (H = v.billing_postal_code) == null ? void 0 : H.type,
          O.title
        ),
        onBlur: () => {
          q.onBlur(), a && a("billing_postal_code", z);
        }
      }));
    }
  }));
};
var ud = Object.defineProperty, Na = Object.getOwnPropertySymbols, yd = Object.prototype.hasOwnProperty, hd = Object.prototype.propertyIsEnumerable, Ba = (t, e, r) => e in t ? ud(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, fd = (t, e) => {
  for (var r in e || (e = {}))
    yd.call(e, r) && Ba(t, r, e[r]);
  if (Na)
    for (var r of Na(e))
      hd.call(e, r) && Ba(t, r, e[r]);
  return t;
};
const fe = (t) => /* @__PURE__ */ n.createElement("div", {
  className: "pipo-mobile-separator"
}, /* @__PURE__ */ n.createElement(lr, fd({
  color: "LinePrimary2"
}, t)));
var vd = Object.defineProperty, gd = Object.defineProperties, Ed = Object.getOwnPropertyDescriptors, Da = Object.getOwnPropertySymbols, Pd = Object.prototype.hasOwnProperty, bd = Object.prototype.propertyIsEnumerable, Va = (t, e, r) => e in t ? vd(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, xd = (t, e) => {
  for (var r in e || (e = {}))
    Pd.call(e, r) && Va(t, r, e[r]);
  if (Da)
    for (var r of Da(e))
      bd.call(e, r) && Va(t, r, e[r]);
  return t;
}, Md = (t, e) => gd(t, Ed(e));
const Od = (t) => {
  const {
    title: e,
    placeholder: r,
    maxLength: a = 10,
    error: o,
    errorMessage: i,
    onBlur: l
  } = t, [c, s] = Q(t);
  return j(
    () => {
      s(c);
    },
    [c]
  ), /* @__PURE__ */ n.createElement(We, Md(xd({}, t), {
    hasBottomBorder: !0,
    placeholder: r,
    value: c || "",
    title: e,
    hasError: Boolean(o),
    errorMessage: i,
    hasClearButton: !0,
    onChange: (p) => s(p.target.value),
    maxLength: a,
    onBlur: l
  }));
};
var Cd = Object.defineProperty, wd = Object.defineProperties, $d = Object.getOwnPropertyDescriptors, ja = Object.getOwnPropertySymbols, Sd = Object.prototype.hasOwnProperty, kd = Object.prototype.propertyIsEnumerable, La = (t, e, r) => e in t ? Cd(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Td = (t, e) => {
  for (var r in e || (e = {}))
    Sd.call(e, r) && La(t, r, e[r]);
  if (ja)
    for (var r of ja(e))
      kd.call(e, r) && La(t, r, e[r]);
  return t;
}, Id = (t, e) => wd(t, $d(e));
const Pi = (t) => {
  const {
    title: e,
    placeholder: r,
    maxLength: a = 4,
    error: o,
    errorMessage: i,
    onBlur: l
  } = t, [c, s] = Q(t);
  return j(
    () => {
      s(c);
    },
    [c]
  ), /* @__PURE__ */ n.createElement(We, Id(Td({}, t), {
    type: "password",
    hasBottomBorder: !0,
    placeholder: r,
    value: c || "",
    title: e,
    hasError: Boolean(o),
    errorMessage: i,
    hasClearButton: !0,
    onChange: (p) => s(p.target.value),
    maxLength: a,
    onBlur: l
  }));
}, Nd = (t) => {
  const { onClick: e } = t, { t: r } = I.useContext();
  return /* @__PURE__ */ n.createElement("div", {
    onClick: e,
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "17.5 0"
    }
  }, /* @__PURE__ */ n.createElement("span", {
    className: "P2-Semibold"
  }, r("pipo_payin_state_cashier_seemore")), /* @__PURE__ */ n.createElement(jr, null));
};
var Bd = Object.defineProperty, Dd = Object.defineProperties, Vd = Object.getOwnPropertyDescriptors, Or = Object.getOwnPropertySymbols, bi = Object.prototype.hasOwnProperty, xi = Object.prototype.propertyIsEnumerable, Ra = (t, e, r) => e in t ? Bd(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Oe = (t, e) => {
  for (var r in e || (e = {}))
    bi.call(e, r) && Ra(t, r, e[r]);
  if (Or)
    for (var r of Or(e))
      xi.call(e, r) && Ra(t, r, e[r]);
  return t;
}, je = (t, e) => Dd(t, Vd(e)), jd = (t, e) => {
  var r = {};
  for (var a in t)
    bi.call(t, a) && e.indexOf(a) < 0 && (r[a] = t[a]);
  if (t != null && Or)
    for (var a of Or(t))
      e.indexOf(a) < 0 && xi.call(t, a) && (r[a] = t[a]);
  return r;
}, Ld = (t, e, r) => new Promise((a, o) => {
  var i = (s) => {
    try {
      c(r.next(s));
    } catch (p) {
      o(p);
    }
  }, l = (s) => {
    try {
      c(r.throw(s));
    } catch (p) {
      o(p);
    }
  }, c = (s) => s.done ? a(s.value) : Promise.resolve(s.value).then(i, l);
  c((r = r.apply(t, e)).next());
});
const In = (t) => {
  var e, r;
  const { state: a, t: o, getErrorText: i, useOldEvent: l, noSavingBox: c } = I.useContext(), { countryOrRegion: s, config: p = {}, amount: _ } = a, {
    showSavingBox: m = !c,
    onFetchDistrict: d,
    onFetchAddressAutocomplete: f,
    onFetchPlaceDetail: g,
    onValidate: h,
    onSendEvent: y
  } = t, [u = {}, v] = Q(t), {
    watch: P,
    control: $,
    getValues: x,
    unregister: N,
    formState: { errors: C, isValid: M, touchedFields: b }
  } = ce({
    mode: "all"
  }), E = de({
    touchedFields: b,
    errors: C
  }), {
    defaultProxyType: O,
    proxyTypeTitle: T,
    proxyTypeValidator: W,
    onProxyTypeChange: re
  } = Pn(N), [J, F] = R(O), [ee, pe] = R(!1), { boleto: _e = {} } = p, { hasCNPJ: G = !0, hasEmail: q = !1 } = Oe(Oe({}, _e), t), z = P("proxy_type") === "individual", H = P("proxy_type") === "company", Ee = ue.list[s].code, ke = (r = (e = ue.list[s]) == null ? void 0 : e.phone) == null ? void 0 : r.pattern, oe = Ne(
    () => {
      u.proxy_type = J;
      const B = u, { storeCard: L = !1 } = B, U = jd(B, ["storeCard"]), Z = Dr(
        U,
        Zi
      ), { paymentMethodType: xe, paymentMethod: $e } = dr;
      v(u, {
        formData: U,
        paymentMethod: {
          paymentMethod: $e.paymentMethod,
          paymentMethodId: $e.paymentMethodId
        },
        paymentMethodType: xe.paymentMethodType,
        paymentParams: Z,
        storeCard: L
      });
    },
    [u]
  ), ve = (B, L) => {
    const U = {
      paymentMethodType: dr.paymentMethodType.paymentMethodType,
      paymentMethod: dr.paymentMethod.paymentMethod,
      paymentMethodId: dr.paymentMethod.paymentMethodId
    };
    ie({
      event: _ != null && _.value ? "fp_sdk_checkout_fill_in" : "fp_sdk_checkout_pi_management_fill_in",
      scenario: B,
      fieldState: L,
      getValues: x,
      onSendEvent: y,
      paymentMethodInfo: U
    });
  }, D = (B) => {
    y && (y({
      name: "fp_sdk_checkout_dropin_element_click",
      categories: {
        click_scenario: B ? "save_for_next_time" : "unsave_for_next_time"
      }
    }), l && y({
      name: "fp_sdk_checkout_page_click",
      categories: {
        click_method: B ? "save_for_next_time" : "unsave_for_next_time"
      }
    }));
  };
  return j(
    () => {
      oe(), h(M && ee);
    },
    [u, M, ee]
  ), /* @__PURE__ */ n.createElement("div", {
    className: "w-full"
  }, /* @__PURE__ */ n.createElement("div", {
    style: { overflowX: "unset", position: "relative" },
    className: "w-full box-border"
  }, /* @__PURE__ */ n.createElement("div", {
    className: "w-full",
    style: {
      position: "relative",
      overflowX: "unset"
    }
  }, /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, pattern: K.nameRegex },
    name: "holder_name",
    control: $,
    render: ({ field: B, fieldState: L }) => {
      var U;
      return /* @__PURE__ */ n.createElement(we, je(Oe({}, B), {
        value: u.holder_name,
        onChange: (Z) => {
          B.onChange(Z), v(je(Oe({}, u), { holder_name: Z }));
        },
        error: E.holder_name,
        errorMessage: i(
          (U = E.holder_name) == null ? void 0 : U.type,
          o("pipo_common_payin_boleto_name")
        ),
        title: o("pipo_common_payin_boleto_name"),
        placeholder: o("pipo_common_payin_boleto_name"),
        onBlur: () => {
          B.onBlur(), ve("holder_name", L);
        }
      }));
    }
  }), q && /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, pattern: K.emailRegex },
    name: "email",
    control: $,
    render: ({ field: B, fieldState: L }) => {
      var U;
      return /* @__PURE__ */ n.createElement(Ae, je(Oe({}, B), {
        value: u.email,
        onChange: (Z) => {
          B.onChange(Z), v(je(Oe({}, u), { email: Z }));
        },
        title: o("pipo_common_payin_Email"),
        placeholder: o("pipo_common_payin_ph_email"),
        error: E.email,
        errorMessage: i(
          (U = E.email) == null ? void 0 : U.type,
          o("pipo_common_payin_Email")
        ),
        onBlur: () => {
          B.onBlur(), ve("email", L);
        }
      }));
    }
  }), /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0 },
    name: "phone_country_code",
    control: $,
    render: ({ field: B }) => /* @__PURE__ */ n.createElement(pt, {
      countryCode: Ee,
      onChange: (L) => {
        B.onChange(L);
      }
    })
  }), /* @__PURE__ */ n.createElement(k, {
    rules: {
      required: !0,
      pattern: ke
    },
    name: "phone",
    control: $,
    render: ({ field: B, fieldState: L }) => {
      var U;
      return /* @__PURE__ */ n.createElement(Fe, je(Oe({}, B), {
        title: o("pipo_common_payin_phone_number"),
        placeholder: o("pipo_common_payin_ph_phone_number"),
        error: E.phone,
        errorMessage: i(
          (U = E.phone) == null ? void 0 : U.type,
          o("pipo_common_payin_phone_number")
        ),
        countryCode: Ee,
        countryOrRegion: s,
        value: u.phone,
        onChange: (Z, xe) => {
          B.onChange(Z), v(je(Oe({}, u), {
            phone: Z,
            phone_country_code: xe
          }));
        },
        onBlur: () => {
          B.onBlur(), ve("phone", L);
        }
      }));
    }
  }), /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0 },
    name: "proxy_type",
    control: $,
    defaultValue: O,
    render: ({ field: B }) => /* @__PURE__ */ n.createElement($n, je(Oe({}, B), {
      show: G,
      title: T,
      value: J,
      proxyTypeValidator: W,
      onChange: (L) => {
        F(L), re(L, B.onChange);
      },
      "data-sel": "pipo-mobile-boleto-proxy-type"
    }))
  }), z && /* @__PURE__ */ n.createElement(k, {
    rules: {
      required: !0,
      validate: {
        cpf: (B) => ar.isValid(B || "")
      }
    },
    name: "identity",
    control: $,
    defaultValue: "",
    render: ({ field: B, fieldState: L }) => {
      var U;
      return /* @__PURE__ */ n.createElement(On, je(Oe({}, B), {
        title: o("pipo_common_payin_CPF"),
        value: u.identity,
        onChange: (Z) => {
          B.onChange(Z), v(je(Oe({}, u), { identity: Z }));
        },
        error: E.identity,
        errorMessage: i(
          (U = E.identity) == null ? void 0 : U.type,
          o("pipo_common_payin_CPF")
        ),
        onBlur: () => {
          B.onBlur(), ve("identity", L);
        }
      }));
    }
  }), H && /* @__PURE__ */ n.createElement(k, {
    rules: {
      required: !0,
      validate: {
        cnpj: (B) => nr.isValid(B || "")
      }
    },
    name: "company_id",
    control: $,
    defaultValue: "",
    render: ({ field: B, fieldState: L }) => {
      var U;
      return /* @__PURE__ */ n.createElement(Mn, je(Oe({}, B), {
        title: o("pipo_common_payin_CNPJ"),
        value: u.company_id,
        onChange: (Z) => {
          B.onChange(Z), v(je(Oe({}, u), { company_id: Z }));
        },
        error: E.company_id,
        errorMessage: i(
          (U = E.company_id) == null ? void 0 : U.type,
          o("pipo_common_payin_CNPJ")
        ),
        onBlur: () => {
          B.onBlur(), ve("company_id", L);
        }
      }));
    }
  }), /* @__PURE__ */ n.createElement(Tn, {
    onFetchDistrict: d,
    onFetchAddressAutocomplete: f,
    onFetchPlaceDetail: g,
    value: u,
    onChange: (B) => {
      v(Oe(Oe({}, u), B));
    },
    onValidate: (B) => pe(B),
    handleBlur: ve
  }), m && /* @__PURE__ */ n.createElement(mt, {
    title: o("pipo_common_payin_save_card"),
    value: u.storeCard,
    onChange: (B) => {
      v(je(Oe({}, u), { storeCard: B })), D(B);
    }
  }))));
};
Ft(
  (t, e) => {
    const { onRedirectPP: r, onSubmit: a, onSendEvent: o } = t, [i, l] = R(), [c, s] = R(!1), { isSubmitting: p, formSubmitState: _ } = Rt(), m = (d) => Ld(void 0, null, function* () {
      if (d == null || d.preventDefault(), !a || !i)
        return;
      const f = i.paymentMethodType, { paymentMethod: g, paymentMethodId: h } = i.paymentMethod;
      _.setTrue(), o && o({
        name: "fp_sdk_checkout_pi_management_click",
        metrics: Oe({}, {}),
        categories: {
          click_method: "confirm",
          pi_type_1: f,
          pi_type_2: g,
          pi_type_3: "",
          pm_id: h,
          saved_pi: "other"
        }
      }), yield a(i), _.setFalse();
    });
    return sr(e, {
      initPath: "boleto",
      initParams: {},
      instanceMethods: {}
    }), /* @__PURE__ */ n.createElement("div", {
      className: "w-full h-full"
    }, /* @__PURE__ */ n.createElement("div", {
      style: { overflowX: "unset", position: "relative" },
      className: "w-full h-full box-border"
    }, /* @__PURE__ */ n.createElement("form", {
      onSubmit: m,
      className: "w-full h-full",
      onKeyDown: (d) => {
        d.keyCode === 13 && d.preventDefault();
      }
    }, /* @__PURE__ */ n.createElement("div", {
      className: "pt-24 pb-24 pl-16 pr-16 w-full h-full",
      style: {
        overflowY: "auto",
        position: "relative",
        overflowX: "unset"
      }
    }, /* @__PURE__ */ n.createElement(In, je(Oe({}, t), {
      onChange: (d, f) => l(f),
      onValidate: (d) => s(d)
    })), /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(qt, {
      type: "bind",
      onRedirectPP: r
    }), /* @__PURE__ */ n.createElement("div", {
      className: "w-full mt-16"
    }, /* @__PURE__ */ n.createElement(Lr, {
      isValid: c,
      isLoading: p
    })))))));
  }
);
var Rd = Object.defineProperty, Fd = Object.defineProperties, Ad = Object.getOwnPropertyDescriptors, Cr = Object.getOwnPropertySymbols, Mi = Object.prototype.hasOwnProperty, Oi = Object.prototype.propertyIsEnumerable, Fa = (t, e, r) => e in t ? Rd(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, he = (t, e) => {
  for (var r in e || (e = {}))
    Mi.call(e, r) && Fa(t, r, e[r]);
  if (Cr)
    for (var r of Cr(e))
      Oi.call(e, r) && Fa(t, r, e[r]);
  return t;
}, Me = (t, e) => Fd(t, Ad(e)), Hd = (t, e) => {
  var r = {};
  for (var a in t)
    Mi.call(t, a) && e.indexOf(a) < 0 && (r[a] = t[a]);
  if (t != null && Cr)
    for (var a of Cr(t))
      e.indexOf(a) < 0 && Oi.call(t, a) && (r[a] = t[a]);
  return r;
}, Aa = (t, e, r) => new Promise((a, o) => {
  var i = (s) => {
    try {
      c(r.next(s));
    } catch (p) {
      o(p);
    }
  }, l = (s) => {
    try {
      c(r.throw(s));
    } catch (p) {
      o(p);
    }
  }, c = (s) => s.done ? a(s.value) : Promise.resolve(s.value).then(i, l);
  c((r = r.apply(t, e)).next());
});
const Nn = (t) => {
  var e, r;
  const {
    onFetchDistrict: a,
    onValidate: o,
    onSendEvent: i,
    onFetchAddressAutocomplete: l,
    onFetchPlaceDetail: c,
    onScanCard: s
  } = t, [p = {}, _] = Q(t), {
    watch: m,
    control: d,
    trigger: f,
    getValues: g,
    unregister: h,
    formState: { errors: y, isValid: u, touchedFields: v }
  } = ce({
    mode: "all"
  }), P = de({
    touchedFields: v,
    errors: y
  }), { state: $, t: x, getErrorText: N, isFlip: C } = I.useContext(), { countryOrRegion: M, amount: b, cardType: E = "", prepaidType: O = "" } = $, T = Boolean(b == null ? void 0 : b.value), {
    cardNumberInputRef: W,
    cardBrands: re,
    cardNoValidator: J,
    currentCardBrand: F,
    cardNoPlaceholder: ee,
    cardNoMaxLength: pe,
    getCardNoError: _e,
    onCardNoChange: G,
    formatValue: q,
    formatCursor: z,
    cardDetail: H,
    onCardNumberBlur: Ee
  } = Ps(t);
  j(
    () => {
      f("card_number").catch((V) => null);
    },
    [H]
  );
  const { getExpiryDateError: ke } = bs(), { cvvPlaceholder: oe, cvvValidator: ve, cvvTitle: D, getCVVError: B } = Gl(F, f, g), {
    defaultProxyType: L,
    proxyTypeTitle: U,
    proxyTypeValidator: Z,
    onProxyTypeChange: xe
  } = Pn(h), [$e, Be] = R(L), {
    hasSavingBox: Ze,
    hasCNPJ: Te,
    hasPhoneNumber: rt,
    hasEmail: kt,
    hasProxyType: gt,
    hasCPF: Et,
    renderCNPJ: w,
    renderBillingInfo: A,
    hasBillingAddressCountry: Ie,
    hasBillingAddressState: nt,
    hasBillingAddressCity: Qe,
    hasBillingAddressStreet: Ut,
    hasPostalCode: Pe
  } = xs(t, m), [Yt, Rr] = R(!A), Se = ue.list[M].code, Pt = (r = (e = ue.list[M]) == null ? void 0 : e.phone) == null ? void 0 : r.pattern, Tt = Ne(() => {
    var V, ne, te, le;
    p.proxy_type = $e;
    const at = p, { storeCard: Xt = !1 } = at, It = Hd(at, ["storeCard"]), S = Dr(
      It,
      es
    ), X = ((V = F == null ? void 0 : F.paymentMethod) == null ? void 0 : V.paymentMethodId) || "pm_pi_ccdc_visa_c_d", { paymentMethod: me, paymentMethodId: se } = (ne = or[`${X}`]) == null ? void 0 : ne.paymentMethod;
    _(p, {
      formData: It,
      paymentMethod: {
        paymentMethod: me,
        paymentMethodId: se
      },
      paymentMethodType: (le = (te = or[`${X}`]) == null ? void 0 : te.paymentMethodType) == null ? void 0 : le.paymentMethodType,
      paymentParams: S,
      storeCard: Xt
    });
  }, [F, p, _, $e]), [dt, zt] = R("0"), bt = (() => {
    var V, ne, te, le;
    if (!H)
      return {};
    const at = (ne = H.card_brand_length) != null && ne.includes(
      ((V = p.card_number) == null ? void 0 : V.length) || 0
    ) ? "1" : "0", Xt = (() => {
      let X = "0";
      return re.forEach((me) => {
        var se;
        me.paymentMethod.paymentMethod.toLowerCase() === ((se = H == null ? void 0 : H.card_brand) == null ? void 0 : se.toLowerCase()) && (X = "1");
      }), X;
    })(), It = (() => {
      var X;
      return H.card_type ? !E || (E == null ? void 0 : E.toLowerCase()) === "all" ? "default" : ((X = H == null ? void 0 : H.card_type) == null ? void 0 : X.toLowerCase()) === (E == null ? void 0 : E.toLowerCase()) ? "yes" : "no" : "null";
    })(), S = (() => {
      if (H.is_prepaid === void 0)
        return "null";
      if (!O || O.toLowerCase() === "all")
        return "default";
      const X = O.toLowerCase() === "prepaid";
      return H.is_prepaid === X ? "yes" : "no";
    })();
    return {
      module: b != null && b.value ? "checkout" : "pi_management",
      is_identified: H != null && H.validate_succ ? "1" : "0",
      card_country_code: H == null ? void 0 : H.issuer_country_code,
      card_brand: H == null ? void 0 : H.card_brand,
      card_ccdc: H == null ? void 0 : H.card_type,
      timestamp: Date.now(),
      card_bin: (te = p.card_number) == null ? void 0 : te.slice(0, 6),
      is_prepaid: H != null && H.is_prepaid ? "1" : "0",
      card_number_length: (le = H.card_brand_length) == null ? void 0 : le.toString(),
      is_card_length_support: at,
      is_ccdc_suport: It,
      is_channel_support: Xt,
      is_prepaid_support: S,
      is_Luhn_support: K.luhn(p.card_number || "") ? "1" : "0"
    };
  })(), He = (V, ne, te) => {
    const le = {
      paymentMethodType: Ll.paymentMethodType,
      paymentMethod: F == null ? void 0 : F.paymentMethod.paymentMethod,
      paymentMethodId: F == null ? void 0 : F.paymentMethod.paymentMethodId
    };
    ie({
      event: T ? "fp_sdk_checkout_fill_in" : "fp_sdk_checkout_pi_management_fill_in",
      scenario: V,
      fieldState: ne,
      getValues: g,
      onSendEvent: i,
      paymentMethodInfo: le,
      extra: dt ? { is_after_ocr: dt } : {},
      replaceScenario: te
    }), V === "card_number" && ie({
      event: "fp_sdk_checkout_card_number_verify",
      scenario: V,
      fieldState: ne,
      getValues: g,
      onSendEvent: i,
      paymentMethodInfo: le,
      cardBinDetail: bt
    });
  }, mr = (V) => {
    i && i({
      name: T ? "fp_sdk_checkout_dropin_element_click" : "fp_sdk_checkout_pi_management_click",
      categories: {
        click_scenario: V ? "save_for_next_time" : "unsave_for_next_time"
      }
    });
  };
  return j(
    () => {
      Tt(), o(u && Yt);
    },
    [p, u, Yt, F]
  ), /* @__PURE__ */ n.createElement("div", {
    className: "w-full"
  }, /* @__PURE__ */ n.createElement("div", {
    style: { overflowX: "unset", position: "relative" },
    className: "w-full box-border"
  }, /* @__PURE__ */ n.createElement(k, {
    rules: {
      required: !0,
      validate: J
    },
    name: "card_number",
    control: d,
    render: ({ field: V, fieldState: ne }) => /* @__PURE__ */ n.createElement(gc, Me(he({}, V), {
      ref: W,
      title: x("pipo_common_payin_card_number"),
      value: p.card_number,
      onChange: (te) => G(
        te,
        (le) => _(Me(he({}, p), { card_number: le })),
        V.onChange
      ),
      hasError: Boolean(P.card_number),
      errorMessage: _e(P.card_number),
      placeholder: ee,
      maxLength: pe,
      cardBrands: re,
      currentCardBrand: F,
      formatValue: q,
      formatCursor: z,
      onBlur: () => {
        V.onBlur(), He("card_number", ne), Ee(g().card_number);
      },
      onScanCard: s,
      onSendEvent: i,
      setIsAfterOCR: zt,
      onScanBlur: () => {
        V.onBlur(), He("card_number", ne, "ocr_card_number");
      }
    }))
  }), /* @__PURE__ */ n.createElement(k, {
    rules: {
      required: !0,
      validate: K.dateValidator
    },
    name: "expiration_month",
    control: d,
    render: ({ field: V, fieldState: ne }) => /* @__PURE__ */ n.createElement(Wp, {
      title: x("pipo_common_payin_expiry_date"),
      placeholder: C ? `${x("pipo_common_payin_ph_expiry_yy")}/${x(
        "pipo_common_payin_ph_expiry_mm"
      )}` : `${x("pipo_common_payin_ph_expiry_mm")}/${x(
        "pipo_common_payin_ph_expiry_yy"
      )}`,
      error: P.expiration_month,
      errorMessage: ke(
        P.expiration_month
      ),
      value: {
        month: p.expiration_month || "",
        year: p.expiration_year || ""
      },
      onChange: (te, le) => {
        _(Me(he({}, p), {
          expiration_month: te,
          expiration_year: le
        })), V.onChange(te + "/" + le);
      },
      onBlur: () => {
        V.onBlur(), He("expiration_month", ne);
      }
    })
  }), /* @__PURE__ */ n.createElement(k, {
    rules: ve,
    name: "cvv",
    control: d,
    render: ({ field: V, fieldState: ne }) => /* @__PURE__ */ n.createElement(li, Me(he({}, V), {
      title: D,
      value: p.cvv,
      onChange: (te) => {
        V.onChange(te), _(Me(he({}, p), { cvv: te }));
      },
      placeholder: oe,
      hasError: Boolean(P.cvv),
      errorMessage: B(P.cvv),
      onBlur: () => {
        V.onBlur(), He("cvv", ne);
      }
    }))
  }), /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, pattern: K.nameRegex },
    name: "holder_name",
    control: d,
    render: ({ field: V, fieldState: ne }) => {
      var te;
      return /* @__PURE__ */ n.createElement(we, Me(he({}, V), {
        value: p.holder_name,
        onChange: (le) => {
          V.onChange(le), _(Me(he({}, p), { holder_name: le }));
        },
        error: P.holder_name,
        errorMessage: N(
          (te = P.holder_name) == null ? void 0 : te.type,
          x("pipo_common_payin_cardholder_name")
        ),
        title: x("pipo_common_payin_cardholder_name"),
        placeholder: x("pipo_common_payin_cardholder_name"),
        onBlur: () => {
          V.onBlur(), He("holder_name", ne);
        }
      }));
    }
  }), gt && /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0 },
    name: "proxy_type",
    control: d,
    defaultValue: L,
    render: ({ field: V }) => /* @__PURE__ */ n.createElement($n, Me(he({}, V), {
      show: Te,
      title: U,
      value: $e,
      proxyTypeValidator: Z,
      onChange: (ne) => {
        Be(ne), xe(ne, V.onChange);
      },
      "data-sel": "pipo-mobile-ccdc-proxy-type"
    }))
  }), Et && /* @__PURE__ */ n.createElement(k, {
    rules: {
      required: !0,
      validate: {
        cpf: (V) => ar.isValid(V || "")
      }
    },
    name: "identity",
    control: d,
    defaultValue: "",
    render: ({ field: V, fieldState: ne }) => {
      var te;
      return /* @__PURE__ */ n.createElement(On, Me(he({}, V), {
        title: x("pipo_common_payin_CPF"),
        value: p.identity,
        onChange: (le) => {
          V.onChange(le), _(Me(he({}, p), { identity: le }));
        },
        error: P.identity,
        errorMessage: N(
          (te = P.identity) == null ? void 0 : te.type,
          x("pipo_common_payin_CPF")
        ),
        onBlur: () => {
          V.onBlur(), He("identity", ne);
        }
      }));
    }
  }), w && /* @__PURE__ */ n.createElement(k, {
    rules: {
      required: !0,
      validate: {
        cnpj: (V) => nr.isValid(V || "")
      }
    },
    name: "company_id",
    control: d,
    defaultValue: "",
    render: ({ field: V, fieldState: ne }) => {
      var te;
      return /* @__PURE__ */ n.createElement(Mn, Me(he({}, V), {
        title: x("pipo_common_payin_CNPJ"),
        value: p.company_id,
        onChange: (le) => {
          V.onChange(le), _(Me(he({}, p), { company_id: le }));
        },
        error: P.company_id,
        errorMessage: N(
          (te = P.company_id) == null ? void 0 : te.type,
          x("pipo_common_payin_CNPJ")
        ),
        onBlur: () => {
          V.onBlur(), He("company_id", ne);
        }
      }));
    }
  }), rt && /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0 },
    name: "phone_country_code",
    control: d,
    render: ({ field: V }) => /* @__PURE__ */ n.createElement(pt, {
      countryCode: Se,
      onChange: (ne) => {
        V.onChange(ne);
      }
    })
  }), /* @__PURE__ */ n.createElement(k, {
    rules: {
      required: !0,
      pattern: Pt
    },
    name: "phone",
    control: d,
    render: ({ field: V, fieldState: ne }) => {
      var te;
      return /* @__PURE__ */ n.createElement(Fe, Me(he({}, V), {
        title: x("pipo_common_payin_phone_number"),
        placeholder: x("pipo_common_payin_ph_phone_number"),
        error: P.phone,
        errorMessage: N(
          (te = P.phone) == null ? void 0 : te.type,
          x("pipo_common_payin_phone_number")
        ),
        countryCode: Se,
        countryOrRegion: M,
        value: p.phone,
        onChange: (le, at) => {
          V.onChange(le), _(Me(he({}, p), {
            phone: le,
            phone_country_code: at
          }));
        },
        onBlur: () => {
          V.onBlur(), He("phone", ne);
        }
      }));
    }
  })), kt && /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, pattern: K.emailRegex },
    name: "email",
    control: d,
    render: ({ field: V, fieldState: ne }) => {
      var te;
      return /* @__PURE__ */ n.createElement(Ae, Me(he({}, V), {
        title: x("pipo_common_payin_Email"),
        value: p.email,
        onChange: (le) => {
          V.onChange(le), _(Me(he({}, p), { email: le }));
        },
        placeholder: x("pipo_common_payin_ph_email"),
        error: P.email,
        errorMessage: N(
          (te = P.email) == null ? void 0 : te.type,
          x("pipo_common_payin_Email")
        ),
        onBlur: () => {
          V.onBlur(), He("email", ne);
        }
      }));
    }
  }), A && /* @__PURE__ */ n.createElement(Tn, {
    onFetchDistrict: a,
    onFetchAddressAutocomplete: l,
    onFetchPlaceDetail: c,
    value: p,
    onChange: (V) => {
      _(he(he({}, p), V));
    },
    onValidate: (V) => Rr(V),
    handleBlur: He,
    hasBillingAddressCountry: Ie,
    hasBillingAddressState: nt,
    hasBillingAddressCity: Qe,
    hasBillingAddressStreet: Ut,
    hasPostalCode: Pe
  }), Ze && T && /* @__PURE__ */ n.createElement(mt, {
    title: x("pipo_common_payin_save_card"),
    value: p.storeCard,
    onChange: (V) => {
      _(Me(he({}, p), { storeCard: V })), mr(V);
    }
  })));
}, Wf = Ft(
  (t, e) => {
    const { onRedirectPP: r, onSubmit: a, onSendEvent: o } = t, { state: i, t: l } = I.useContext(), { countryOrRegion: c, cardType: s = "" } = i, { cardTypeBool: p, cardTypeStarling: _ } = Qi(s), [m, d] = R(), [f, g] = R(!1), { isSubmitting: h, formSubmitState: y } = Rt(), u = (v) => Aa(void 0, null, function* () {
      if (v == null || v.preventDefault(), !a || !m)
        return;
      const P = m.paymentMethodType, { paymentMethod: $, paymentMethodId: x } = m.paymentMethod;
      y.setTrue(), o && o({
        name: "fp_sdk_checkout_pi_management_click",
        metrics: he({}, {}),
        categories: {
          click_method: "confirm",
          pi_type_1: P,
          pi_type_2: $,
          pi_type_3: "",
          pm_id: x,
          saved_pi: "other"
        }
      }), yield a(m), y.setFalse();
    });
    return sr(e, {
      initPath: "ccdc",
      initParams: {},
      instanceMethods: {}
    }), /* @__PURE__ */ n.createElement("div", {
      className: "pipo-mobile w-full h-full",
      "data-sel": "pipo-mobile-ccdc-form"
    }, /* @__PURE__ */ n.createElement("div", {
      style: { overflowX: "unset", position: "relative" },
      className: "w-full h-full box-border"
    }, /* @__PURE__ */ n.createElement("form", {
      className: "w-full h-full",
      onKeyDown: (v) => {
        v.keyCode === 13 && v.preventDefault();
      }
    }, /* @__PURE__ */ n.createElement("div", {
      className: "pt-24 pb-24 pl-16 pr-16 w-full h-full",
      style: {
        overflowY: "auto",
        position: "relative",
        overflowX: "unset"
      }
    }, /* @__PURE__ */ n.createElement("div", {
      className: "H3-Bold text-color-TextPrimary"
    }, l(c === "BR" ? "pipo_payin_cc" : p ? `pipo_payin_logo_CCDC_${_}` : "pipo_common_payin_cc_dc")), /* @__PURE__ */ n.createElement(Nn, Me(he({}, t), {
      onChange: (v, P) => d(P),
      onValidate: (v) => g(v)
    })), /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(qt, {
      type: "bind",
      onRedirectPP: r
    }), /* @__PURE__ */ n.createElement("div", {
      className: "w-full mt-16"
    }, /* @__PURE__ */ n.createElement(Lr, {
      isValid: f,
      isLoading: h,
      onClick: (v) => Aa(void 0, null, function* () {
        yield u(v);
      })
    })))))));
  }
);
var qd = Object.defineProperty, wr = Object.getOwnPropertySymbols, Ci = Object.prototype.hasOwnProperty, wi = Object.prototype.propertyIsEnumerable, Ha = (t, e, r) => e in t ? qd(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Ud = (t, e) => {
  for (var r in e || (e = {}))
    Ci.call(e, r) && Ha(t, r, e[r]);
  if (wr)
    for (var r of wr(e))
      wi.call(e, r) && Ha(t, r, e[r]);
  return t;
}, Yd = (t, e) => {
  var r = {};
  for (var a in t)
    Ci.call(t, a) && e.indexOf(a) < 0 && (r[a] = t[a]);
  if (t != null && wr)
    for (var a of wr(t))
      e.indexOf(a) < 0 && wi.call(t, a) && (r[a] = t[a]);
  return r;
};
const zd = (t) => {
  var e = t, { className: r } = e, a = Yd(e, ["className"]);
  return /* @__PURE__ */ n.createElement("div", {
    className: ae(r, "pipo-mobile-radio-button")
  }, /* @__PURE__ */ n.createElement(bn, Ud({}, a)));
}, rr = (t) => {
  const {
    icon: e,
    label: r,
    disabled: a,
    isPrimary: o,
    isExpired: i,
    isSelected: l,
    onSelect: c,
    children: s,
    type: p = "select",
    balance: _,
    marketingTextList: m = [],
    "data-sel": d = ""
  } = t, f = Boolean(!(s && l)), { t: g, isFlip: h } = I.useContext(), y = () => {
    switch (p) {
      case "select":
        return /* @__PURE__ */ n.createElement(zd, {
          checked: l,
          onChange: c,
          size: "medium",
          disabled: a
        });
      case "jump":
        return /* @__PURE__ */ n.createElement(Ls, {
          color: "TextTertiary",
          size: 16
        });
      case "expand":
        return /* @__PURE__ */ n.createElement("div", {
          style: { transform: l ? "rotate(180deg)" : "" }
        }, /* @__PURE__ */ n.createElement(jr, {
          color: "TextTertiary",
          size: 16
        }));
    }
  }, u = () => m.length ? /* @__PURE__ */ n.createElement("div", {
    className: "pipo-mobile-payment-method-item-marketing-event-container mb-8",
    style: h ? { marginRight: 44 } : { marginLeft: 44 }
  }, m.map((P, $) => /* @__PURE__ */ n.createElement("p", {
    key: $,
    className: "pipo-mobile-payment-method-item-marketing-event-text"
  }, g(P)))) : /* @__PURE__ */ n.createElement(n.Fragment, null), v = Boolean(l && s);
  return /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("div", {
    className: ae(
      "mt-16",
      i ? "mb-12" : m.length ? "mb-8" : "mb-16",
      "pipo-mobile-pi"
    ),
    onClick: () => !a && c(),
    "data-sel": d
  }, /* @__PURE__ */ n.createElement("div", {
    className: "flex justify-between items-center"
  }, /* @__PURE__ */ n.createElement("div", {
    className: "flex justify-center items-center"
  }, /* @__PURE__ */ n.createElement("img", {
    className: `w-32 h-20 m${h ? "l" : "r"}-12`,
    src: e
  }), /* @__PURE__ */ n.createElement("span", {
    className: ae(
      "H4-Regular",
      i ? "text-color-TextQuaternary" : "text-color-TextPrimary"
    ),
    style: {
      direction: "ltr",
      maxWidth: o ? 194 : 255,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    }
  }, r), o && /* @__PURE__ */ n.createElement("div", {
    className: "pipo-mobile-payment-method-item-primary-container"
  }, /* @__PURE__ */ n.createElement("span", {
    className: "pipo-mobile-payment-method-item-primary"
  }, g("pipo_payin_primary_title")))), y()), i && /* @__PURE__ */ n.createElement("div", {
    className: "payment-method-item-expired text-color-TextQuaternary H4-Regular mt-4"
  }, g("pipo_payin_card_status_expired")), _ && /* @__PURE__ */ n.createElement("div", {
    className: "payment-method-item-balance text-color-TextTertiary  H4-Regular mt-4"
  }, `${g("pipo_payin_pi_balance") ? `${g("pipo_payin_pi_balance")}: ` : ""}${_}`)), u(), f && /* @__PURE__ */ n.createElement(fe, null), v ? s : null);
};
var Xd = Object.defineProperty, Gd = Object.defineProperties, Kd = Object.getOwnPropertyDescriptors, qa = Object.getOwnPropertySymbols, Wd = Object.prototype.hasOwnProperty, Jd = Object.prototype.propertyIsEnumerable, Ua = (t, e, r) => e in t ? Xd(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Ya = (t, e) => {
  for (var r in e || (e = {}))
    Wd.call(e, r) && Ua(t, r, e[r]);
  if (qa)
    for (var r of qa(e))
      Jd.call(e, r) && Ua(t, r, e[r]);
  return t;
}, za = (t, e) => Gd(t, Kd(e));
const $i = (t) => {
  var e;
  const { item: r, onValidate: a, onSendEvent: o } = t, { isFlip: i, state: l } = I.useContext(), { cvvTitle: c, cvvPlaceholder: s, cvvValidator: p, getCVVError: _ } = Gl(r), [m = {}, d] = Q(
    t
  ), {
    control: f,
    getValues: g,
    formState: { errors: h, isValid: y, touchedFields: u }
  } = ce({
    mode: "all"
  }), v = de({
    touchedFields: u,
    errors: h
  }), P = (x, N) => {
    const C = {
      paymentMethodType: r.paymentMethodType.paymentMethodType,
      paymentMethod: r.paymentMethod.paymentMethod,
      paymentMethodId: r.paymentMethod.paymentMethodId
    };
    ie({
      event: "fp_sdk_checkout_fill_in",
      scenario: x,
      fieldState: N,
      getValues: g,
      onSendEvent: o,
      paymentMethodInfo: C
    });
  }, $ = Boolean((e = l.amount) == null ? void 0 : e.value);
  return j(
    () => {
      d(m), a(y);
    },
    [m, y]
  ), /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement(k, {
    rules: p,
    name: "cvv",
    control: f,
    render: ({ field: x, fieldState: N }) => /* @__PURE__ */ n.createElement("div", {
      style: i ? { marginRight: "44px" } : { marginLeft: "44px" }
    }, /* @__PURE__ */ n.createElement(li, za(Ya({}, x), {
      title: c,
      placeholder: s,
      hasError: Boolean(v.cvv),
      errorMessage: _(v.cvv),
      value: m.cvv,
      onChange: (C) => {
        x.onChange(C), d(za(Ya({}, m), {
          cvv: C
        }));
      },
      onBlur: () => {
        x.onBlur(), P("cvv", N);
      }
    })))
  }), !$ && /* @__PURE__ */ n.createElement(Je, {
    onClick: () => {
      t.onBindSubmit && t.onBindSubmit();
    },
    intro: !1,
    disabled: !y,
    isLoading: t == null ? void 0 : t.isSubmitting
  }));
};
var Zd = Object.defineProperty, Qd = Object.defineProperties, e_ = Object.getOwnPropertyDescriptors, Xa = Object.getOwnPropertySymbols, t_ = Object.prototype.hasOwnProperty, r_ = Object.prototype.propertyIsEnumerable, Ga = (t, e, r) => e in t ? Zd(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Ka = (t, e) => {
  for (var r in e || (e = {}))
    t_.call(e, r) && Ga(t, r, e[r]);
  if (Xa)
    for (var r of Xa(e))
      r_.call(e, r) && Ga(t, r, e[r]);
  return t;
}, Wa = (t, e) => Qd(t, e_(e));
const n_ = (t) => {
  const { onValidate: e, onSendEvent: r } = t, { t: a, getErrorText: o, isFlip: i } = I.useContext(), [l = {}, c] = Q(t), {
    control: s,
    getValues: p,
    formState: { errors: _, isValid: m, touchedFields: d }
  } = ce({
    mode: "all"
  }), f = de({
    touchedFields: d,
    errors: _
  }), g = (h, y) => {
    const u = {
      paymentMethodType: Hr.paymentMethodType.paymentMethodType,
      paymentMethod: Hr.paymentMethod.paymentMethod,
      paymentMethodId: Hr.paymentMethod.paymentMethodId
    };
    ie({
      event: "fp_sdk_checkout_fill_in",
      scenario: h,
      fieldState: y,
      getValues: p,
      onSendEvent: r,
      paymentMethodInfo: u
    });
  };
  return j(
    () => {
      c(l), e(m);
    },
    [l, m]
  ), /* @__PURE__ */ n.createElement("div", {
    className: "payment-ewallet-ovo",
    "data-sel": "pipo-mobile-payment-ewallet-ovo"
  }, /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, pattern: K.OVOIdRegex },
    name: "wallet_id",
    control: s,
    render: ({ field: h, fieldState: y }) => {
      var u;
      return /* @__PURE__ */ n.createElement("div", {
        className: "pl-4",
        style: i ? { marginRight: "44px" } : { marginLeft: "44px" }
      }, /* @__PURE__ */ n.createElement(Fe, Wa(Ka({}, h), {
        title: a("pipo_common_payin_phone_number"),
        footer: a("pipo_common_payin_ovo_id_append"),
        error: f.wallet_id,
        errorMessage: o(
          (u = f.wallet_id) == null ? void 0 : u.type,
          a("pipo_common_payin_ovo_id")
        ),
        placeholder: a("pipo_common_payin_ph_ovo_id"),
        addBefore: "08",
        minLength: 8,
        maxLength: 11,
        autoFocus: !0,
        value: l.wallet_id,
        onChange: (v) => {
          h.onChange(v), c(Wa(Ka({}, l), {
            wallet_id: v,
            storeCard: !0
          }));
        },
        onBlur: () => {
          h.onBlur(), g("wallet_id", y);
        }
      })));
    }
  }));
};
var a_ = Object.defineProperty, o_ = Object.defineProperties, l_ = Object.getOwnPropertyDescriptors, Ja = Object.getOwnPropertySymbols, i_ = Object.prototype.hasOwnProperty, s_ = Object.prototype.propertyIsEnumerable, Za = (t, e, r) => e in t ? a_(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, c_ = (t, e) => {
  for (var r in e || (e = {}))
    i_.call(e, r) && Za(t, r, e[r]);
  if (Ja)
    for (var r of Ja(e))
      s_.call(e, r) && Za(t, r, e[r]);
  return t;
}, p_ = (t, e) => o_(t, l_(e));
const Si = (t) => {
  const { onSendEvent: e } = t, { getErrorText: r, state: a, isFlip: o, t: i, noBindButton: l } = I.useContext(), { amount: c } = a, { onBindSubmit: s, isSubmitting: p } = t, _ = vt(), {
    control: m,
    formState: { errors: d },
    setValue: f,
    getValues: g
  } = _, { errors: h } = Br({
    control: m
  }), { countryOrRegion: y } = a, u = ue.list[y].code;
  f("phone_country_code", u);
  const v = (P, $) => {
    const x = {
      paymentMethodType: qr.paymentMethodType.paymentMethodType,
      paymentMethod: qr.paymentMethod.paymentMethod,
      paymentMethodId: qr.paymentMethod.paymentMethodId
    };
    ie({
      event: c != null && c.value ? "fp_sdk_checkout_fill_in" : "fp_sdk_checkout_pi_management_fill_in",
      scenario: P,
      fieldState: $,
      getValues: g,
      onSendEvent: e,
      paymentMethodInfo: x
    });
  };
  return /* @__PURE__ */ n.createElement("div", {
    className: "payment-ewallet-ovo-redirect"
  }, /* @__PURE__ */ n.createElement("div", {
    className: "payment-ewallet-ovo-redirect-form mb-24"
  }, !l && /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0 },
    name: "bind_required",
    control: m,
    render: (P) => /* @__PURE__ */ n.createElement("div", null)
  }), /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, pattern: K.OVOIdRegex },
    name: "phone",
    control: m,
    render: ({ field: P, fieldState: $ }) => {
      var x;
      return /* @__PURE__ */ n.createElement("div", {
        className: "pl-4",
        style: o ? { marginRight: "44px" } : { marginLeft: "44px" }
      }, /* @__PURE__ */ n.createElement(Fe, p_(c_({}, P), {
        title: i("pipo_common_payin_phone_number"),
        error: d.phone,
        errorMessage: r(
          (x = d.phone) == null ? void 0 : x.type,
          i("pipo_common_payin_ovo_id")
        ),
        placeholder: i("pipo_common_payin_ph_ovo_id"),
        addBefore: "08",
        minLength: 8,
        maxLength: 11,
        autoFocus: !0,
        onBlur: () => {
          P.onBlur(), v("phone", $);
        }
      })));
    }
  })), !l && /* @__PURE__ */ n.createElement(Je, {
    onClick: s,
    intro: !1,
    disabled: !gn({ items: ["phone"], errors: h, getValues: g }),
    isLoading: p
  }));
}, m_ = (t) => {
  const { setToExtend: e } = t, { t: r } = I.useContext();
  return j(
    () => (e(!0), function() {
      e(!1);
    }),
    []
  ), /* @__PURE__ */ n.createElement("div", {
    className: "payment-ewallet-ovo-expired"
  }, /* @__PURE__ */ n.createElement(fe, null), /* @__PURE__ */ n.createElement("div", {
    className: "payment-ewallet-ovo-expired-container flex mb-8 H4-Regular",
    style: { color: "#FF7D00" }
  }, /* @__PURE__ */ n.createElement("div", {
    className: "payment-ewallet-ovo-expired-icon mr-4 mt-10"
  }, /* @__PURE__ */ n.createElement(Rs, null)), /* @__PURE__ */ n.createElement("div", {
    className: "payment-ewallet-ovo-expired-text mt-8"
  }, /* @__PURE__ */ n.createElement("span", null, r("pipo_common_payin_PC_middlepage_ovo_token_subtitle") || "You need to input your OVO security PIN twice to refresh it."))));
}, d_ = () => {
  const { t } = I.useContext();
  return /* @__PURE__ */ n.createElement("div", {
    className: "payment-ewallet-balance-unsupported"
  }, /* @__PURE__ */ n.createElement(fe, null), /* @__PURE__ */ n.createElement("div", {
    className: "payment-ewallet-balance-unsupported-text P2-Regular mt-12"
  }, t("pipo_payin_state_cashier_rlp_token_notice") || "Please check you have sufficient funds for the purchase."));
};
var __ = Object.defineProperty, u_ = Object.defineProperties, y_ = Object.getOwnPropertyDescriptors, Qa = Object.getOwnPropertySymbols, h_ = Object.prototype.hasOwnProperty, f_ = Object.prototype.propertyIsEnumerable, eo = (t, e, r) => e in t ? __(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, v_ = (t, e) => {
  for (var r in e || (e = {}))
    h_.call(e, r) && eo(t, r, e[r]);
  if (Qa)
    for (var r of Qa(e))
      f_.call(e, r) && eo(t, r, e[r]);
  return t;
}, g_ = (t, e) => u_(t, y_(e));
const ki = (t) => {
  const {
    title: e,
    requestTitle: r,
    placeholder: a,
    error: o,
    errorMessage: i,
    cooldown: l,
    footer: c,
    minLength: s,
    maxLength: p = 11,
    autoFocus: _,
    disabled: m,
    onBlur: d,
    onClick: f
  } = t, [g, h] = cr(t);
  return /* @__PURE__ */ n.createElement(At, g_(v_({
    className: "pipo-mobile-verification-code-field"
  }, pr(t, ["error"])), {
    hasBottomBorder: !0,
    type: "number",
    value: g || "",
    clear: !1,
    disabled: !1,
    onChange: (y) => h(y.target.value),
    placeholder: a,
    title: e,
    hasError: Boolean(o),
    onClick: (y) => y.preventDefault(),
    end: /* @__PURE__ */ n.createElement("div", {
      onClick: () => {
        m || f();
      },
      style: {
        color: m ? "gray" : "rgb(255, 44, 85)"
      },
      className: "pipo-mobile-verification-code-field-button"
    }, r, " ", l && l > 0 ? `${l}s` : ""),
    errorMessage: i,
    maxLength: p,
    minLength: s,
    hasClearButton: !0,
    footer: c,
    autoFocus: _,
    onBlur: d
  }));
};
var E_ = Object.defineProperty, P_ = Object.defineProperties, b_ = Object.getOwnPropertyDescriptors, to = Object.getOwnPropertySymbols, x_ = Object.prototype.hasOwnProperty, M_ = Object.prototype.propertyIsEnumerable, ro = (t, e, r) => e in t ? E_(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, no = (t, e) => {
  for (var r in e || (e = {}))
    x_.call(e, r) && ro(t, r, e[r]);
  if (to)
    for (var r of to(e))
      M_.call(e, r) && ro(t, r, e[r]);
  return t;
}, ao = (t, e) => P_(t, b_(e));
const O_ = (t) => {
  const { onValidate: e, onSendEvent: r, onSendOTP: a, sendOtpDisabled: o } = t, [i = {}, l] = Q(
    t
  ), { t: c, getErrorText: s, isFlip: p } = I.useContext(), { seconds: _, start: m, reset: d } = ni(1e3 * 60), {
    control: f,
    getValues: g,
    formState: { errors: h, isValid: y, touchedFields: u }
  } = ce({
    mode: "all"
  });
  j(
    () => {
      l(i), e(y);
    },
    [i, y]
  ), j(
    () => {
      d(!0, 0);
    },
    []
  );
  const v = de({
    touchedFields: u,
    errors: h
  }), P = (x, N) => {
    const C = {
      paymentMethodType: jt.paymentMethodType.paymentMethodType,
      paymentMethod: jt.paymentMethod.paymentMethod,
      paymentMethodId: jt.paymentMethod.paymentMethodId
    };
    ie({
      event: "fp_sdk_checkout_fill_in",
      scenario: x,
      fieldState: N,
      getValues: g,
      onSendEvent: r,
      paymentMethodInfo: C
    });
  }, $ = parseInt(_) > 0 || o;
  return /* @__PURE__ */ n.createElement("div", {
    style: p ? { marginRight: "44px" } : { marginLeft: "44px" }
  }, /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, pattern: K.PaycellOTPRegex },
    name: "otp_code",
    control: f,
    render: ({ field: x, fieldState: N }) => {
      var C;
      return /* @__PURE__ */ n.createElement(ki, ao(no({}, x), {
        error: v.otp_code,
        value: i.otp_code,
        onChange: (M) => {
          x.onChange(M), l(ao(no({}, i), {
            otp_code: M
          }));
        },
        title: c("pipo_payin_state_cashier_otp_notice"),
        requestTitle: c("pipo_payin_state_cashier_otp_notice_retry"),
        placeholder: "123456",
        maxLength: 6,
        disabled: $,
        cooldown: parseInt(_),
        errorMessage: s(
          (C = v.otp_code) == null ? void 0 : C.type,
          c("pipo_payin_state_cashier_otp_notice")
        ),
        onBlur: () => {
          x.onBlur(), P("otp_code", N);
        },
        onClick: () => {
          a && a(), d(!0), m();
        }
      }));
    }
  }));
};
var C_ = Object.defineProperty, w_ = Object.defineProperties, $_ = Object.getOwnPropertyDescriptors, oo = Object.getOwnPropertySymbols, S_ = Object.prototype.hasOwnProperty, k_ = Object.prototype.propertyIsEnumerable, lo = (t, e, r) => e in t ? C_(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, io = (t, e) => {
  for (var r in e || (e = {}))
    S_.call(e, r) && lo(t, r, e[r]);
  if (oo)
    for (var r of oo(e))
      k_.call(e, r) && lo(t, r, e[r]);
  return t;
}, so = (t, e) => w_(t, $_(e));
const T_ = (t) => {
  const { onValidate: e, onSendEvent: r } = t, [a = {}, o] = Q(
    t
  ), { t: i, getErrorText: l, isFlip: c } = I.useContext(), {
    control: s,
    getValues: p,
    formState: { errors: _, isValid: m, touchedFields: d }
  } = ce({
    mode: "all"
  });
  j(
    () => {
      o(a), e(m);
    },
    [a, m]
  );
  const f = de({
    touchedFields: d,
    errors: _
  }), g = (h, y) => {
    const u = {
      paymentMethodType: Lt.paymentMethodType.paymentMethodType,
      paymentMethod: Lt.paymentMethod.paymentMethod,
      paymentMethodId: Lt.paymentMethod.paymentMethodId
    };
    ie({
      event: "fp_sdk_checkout_fill_in",
      scenario: h,
      fieldState: y,
      getValues: p,
      onSendEvent: r,
      paymentMethodInfo: u
    });
  };
  return /* @__PURE__ */ n.createElement("div", {
    style: c ? { marginRight: "44px" } : { marginLeft: "44px" }
  }, /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0 },
    name: "pin",
    control: s,
    render: ({ field: h, fieldState: y }) => {
      var u;
      return /* @__PURE__ */ n.createElement(Pi, so(io({}, h), {
        value: a.pin,
        onChange: (v) => {
          h.onChange(v), o(so(io({}, a), { pin: v }));
        },
        title: i("pipo_common_payin_password") || "Password",
        placeholder: i("pipo_common_payin_password") || "Password",
        error: f.pin || f.pin,
        errorMessage: l(
          (u = f.pin) == null ? void 0 : u.type,
          i("pipo_common_payin_password") || "Password"
        ),
        onBlur: () => {
          h.onBlur(), g("pin", y);
        }
      }));
    }
  }));
};
var I_ = Object.defineProperty, co = Object.getOwnPropertySymbols, N_ = Object.prototype.hasOwnProperty, B_ = Object.prototype.propertyIsEnumerable, po = (t, e, r) => e in t ? I_(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, ln = (t, e) => {
  for (var r in e || (e = {}))
    N_.call(e, r) && po(t, r, e[r]);
  if (co)
    for (var r of co(e))
      B_.call(e, r) && po(t, r, e[r]);
  return t;
};
const D_ = (t) => {
  const { item: e, setToExtend: r } = t;
  return e.paymentMethodType.paymentMethodType === "CCDC" ? /* @__PURE__ */ n.createElement($i, ln({}, t)) : e.paymentMethod.paymentMethodId === "pm_pi_ew_ovo_c_r" && e.isExpired ? /* @__PURE__ */ n.createElement(m_, {
    setToExtend: r
  }) : e.paymentMethod.paymentMethodId === "pm_pi_ew_rabbitlinepay_c_d" && !e.title && !e.balance ? /* @__PURE__ */ n.createElement(d_, null) : e.paymentMethod.paymentMethodId === "pm_pi_ew_paycell_c_d" ? /* @__PURE__ */ n.createElement(O_, ln({}, t)) : e.paymentMethod.paymentMethodId === "pm_pi_ew_todito_c_d" ? /* @__PURE__ */ n.createElement(T_, ln({}, t)) : null;
}, Ye = "pipo-checkout-payment-sub-item";
function mo(t) {
  const { item: e, onClick: r, isSelected: a, disabled: o, errorMsg: i } = t, { t: l, isFlip: c } = I.useContext(), s = !1, p = ae({
    [`${Ye}-disabled`]: o,
    [Ye]: !0,
    border: !0,
    "border-solid": !0,
    "border-color-LineSecondary": !0,
    "flex-wrap": !0,
    [`${Ye}-selected`]: a,
    "text-color-TextPrimary": !a,
    "text-color-Link": a,
    "border-color-Link": a
  });
  return /* @__PURE__ */ n.createElement("div", {
    className: p,
    onClick: () => {
      r == null || r();
    }
  }, /* @__PURE__ */ n.createElement(Cn, {
    src: e.paymentMethod.icon.iconUrl,
    className: ae(`${Ye}-icon `, {
      [`${Ye}-icon-isFlip`]: c,
      [`${Ye}-icon-des`]: s
    })
  }), /* @__PURE__ */ n.createElement("div", {
    className: ae(`${Ye}-text`, {
      [`${Ye}-text-class`]: s
    })
  }, /* @__PURE__ */ n.createElement("span", {
    className: ae("", {
      [`${Ye}-text-withdes`]: s
    })
  }, l(e.paymentMethod.starling_key) || e.paymentMethod.displayName), null), o && /* @__PURE__ */ n.createElement("div", {
    className: "flex w-full flex-shrink-0 P3-Regular"
  }, /* @__PURE__ */ n.createElement("div", {
    className: "w-40 ml-4 flex-shrink-0"
  }), /* @__PURE__ */ n.createElement("div", {
    className: "truncate text-color-TextPrimary"
  }, l(En(i)) || "NEED_I18N")), a ? /* @__PURE__ */ n.createElement("div", {
    className: `${Ye}-selected-icon`,
    style: c ? {
      left: 0,
      right: "unset",
      transform: "rotateY(180deg)"
    } : {}
  }, /* @__PURE__ */ n.createElement(ai, {
    className: `${Ye}-selected-icon-background`
  }), /* @__PURE__ */ n.createElement(oi, {
    className: `${Ye}-selected-icon-img`,
    style: c ? {
      right: -2,
      transform: "rotateY(180deg)"
    } : {}
  })) : null);
}
var V_ = Object.defineProperty, j_ = Object.defineProperties, L_ = Object.getOwnPropertyDescriptors, _o = Object.getOwnPropertySymbols, R_ = Object.prototype.hasOwnProperty, F_ = Object.prototype.propertyIsEnumerable, uo = (t, e, r) => e in t ? V_(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, yo = (t, e) => {
  for (var r in e || (e = {}))
    R_.call(e, r) && uo(t, r, e[r]);
  if (_o)
    for (var r of _o(e))
      F_.call(e, r) && uo(t, r, e[r]);
  return t;
}, ho = (t, e) => j_(t, L_(e));
const A_ = (t) => {
  const { onValidate: e, onSendEvent: r } = t, { t: a, getErrorText: o, isFlip: i } = I.useContext(), [l = {}, c] = Q(t), {
    control: s,
    getValues: p,
    formState: { errors: _, isValid: m, touchedFields: d }
  } = ce({
    mode: "all"
  }), f = de({
    touchedFields: d,
    errors: _
  });
  j(
    () => {
      c(l), e(m);
    },
    [l, m]
  );
  const g = (h, y) => {
    const u = {
      paymentMethodType: Ur.paymentMethodType.paymentMethodType,
      paymentMethod: Ur.paymentMethod.paymentMethod,
      paymentMethodId: Ur.paymentMethod.paymentMethodId
    };
    ie({
      event: "fp_sdk_checkout_fill_in",
      scenario: h,
      fieldState: y,
      getValues: p,
      onSendEvent: r,
      paymentMethodInfo: u
    });
  };
  return /* @__PURE__ */ n.createElement("div", {
    className: "payment-cash-dailyyamazaki"
  }, /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, pattern: K.emailRegex },
    name: "email",
    control: s,
    render: ({ field: h, fieldState: y }) => {
      var u;
      return /* @__PURE__ */ n.createElement("div", {
        className: "pl-4",
        style: i ? { marginRight: "44px" } : { marginLeft: "44px" }
      }, /* @__PURE__ */ n.createElement(Ae, ho(yo({}, h), {
        title: a("pipo_common_payin_Email"),
        placeholder: a("pipo_common_payin_ph_email"),
        error: f.email,
        errorMessage: o(
          (u = f.email) == null ? void 0 : u.type,
          a("pipo_common_payin_Email")
        ),
        footer: a("pipo_common_payin_conveniencestore_degicanotice"),
        value: l.email,
        onChange: (v) => {
          h.onChange(v), c(ho(yo({}, l), {
            email: v
          }));
        },
        onBlur: () => {
          h.onBlur(), g("email", y);
        }
      })));
    }
  }));
};
var H_ = Object.defineProperty, q_ = Object.defineProperties, U_ = Object.getOwnPropertyDescriptors, fo = Object.getOwnPropertySymbols, Y_ = Object.prototype.hasOwnProperty, z_ = Object.prototype.propertyIsEnumerable, vo = (t, e, r) => e in t ? H_(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, go = (t, e) => {
  for (var r in e || (e = {}))
    Y_.call(e, r) && vo(t, r, e[r]);
  if (fo)
    for (var r of fo(e))
      z_.call(e, r) && vo(t, r, e[r]);
  return t;
}, Eo = (t, e) => q_(t, U_(e));
const X_ = (t) => {
  const { onValidate: e, onSendEvent: r } = t, { t: a, getErrorText: o, isFlip: i } = I.useContext(), [l = {}, c] = Q(t), {
    control: s,
    getValues: p,
    formState: { errors: _, isValid: m, touchedFields: d }
  } = ce({
    mode: "all"
  }), f = de({
    touchedFields: d,
    errors: _
  }), g = (h, y) => {
    const u = {
      paymentMethodType: Yr.paymentMethodType.paymentMethodType,
      paymentMethod: Yr.paymentMethod.paymentMethod,
      paymentMethodId: Yr.paymentMethod.paymentMethodId
    };
    ie({
      event: "fp_sdk_checkout_fill_in",
      scenario: h,
      fieldState: y,
      getValues: p,
      onSendEvent: r,
      paymentMethodInfo: u
    });
  };
  return j(
    () => {
      c(l), e(m);
    },
    [l, m]
  ), /* @__PURE__ */ n.createElement("div", {
    className: "payment-cash-dailyyamazaki"
  }, /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, pattern: K.emailRegex },
    name: "email",
    control: s,
    render: ({ field: h, fieldState: y }) => {
      var u;
      return /* @__PURE__ */ n.createElement("div", {
        className: "pl-4",
        style: i ? { marginRight: "44px" } : { marginLeft: "44px" }
      }, /* @__PURE__ */ n.createElement(Ae, Eo(go({}, h), {
        title: a("pipo_common_payin_Email"),
        placeholder: a("pipo_common_payin_ph_email"),
        error: f.email,
        errorMessage: o(
          (u = f.email) == null ? void 0 : u.type,
          a("pipo_common_payin_Email")
        ),
        footer: a("pipo_common_payin_conveniencestore_degicanotice"),
        value: l.email,
        onChange: (v) => {
          h.onChange(v), c(Eo(go({}, l), {
            email: v
          }));
        },
        onBlur: () => {
          h.onBlur(), g("email", y);
        }
      })));
    }
  }));
};
var G_ = Object.defineProperty, K_ = Object.defineProperties, W_ = Object.getOwnPropertyDescriptors, Po = Object.getOwnPropertySymbols, J_ = Object.prototype.hasOwnProperty, Z_ = Object.prototype.propertyIsEnumerable, bo = (t, e, r) => e in t ? G_(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, xo = (t, e) => {
  for (var r in e || (e = {}))
    J_.call(e, r) && bo(t, r, e[r]);
  if (Po)
    for (var r of Po(e))
      Z_.call(e, r) && bo(t, r, e[r]);
  return t;
}, Mo = (t, e) => K_(t, W_(e));
const Q_ = (t) => {
  const { onValidate: e, onSendEvent: r } = t, { t: a, getErrorText: o, isFlip: i } = I.useContext(), [l = {}, c] = Q(t), {
    control: s,
    getValues: p,
    formState: { errors: _, isValid: m, touchedFields: d }
  } = ce({
    mode: "all"
  }), f = de({
    touchedFields: d,
    errors: _
  });
  j(
    () => {
      c(l), e(m);
    },
    [l, m]
  );
  const g = (h, y) => {
    const u = {
      paymentMethodType: zr.paymentMethodType.paymentMethodType,
      paymentMethod: zr.paymentMethod.paymentMethod,
      paymentMethodId: zr.paymentMethod.paymentMethodId
    };
    ie({
      event: "fp_sdk_checkout_fill_in",
      scenario: h,
      fieldState: y,
      getValues: p,
      onSendEvent: r,
      paymentMethodInfo: u
    });
  };
  return /* @__PURE__ */ n.createElement("div", {
    className: "payment-cash-dailyyamazaki"
  }, /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, pattern: K.emailRegex },
    name: "email",
    control: s,
    render: ({ field: h, fieldState: y }) => {
      var u;
      return /* @__PURE__ */ n.createElement("div", {
        className: "pl-4",
        style: i ? { marginRight: "44px" } : { marginLeft: "44px" }
      }, /* @__PURE__ */ n.createElement(Ae, Mo(xo({}, h), {
        title: a("pipo_common_payin_Email"),
        placeholder: a("pipo_common_payin_ph_email"),
        error: f.email,
        errorMessage: o(
          (u = f.email) == null ? void 0 : u.type,
          a("pipo_common_payin_Email")
        ),
        footer: a("pipo_common_payin_conveniencestore_degicanotice"),
        value: l.email,
        onChange: (v) => {
          h.onChange(v), c(Mo(xo({}, l), {
            email: v
          }));
        },
        onBlur: () => {
          h.onBlur(), g("email", y);
        }
      })));
    }
  }));
};
var eu = Object.defineProperty, tu = Object.defineProperties, ru = Object.getOwnPropertyDescriptors, Oo = Object.getOwnPropertySymbols, nu = Object.prototype.hasOwnProperty, au = Object.prototype.propertyIsEnumerable, Co = (t, e, r) => e in t ? eu(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, wo = (t, e) => {
  for (var r in e || (e = {}))
    nu.call(e, r) && Co(t, r, e[r]);
  if (Oo)
    for (var r of Oo(e))
      au.call(e, r) && Co(t, r, e[r]);
  return t;
}, $o = (t, e) => tu(t, ru(e));
const ou = (t) => {
  const { onValidate: e, onSendEvent: r } = t, { t: a, getErrorText: o, isFlip: i } = I.useContext(), [l = {}, c] = Q(t), {
    control: s,
    getValues: p,
    formState: { errors: _, isValid: m, touchedFields: d }
  } = ce({
    mode: "all"
  }), f = de({
    touchedFields: d,
    errors: _
  });
  j(
    () => {
      c(l), e(m);
    },
    [l, m]
  );
  const g = (h, y) => {
    const u = {
      paymentMethodType: Xr.paymentMethodType.paymentMethodType,
      paymentMethod: Xr.paymentMethod.paymentMethod,
      paymentMethodId: Xr.paymentMethod.paymentMethodId
    };
    ie({
      event: "fp_sdk_checkout_fill_in",
      scenario: h,
      fieldState: y,
      getValues: p,
      onSendEvent: r,
      paymentMethodInfo: u
    });
  };
  return /* @__PURE__ */ n.createElement("div", {
    className: "payment-cash-dailyyamazaki"
  }, /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, pattern: K.emailRegex },
    name: "email",
    control: s,
    render: ({ field: h, fieldState: y }) => {
      var u;
      return /* @__PURE__ */ n.createElement("div", {
        className: "pl-4",
        style: i ? { marginRight: "44px" } : { marginLeft: "44px" }
      }, /* @__PURE__ */ n.createElement(Ae, $o(wo({}, h), {
        title: a("pipo_common_payin_Email"),
        placeholder: a("pipo_common_payin_ph_email"),
        error: f.email,
        errorMessage: o(
          (u = f.email) == null ? void 0 : u.type,
          a("pipo_common_payin_Email")
        ),
        footer: a("pipo_common_payin_conveniencestore_degicanotice"),
        value: l.email,
        onChange: (v) => {
          h.onChange(v), c($o(wo({}, l), {
            email: v
          }));
        },
        onBlur: () => {
          h.onBlur(), g("email", y);
        }
      })));
    }
  }));
};
var lu = Object.defineProperty, iu = Object.defineProperties, su = Object.getOwnPropertyDescriptors, So = Object.getOwnPropertySymbols, cu = Object.prototype.hasOwnProperty, pu = Object.prototype.propertyIsEnumerable, ko = (t, e, r) => e in t ? lu(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, To = (t, e) => {
  for (var r in e || (e = {}))
    cu.call(e, r) && ko(t, r, e[r]);
  if (So)
    for (var r of So(e))
      pu.call(e, r) && ko(t, r, e[r]);
  return t;
}, Io = (t, e) => iu(t, su(e));
const mu = (t) => {
  const { onValidate: e, onSendEvent: r } = t, { t: a, getErrorText: o, isFlip: i } = I.useContext(), [l = {}, c] = Q(t), {
    control: s,
    getValues: p,
    formState: { errors: _, isValid: m, touchedFields: d }
  } = ce({
    mode: "all"
  }), f = de({
    touchedFields: d,
    errors: _
  }), g = (h, y) => {
    const u = {
      paymentMethodType: Gr.paymentMethodType.paymentMethodType,
      paymentMethod: Gr.paymentMethod.paymentMethod,
      paymentMethodId: Gr.paymentMethod.paymentMethodId
    };
    ie({
      event: "fp_sdk_checkout_fill_in",
      scenario: h,
      fieldState: y,
      getValues: p,
      onSendEvent: r,
      paymentMethodInfo: u
    });
  };
  return j(
    () => {
      c(l), e(m);
    },
    [l, m]
  ), /* @__PURE__ */ n.createElement("div", {
    className: "payment-cash-dailyyamazaki"
  }, /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, pattern: K.emailRegex },
    name: "email",
    control: s,
    render: ({ field: h, fieldState: y }) => {
      var u;
      return /* @__PURE__ */ n.createElement("div", {
        className: "pl-4",
        style: i ? { marginRight: "44px" } : { marginLeft: "44px" }
      }, /* @__PURE__ */ n.createElement(Ae, Io(To({}, h), {
        title: a("pipo_common_payin_Email"),
        placeholder: a("pipo_common_payin_ph_email"),
        error: f.email,
        errorMessage: o(
          (u = f.email) == null ? void 0 : u.type,
          a("pipo_common_payin_Email")
        ),
        footer: a("pipo_common_payin_conveniencestore_degicanotice"),
        value: l.email,
        onChange: (v) => {
          h.onChange(v), c(Io(To({}, l), {
            email: v
          }));
        },
        onBlur: () => {
          h.onBlur(), g("email", y);
        }
      })));
    }
  }));
};
var du = Object.defineProperty, _u = Object.defineProperties, uu = Object.getOwnPropertyDescriptors, No = Object.getOwnPropertySymbols, yu = Object.prototype.hasOwnProperty, hu = Object.prototype.propertyIsEnumerable, Bo = (t, e, r) => e in t ? du(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Do = (t, e) => {
  for (var r in e || (e = {}))
    yu.call(e, r) && Bo(t, r, e[r]);
  if (No)
    for (var r of No(e))
      hu.call(e, r) && Bo(t, r, e[r]);
  return t;
}, Vo = (t, e) => _u(t, uu(e));
const fu = (t) => {
  const { onValidate: e, onSendEvent: r } = t, { t: a, getErrorText: o, isFlip: i } = I.useContext(), [l = {}, c] = Q(t), {
    control: s,
    getValues: p,
    formState: { errors: _, isValid: m, touchedFields: d }
  } = ce({
    mode: "all"
  }), f = de({
    touchedFields: d,
    errors: _
  });
  j(
    () => {
      c(l), e(m);
    },
    [l, m]
  );
  const g = (h, y) => {
    const u = {
      paymentMethodType: Kr.paymentMethodType.paymentMethodType,
      paymentMethod: Kr.paymentMethod.paymentMethod,
      paymentMethodId: Kr.paymentMethod.paymentMethodId
    };
    ie({
      event: "fp_sdk_checkout_fill_in",
      scenario: h,
      fieldState: y,
      getValues: p,
      onSendEvent: r,
      paymentMethodInfo: u
    });
  };
  return /* @__PURE__ */ n.createElement("div", {
    className: "payment-cash-dailyyamazaki"
  }, /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, pattern: K.emailRegex },
    name: "email",
    control: s,
    render: ({ field: h, fieldState: y }) => {
      var u;
      return /* @__PURE__ */ n.createElement("div", {
        className: "pl-4",
        style: i ? { marginRight: "44px" } : { marginLeft: "44px" }
      }, /* @__PURE__ */ n.createElement(Ae, Vo(Do({}, h), {
        title: a("pipo_common_payin_Email"),
        placeholder: a("pipo_common_payin_ph_email"),
        error: f.email,
        errorMessage: o(
          (u = f.email) == null ? void 0 : u.type,
          a("pipo_common_payin_Email")
        ),
        footer: a("pipo_common_payin_conveniencestore_degicanotice"),
        value: l.email,
        onChange: (v) => {
          h.onChange(v), c(Vo(Do({}, l), {
            email: v
          }));
        },
        onBlur: () => {
          h.onBlur(), g("email", y);
        }
      })));
    }
  }));
};
var vu = Object.defineProperty, gu = Object.defineProperties, Eu = Object.getOwnPropertyDescriptors, $r = Object.getOwnPropertySymbols, Ti = Object.prototype.hasOwnProperty, Ii = Object.prototype.propertyIsEnumerable, jo = (t, e, r) => e in t ? vu(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Mt = (t, e) => {
  for (var r in e || (e = {}))
    Ti.call(e, r) && jo(t, r, e[r]);
  if ($r)
    for (var r of $r(e))
      Ii.call(e, r) && jo(t, r, e[r]);
  return t;
}, Ot = (t, e) => gu(t, Eu(e)), Pu = (t, e) => {
  var r = {};
  for (var a in t)
    Ti.call(t, a) && e.indexOf(a) < 0 && (r[a] = t[a]);
  if (t != null && $r)
    for (var a of $r(t))
      e.indexOf(a) < 0 && Ii.call(t, a) && (r[a] = t[a]);
  return r;
};
const bu = (t) => {
  var e, r;
  const { state: a, getErrorText: o, t: i, useOldEvent: l } = I.useContext(), { onValidate: c, onSendEvent: s } = t, { countryOrRegion: p } = a, [_ = {}, m] = cr(t), {
    control: d,
    getValues: f,
    formState: { errors: g, isValid: h, touchedFields: y }
  } = ce({
    mode: "all"
  }), u = de({
    touchedFields: y,
    errors: g
  }), v = ue.list[p].code, P = (r = (e = ue.list[p]) == null ? void 0 : e.phone) == null ? void 0 : r.pattern, $ = Ne(
    () => {
      const C = _, { storeCard: M = !1 } = C, b = Pu(C, ["storeCard"]), E = Dr(
        b,
        ts
      ), { paymentMethodType: O, paymentMethod: T } = _r;
      m(_, {
        formData: b,
        paymentMethod: {
          paymentMethod: T.paymentMethod,
          paymentMethodId: T.paymentMethodId
        },
        paymentMethodType: O.paymentMethodType,
        paymentParams: E,
        storeCard: M
      });
    },
    [_]
  );
  j(
    () => {
      $(), c(h);
    },
    [_, h]
  );
  const x = (C, M) => {
    const b = {
      paymentMethodType: _r.paymentMethodType.paymentMethodType,
      paymentMethod: _r.paymentMethod.paymentMethod,
      paymentMethodId: _r.paymentMethod.paymentMethodId
    };
    ie({
      event: "fp_sdk_checkout_fill_in",
      scenario: C,
      fieldState: M,
      getValues: f,
      onSendEvent: s,
      paymentMethodInfo: b
    });
  }, N = (C) => {
    s && (s({
      name: "fp_sdk_checkout_dropin_element_click",
      categories: {
        click_scenario: C ? "save_for_next_time" : "unsave_for_next_time"
      }
    }), l && s({
      name: "fp_sdk_checkout_page_click",
      categories: {
        click_method: C ? "save_for_next_time" : "unsave_for_next_time"
      }
    }));
  };
  return /* @__PURE__ */ n.createElement("div", {
    className: "payment-cash-oxxo w-full"
  }, /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, pattern: K.nameRegex },
    name: "holder_name",
    control: d,
    render: ({ field: C, fieldState: M }) => {
      var b;
      return /* @__PURE__ */ n.createElement(we, Ot(Mt({}, C), {
        error: u.holder_name,
        errorMessage: o(
          (b = u.holder_name) == null ? void 0 : b.type,
          i("pipo_common_payin_boleto_name")
        ),
        title: i("pipo_common_payin_boleto_name"),
        placeholder: i("pipo_common_payin_boleto_name"),
        value: _.holder_name,
        onChange: (E) => {
          C.onChange(E), m(Ot(Mt({}, _), { holder_name: E }));
        },
        onBlur: () => {
          C.onBlur(), x("holder_name", M);
        }
      }));
    }
  }), /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, pattern: K.emailRegex },
    name: "email",
    control: d,
    render: ({ field: C, fieldState: M }) => {
      var b;
      return /* @__PURE__ */ n.createElement(Ae, Ot(Mt({}, C), {
        title: i("pipo_common_payin_Email"),
        placeholder: i("pipo_common_payin_ph_email"),
        error: u.email,
        errorMessage: o(
          (b = u.email) == null ? void 0 : b.type,
          i("pipo_common_payin_Email")
        ),
        value: _.email,
        onChange: (E) => {
          C.onChange(E), m(Ot(Mt({}, _), { email: E }));
        },
        onBlur: () => {
          C.onBlur(), x("email", M);
        }
      }));
    }
  }), /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0 },
    name: "phone_country_code",
    control: d,
    render: ({ field: C }) => /* @__PURE__ */ n.createElement(pt, {
      countryCode: v,
      onChange: (M) => {
        C.onChange(M);
      }
    })
  }), /* @__PURE__ */ n.createElement(k, {
    rules: {
      required: !0,
      pattern: P
    },
    name: "phone",
    control: d,
    render: ({ field: C, fieldState: M }) => {
      var b;
      return /* @__PURE__ */ n.createElement(Fe, Ot(Mt({}, C), {
        title: i("pipo_common_payin_phone_number"),
        placeholder: i("pipo_common_payin_ph_phone_number"),
        error: u.phone,
        errorMessage: o(
          (b = u.phone) == null ? void 0 : b.type,
          i("pipo_common_payin_phone_number")
        ),
        maxLength: 10,
        countryCode: v,
        countryOrRegion: p,
        value: _.phone,
        onChange: (E, O) => {
          C.onChange(E), m(Ot(Mt({}, _), {
            phone: E,
            phone_country_code: O
          }));
        },
        onBlur: () => {
          C.onBlur(), x("phone", M);
        }
      }));
    }
  }), /* @__PURE__ */ n.createElement(mt, {
    title: i("pipo_common_payin_save_paymentmethod", {
      value: i("pipo_payin_cashier_dropin_payment_OXXO")
    }),
    value: _.storeCard,
    onChange: (C) => {
      m(Ot(Mt({}, _), { storeCard: C })), N(C);
    }
  }));
}, ir = ({ children: t }) => /* @__PURE__ */ n.createElement("div", {
  className: "flex"
}, /* @__PURE__ */ n.createElement("div", {
  className: "flex-shrink-0 w-40 ml-4"
}), t);
var xu = Object.defineProperty, Lo = Object.getOwnPropertySymbols, Mu = Object.prototype.hasOwnProperty, Ou = Object.prototype.propertyIsEnumerable, Ro = (t, e, r) => e in t ? xu(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, _t = (t, e) => {
  for (var r in e || (e = {}))
    Mu.call(e, r) && Ro(t, r, e[r]);
  if (Lo)
    for (var r of Lo(e))
      Ou.call(e, r) && Ro(t, r, e[r]);
  return t;
};
const Cu = (t) => {
  const { item: e, selected: r, onSelect: a } = t, { subPaymentMethodList: o = [], subUnavailablePaymentMethodList: i = [] } = e, { isFlip: l } = I.useContext(), c = ge(() => o.filter((_) => _), [o]), s = ge(
    () => {
      var _;
      switch ((_ = r == null ? void 0 : r[0]) == null ? void 0 : _.paymentMethod.paymentMethodId) {
        case "pm_pi_cp_dailyyamazaki_c_d":
          return /* @__PURE__ */ n.createElement(A_, _t({}, t));
        case "pm_pi_cp_seveneleven_c_d":
          return /* @__PURE__ */ n.createElement(X_, _t({}, t));
        case "pm_pi_cp_lawson_c_d":
          return /* @__PURE__ */ n.createElement(Q_, _t({}, t));
        case "pm_pi_cp_ministop_c_d":
          return /* @__PURE__ */ n.createElement(ou, _t({}, t));
        case "pm_pi_cp_seicomart_c_d":
          return /* @__PURE__ */ n.createElement(mu, _t({}, t));
        case "pm_pi_cp_familymart_c_d":
          return /* @__PURE__ */ n.createElement(fu, _t({}, t));
        case "pm_pi_cp_oxxo_c_d":
          return /* @__PURE__ */ n.createElement(ir, null, /* @__PURE__ */ n.createElement(bu, _t({}, t)));
        case "pm_pi_cp_boleto_c_d":
          return /* @__PURE__ */ n.createElement(ir, null, /* @__PURE__ */ n.createElement(In, _t({}, t)));
      }
      return null;
    },
    [c, r, a]
  ), p = c.length > 0 || Boolean(s);
  return /* @__PURE__ */ n.createElement("div", null, p && /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("div", {
    style: l ? { marginRight: "44px" } : { marginLeft: "44px" }
  }, /* @__PURE__ */ n.createElement(fe, null)), /* @__PURE__ */ n.createElement(wu, {
    cashListData: c,
    subUnavailablePaymentMethodList: i,
    selectedObj: r,
    onSelect: a
  }), s), p ? /* @__PURE__ */ n.createElement("div", {
    style: l ? { marginRight: "44px" } : { marginLeft: "44px" }
  }, /* @__PURE__ */ n.createElement(fe, null)) : /* @__PURE__ */ n.createElement(fe, null));
}, wu = (t) => {
  const {
    cashListData: e,
    subUnavailablePaymentMethodList: r = [],
    selectedObj: a,
    onSelect: o
  } = t, { isFlip: i } = I.useContext();
  return /* @__PURE__ */ n.createElement("div", {
    className: "py-2 pipo-checkout-payment-sub-item-container",
    style: i ? { marginRight: "44px" } : { marginLeft: "44px" }
  }, e.map((l, c) => {
    var s, p;
    const _ = ((p = (s = a == null ? void 0 : a[0]) == null ? void 0 : s.paymentMethod) == null ? void 0 : p.paymentMethodId) === l.paymentMethod.paymentMethodId;
    return /* @__PURE__ */ n.createElement(mo, {
      key: c,
      item: l,
      isSelected: _,
      onClick: () => {
        o(l);
      }
    });
  }), r.map((l) => /* @__PURE__ */ n.createElement(mo, {
    key: l.paymentMethod.paymentMethodId,
    item: l,
    isSelected: !1,
    onClick: () => {
    },
    disabled: !0,
    errorMsg: l.unavailableErrorCode
  })));
}, ze = "pipo-checkout-payment-bank-item";
function Sr(t) {
  const { title: e, iconUrl: r, onClick: a, isSelected: o, disabled: i, errorMsg: l } = t, { isFlip: c, t: s } = I.useContext(), p = !1, _ = ae({
    [ze]: !0,
    border: !0,
    "border-solid": !0,
    "border-color-LineSecondary": !0,
    "flex-wrap": !0,
    [`${ze}-selected`]: o,
    [`${ze}-disabled`]: i,
    "text-color-TextPrimary": !o,
    "text-color-Link": o,
    "border-color-Link": o
  });
  return /* @__PURE__ */ n.createElement("div", {
    className: _,
    onClick: () => {
      a == null || a();
    }
  }, /* @__PURE__ */ n.createElement(Cn, {
    src: r,
    className: ae(`${ze}-icon`, {
      [`${ze}-icon-isFlip`]: c,
      [`${ze}-icon-des`]: p
    })
  }), /* @__PURE__ */ n.createElement("div", {
    className: ae(`${ze}-text`, {
      [`${ze}-text-class`]: p
    })
  }, /* @__PURE__ */ n.createElement("span", {
    className: ae("", {
      [`${ze}-text-withdes`]: p
    })
  }, e), null), i && /* @__PURE__ */ n.createElement("div", {
    className: "flex w-full flex-shrink-0 P3-Regular"
  }, /* @__PURE__ */ n.createElement("div", {
    className: "w-40 ml-4 flex-shrink-0"
  }), /* @__PURE__ */ n.createElement("div", {
    className: "truncate text-color-TextPrimary"
  }, s(En(l)) || "NEED_I18N")), o ? /* @__PURE__ */ n.createElement("div", {
    className: `${ze}-selected-icon`,
    style: c ? {
      left: 0,
      right: "unset",
      transform: "rotateY(180deg)"
    } : {}
  }, /* @__PURE__ */ n.createElement(ai, {
    className: `${ze}-selected-icon-background`
  }), /* @__PURE__ */ n.createElement(oi, {
    className: `${ze}-selected-icon-img`,
    style: c ? {
      right: -2,
      transform: "rotateY(180deg)"
    } : {}
  })) : null);
}
var $u = Object.defineProperty, Su = Object.defineProperties, ku = Object.getOwnPropertyDescriptors, Fo = Object.getOwnPropertySymbols, Tu = Object.prototype.hasOwnProperty, Iu = Object.prototype.propertyIsEnumerable, Ao = (t, e, r) => e in t ? $u(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Nu = (t, e) => {
  for (var r in e || (e = {}))
    Tu.call(e, r) && Ao(t, r, e[r]);
  if (Fo)
    for (var r of Fo(e))
      Iu.call(e, r) && Ao(t, r, e[r]);
  return t;
}, Bu = (t, e) => Su(t, ku(e));
const Du = (t) => {
  const { item: e, onSelect: r, onSendEvent: a } = t, { elements: o = [] } = e, [i = {}, l] = cr(t), { control: c } = ce({
    mode: "all"
  }), { isFlip: s, useOldEvent: p } = I.useContext(), _ = (d) => {
    d !== i.bank_code && (a && (a({
      name: "fp_sdk_checkout_dropin_element_click",
      categories: {
        click_scenario: "choose_sec_pi",
        payment_type: e.paymentMethodType.paymentMethodType,
        payment_method: e.paymentMethod.paymentMethod,
        bank_code: d,
        payment_method_id: e.paymentMethod.paymentMethodId
      }
    }), p && a({
      name: "fp_sdk_checkout_page_click",
      categories: {
        click_method: "sec_pi_choose",
        pi_type_1: e.paymentMethodType.paymentMethodType,
        pi_type_2: e.paymentMethod.paymentMethod,
        pi_type_3: d,
        pm_id: e.paymentMethod.paymentMethodId
      }
    })), r(e, d));
  }, m = ge(() => o.map((d) => un[d]).filter((d) => d), [o]);
  return j(
    () => {
      l(i);
    },
    [i]
  ), /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", {
    style: s ? { marginRight: "44px" } : { marginLeft: "44px" }
  }, /* @__PURE__ */ n.createElement(fe, null)), /* @__PURE__ */ n.createElement(k, {
    name: "bank_code",
    control: c,
    render: ({ field: d }) => /* @__PURE__ */ n.createElement(Vu, Bu(Nu({}, d), {
      value: i.bank_code,
      onChange: (f) => {
        d.onChange(f), l({ bank_code: f });
      },
      onSelect: _,
      bankListData: m
    }))
  }), /* @__PURE__ */ n.createElement("div", {
    style: s ? { marginRight: "44px" } : { marginLeft: "44px" }
  }, /* @__PURE__ */ n.createElement(fe, null)));
}, Vu = (t) => {
  const { bankListData: e, onSelect: r } = t, [a, o] = cr(t), { t: i, isFlip: l } = I.useContext();
  return j(() => {
    e.length && !a && o(e[0].bankCode);
  }, [o, a, e]), j(
    () => {
      r(e[0].bankCode);
    },
    [e]
  ), /* @__PURE__ */ n.createElement("div", {
    className: "py-2",
    style: l ? { marginRight: "44px" } : { marginLeft: "44px" }
  }, e.map((c) => /* @__PURE__ */ n.createElement(Sr, {
    onClick: () => {
      o(c.bankCode), r(c.bankCode);
    },
    isSelected: c.bankCode === a,
    value: c.bankCode,
    key: c.bankCode,
    iconUrl: c.icon.iconUrl,
    title: i(c.i18nKey) || c.name
  })));
};
var ju = Object.defineProperty, Lu = Object.defineProperties, Ru = Object.getOwnPropertyDescriptors, Ho = Object.getOwnPropertySymbols, Fu = Object.prototype.hasOwnProperty, Au = Object.prototype.propertyIsEnumerable, qo = (t, e, r) => e in t ? ju(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, De = (t, e) => {
  for (var r in e || (e = {}))
    Fu.call(e, r) && qo(t, r, e[r]);
  if (Ho)
    for (var r of Ho(e))
      Au.call(e, r) && qo(t, r, e[r]);
  return t;
}, Ve = (t, e) => Lu(t, Ru(e));
const Hu = (t) => {
  var e;
  const { onValidate: r, onSendEvent: a } = t, [o = {}, i] = Q(t), {
    control: l,
    getValues: c,
    formState: { errors: s, isValid: p, touchedFields: _ }
  } = ce({
    mode: "all"
  }), m = de({
    touchedFields: _,
    errors: s
  }), { t: d, getErrorText: f, state: g, isFlip: h } = I.useContext(), { countryOrRegion: y } = g, u = (e = ue.list[y]) == null ? void 0 : e.code, { phone: v = {} } = ue.list[y], {
    pattern: P,
    minLength: $,
    maxLength: x
  } = v, N = (b, E) => b === "required" ? f(b, E) : f(b, d("pipo_common_payin_error_invalid")), C = Ne(
    () => {
      const b = o.holder_first_name_katakana ? String(o.holder_first_name_katakana) : "", E = o.holder_last_name_katakana ? String(o.holder_last_name_katakana) : "", O = `${b} ${E}`;
      O !== o.holder_name && i(Ve(De({}, o), { holder_name: O }));
    },
    [o]
  ), M = (b, E) => {
    const O = {
      paymentMethodType: ct.paymentMethodType.paymentMethodType,
      paymentMethod: ct.paymentMethod.paymentMethod,
      paymentMethodId: ct.paymentMethod.paymentMethodId
    };
    ie({
      event: "fp_sdk_checkout_fill_in",
      scenario: b,
      fieldState: E,
      getValues: c,
      onSendEvent: a,
      paymentMethodInfo: O
    });
  };
  return j(
    () => {
      C(), r(p);
    },
    [o, p]
  ), /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", {
    style: h ? { marginRight: "44px" } : { marginLeft: "44px" }
  }, /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, pattern: K.emailRegex },
    name: "email",
    control: l,
    render: ({ field: b, fieldState: E }) => {
      var O;
      return /* @__PURE__ */ n.createElement(Ae, Ve(De({}, b), {
        title: d("pipo_common_payin_Email"),
        value: o.email,
        onChange: (T) => {
          b.onChange(T), i(Ve(De({}, o), { email: T }));
        },
        placeholder: d("pipo_common_payin_ph_email"),
        error: m.email,
        errorMessage: f(
          (O = m.email) == null ? void 0 : O.type,
          d("pipo_common_payin_Email")
        ),
        onBlur: () => {
          b.onBlur(), M("email", E);
        }
      }));
    }
  }), /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0 },
    name: "phone_country_code",
    control: l,
    render: ({ field: b }) => /* @__PURE__ */ n.createElement(pt, {
      countryCode: u,
      onChange: (E) => {
        b.onChange(E);
      }
    })
  }), /* @__PURE__ */ n.createElement(k, {
    rules: {
      required: !0,
      pattern: P
    },
    name: "phone",
    control: l,
    render: ({ field: b, fieldState: E }) => {
      var O;
      return /* @__PURE__ */ n.createElement(Fe, Ve(De({}, b), {
        title: d("pipo_common_payin_phone_number"),
        placeholder: d("pipo_common_payin_ph_phone_number"),
        error: m.phone,
        errorMessage: f(
          (O = m.phone) == null ? void 0 : O.type,
          d("pipo_common_payin_phone_number")
        ),
        countryCode: u,
        countryOrRegion: y,
        value: o.phone,
        onChange: (T, W) => {
          b.onChange(T), i(Ve(De({}, o), {
            phone: T,
            phone_country_code: W
          }));
        },
        onBlur: () => {
          b.onBlur(), M("phone", E);
        },
        maxLength: x,
        minLength: $
      }));
    }
  }), /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, pattern: K.RomajiNameRegex },
    name: "holder_first_name",
    control: l,
    render: ({ field: b, fieldState: E }) => {
      var O;
      return /* @__PURE__ */ n.createElement(we, Ve(De({}, b), {
        value: o.holder_first_name,
        onChange: (T) => {
          b.onChange(T), i(Ve(De({}, o), { holder_first_name: T }));
        },
        error: m.holder_first_name,
        errorMessage: N(
          (O = m.holder_first_name) == null ? void 0 : O.type,
          d("pipo_common_payin_firstname")
        ),
        maxLength: 255,
        title: d("pipo_common_payin_firstname"),
        placeholder: d("pipo_common_payin_firstname_romaji"),
        onBlur: () => {
          b.onBlur(), M("holder_first_name", E);
        }
      }));
    }
  }), /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, pattern: K.KatakanaNameRegex },
    name: "holder_first_name_katakana",
    control: l,
    render: ({ field: b, fieldState: E }) => {
      var O;
      return /* @__PURE__ */ n.createElement(we, Ve(De({}, b), {
        value: o.holder_first_name_katakana,
        onChange: (T) => {
          b.onChange(T), i(Ve(De({}, o), { holder_first_name_katakana: T }));
        },
        maxLength: 255,
        error: m.holder_first_name_katakana,
        errorMessage: N(
          (O = m.holder_first_name_katakana) == null ? void 0 : O.type,
          d("pipo_common_payin_error_katakana_firstname")
        ),
        placeholder: d("pipo_common_payin_firstname_katakana"),
        onBlur: () => {
          b.onBlur(), M("holder_first_name_katakana", E);
        }
      }));
    }
  }), /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, pattern: K.RomajiNameRegex },
    name: "holder_last_name",
    control: l,
    render: ({ field: b, fieldState: E }) => {
      var O;
      return /* @__PURE__ */ n.createElement(we, Ve(De({}, b), {
        value: o.holder_last_name,
        onChange: (T) => {
          b.onChange(T), i(Ve(De({}, o), { holder_last_name: T }));
        },
        error: m.holder_last_name,
        errorMessage: N(
          (O = m.holder_last_name) == null ? void 0 : O.type,
          d("pipo_common_payin_lastname")
        ),
        maxLength: 255,
        title: d("pipo_common_payin_lastname"),
        placeholder: d("pipo_common_payin_firstname_romaji"),
        onBlur: () => {
          b.onBlur(), M("holder_last_name", E);
        }
      }));
    }
  }), /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, pattern: K.KatakanaNameRegex },
    name: "holder_last_name_katakana",
    control: l,
    render: ({ field: b, fieldState: E }) => {
      var O;
      return /* @__PURE__ */ n.createElement(we, Ve(De({}, b), {
        value: o.holder_last_name_katakana,
        onChange: (T) => {
          b.onChange(T), i(Ve(De({}, o), { holder_last_name_katakana: T }));
        },
        error: m.holder_last_name_katakana,
        errorMessage: N(
          (O = m.holder_last_name_katakana) == null ? void 0 : O.type,
          d("pipo_common_payin_error_katakana_lastname")
        ),
        maxLength: 255,
        placeholder: d("pipo_common_payin_firstname_katakana"),
        onBlur: () => {
          b.onBlur(), M("holder_last_name_katakana", E);
        }
      }));
    }
  })));
};
var qu = Object.defineProperty, Uu = Object.defineProperties, Yu = Object.getOwnPropertyDescriptors, Uo = Object.getOwnPropertySymbols, zu = Object.prototype.hasOwnProperty, Xu = Object.prototype.propertyIsEnumerable, Yo = (t, e, r) => e in t ? qu(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, ut = (t, e) => {
  for (var r in e || (e = {}))
    zu.call(e, r) && Yo(t, r, e[r]);
  if (Uo)
    for (var r of Uo(e))
      Xu.call(e, r) && Yo(t, r, e[r]);
  return t;
}, yt = (t, e) => Uu(t, Yu(e));
const Gu = (t) => {
  const { onValidate: e, onSendEvent: r } = t, [a = {}, o] = Q(t), i = n.createRef(), {
    control: l,
    getValues: c,
    formState: { errors: s, isValid: p, touchedFields: _ }
  } = ce({
    mode: "all"
  }), m = de({
    touchedFields: _,
    errors: s
  }), { t: d, getErrorText: f, isFlip: g } = I.useContext(), h = (y, u) => {
    const v = {
      paymentMethodType: ct.paymentMethodType.paymentMethodType,
      paymentMethod: ct.paymentMethod.paymentMethod,
      paymentMethodId: ct.paymentMethod.paymentMethodId
    };
    ie({
      event: "fp_sdk_checkout_fill_in",
      scenario: y,
      fieldState: u,
      getValues: c,
      onSendEvent: r,
      paymentMethodInfo: v
    });
  };
  return j(
    () => {
      o(a), e(p);
    },
    [a, p]
  ), /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", {
    style: g ? { marginRight: "25px" } : { marginLeft: "25px" }
  }, /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, validate: rs },
    name: "iban",
    control: l,
    render: ({ field: y, fieldState: u }) => {
      var v;
      return /* @__PURE__ */ n.createElement(Ei, yt(ut({}, y), {
        ref: i,
        title: d(
          "pipo_payin_PC_cashier_payment_gocardless_cell_IBAN_placeholder"
        ),
        value: a.iban,
        onChange: (P) => Hl(
          P,
          ($) => o(yt(ut({}, a), { iban: $ })),
          y.onChange
        ),
        placeholder: d(
          "pipo_payin_PC_cashier_payment_gocardless_cell_IBAN_placeholder"
        ),
        error: m.iban,
        errorMessage: ql(
          (v = m.iban) == null ? void 0 : v.type,
          d(
            "pipo_payin_PC_cashier_payment_gocardless_cell_IBAN_placeholder"
          ),
          f,
          d
        ),
        onBlur: () => {
          y.onBlur(), h("iban", u);
        },
        bankList: ns,
        setDisplayBankIcon: vn,
        supportBank: Al
      }));
    }
  }), /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, pattern: K.nationalIDRegex },
    name: "identity",
    control: l,
    render: ({ field: y, fieldState: u }) => {
      var v;
      return /* @__PURE__ */ n.createElement(Sn, yt(ut({}, y), {
        title: d("pipo_payin_state_cashier_Birlesik_Odeme_national_id"),
        value: a.identity,
        onChange: (P) => {
          y.onChange(P), o(yt(ut({}, a), { identity: P }));
        },
        placeholder: d(
          "pipo_payin_state_cashier_Birlesik_Odeme_national_id"
        ),
        error: m.identity,
        errorMessage: f(
          (v = m.identity) == null ? void 0 : v.type,
          d("pipo_payin_state_cashier_Birlesik_Odeme_national_id")
        ),
        onBlur: () => {
          y.onBlur(), h("identity", u);
        }
      }));
    }
  }), /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, pattern: K.LatinNameRegex },
    name: "holder_first_name",
    control: l,
    render: ({ field: y, fieldState: u }) => {
      var v;
      return /* @__PURE__ */ n.createElement(we, yt(ut({}, y), {
        value: a.holder_first_name,
        onChange: (P) => {
          y.onChange(P), o(yt(ut({}, a), { holder_first_name: P }));
        },
        error: m.holder_first_name,
        errorMessage: f(
          (v = m.holder_first_name) == null ? void 0 : v.type,
          d("pipo_common_payin_firstname")
        ),
        maxLength: 255,
        title: d("pipo_common_payin_firstname"),
        placeholder: d("pipo_common_payin_firstname"),
        onBlur: () => {
          y.onBlur(), h("holder_first_name", u);
        }
      }));
    }
  }), /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, pattern: K.LatinNameRegex },
    name: "holder_last_name",
    control: l,
    render: ({ field: y, fieldState: u }) => {
      var v;
      return /* @__PURE__ */ n.createElement(we, yt(ut({}, y), {
        value: a.holder_last_name,
        onChange: (P) => {
          y.onChange(P), o(yt(ut({}, a), { holder_last_name: P }));
        },
        error: m.holder_last_name,
        errorMessage: f(
          (v = m.holder_last_name) == null ? void 0 : v.type,
          d("pipo_common_payin_lastname")
        ),
        maxLength: 255,
        title: d("pipo_common_payin_lastname"),
        placeholder: d("pipo_common_payin_lastname"),
        onBlur: () => {
          y.onBlur(), h("holder_last_name", u);
        }
      }));
    }
  }), /* @__PURE__ */ n.createElement("div", {
    className: "H4-SemiBold text-color-TextPrimary mt-12"
  }, 'This service is provided by Birle\u015Fik \xD6deme Hizmetleri ve Elektronik Para A.\u015E. audited by Central Bank of the Republic of Turkey ("CBRT").'), /* @__PURE__ */ n.createElement("div", {
    className: "H4-SemiBold text-color-TextPrimary mt-12"
  }, '\u0130\u015Fbu hizmet, T\xFCrkiye Cumhuriyeti Merkez Bankas\u0131 ("TCMB") taraf\u0131ndan denetlenen Birle\u015Fik \xD6deme Hizmetleri ve Elektronik Para A.\u015E taraf\u0131ndan olarak verilmektedir. This service is provided by Birle\u015Fik \xD6deme Hizmetleri ve Elektronik Para A.\u015E. audited by Central Bank of the Republic of Turkey ("CBRT").')));
};
var Ku = Object.defineProperty, Wu = Object.defineProperties, Ju = Object.getOwnPropertyDescriptors, zo = Object.getOwnPropertySymbols, Zu = Object.prototype.hasOwnProperty, Qu = Object.prototype.propertyIsEnumerable, Xo = (t, e, r) => e in t ? Ku(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Xe = (t, e) => {
  for (var r in e || (e = {}))
    Zu.call(e, r) && Xo(t, r, e[r]);
  if (zo)
    for (var r of zo(e))
      Qu.call(e, r) && Xo(t, r, e[r]);
  return t;
}, Ge = (t, e) => Wu(t, Ju(e));
const ey = (t) => {
  var e;
  const { onValidate: r, onSendEvent: a } = t, [o = {}, i] = Q(t), {
    control: l,
    getValues: c,
    formState: { errors: s, isValid: p, touchedFields: _ }
  } = ce({
    mode: "all"
  }), m = de({
    touchedFields: _,
    errors: s
  }), { t: d, getErrorText: f, state: g, isFlip: h } = I.useContext(), { countryOrRegion: y } = g, u = (e = ue.list[y]) == null ? void 0 : e.code, { phone: v = {} } = ue.list[y], {
    pattern: P,
    maxLength: $,
    minLength: x
  } = v, N = (M, b) => M === "required" ? f(M, b) : f(M, d("pipo_common_payin_error_invalid")), C = (M, b) => {
    const E = {
      paymentMethodType: Wr.paymentMethodType.paymentMethodType,
      paymentMethod: Wr.paymentMethod.paymentMethod,
      paymentMethodId: Wr.paymentMethod.paymentMethodId
    };
    ie({
      event: "fp_sdk_checkout_fill_in",
      scenario: M,
      fieldState: b,
      getValues: c,
      onSendEvent: a,
      paymentMethodInfo: E
    });
  };
  return j(
    () => {
      i(o), r(p);
    },
    [o, p]
  ), /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", {
    style: h ? { marginRight: "44px" } : { marginLeft: "44px" }
  }, /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, pattern: K.emailRegex },
    name: "email",
    control: l,
    render: ({ field: M, fieldState: b }) => {
      var E;
      return /* @__PURE__ */ n.createElement(Ae, Ge(Xe({}, M), {
        title: d("pipo_common_payin_Email"),
        value: o.email,
        onChange: (O) => {
          M.onChange(O), i(Ge(Xe({}, o), { email: O }));
        },
        placeholder: d("pipo_common_payin_ph_email"),
        error: m.email,
        errorMessage: f(
          (E = m.email) == null ? void 0 : E.type,
          d("pipo_common_payin_Email")
        ),
        onBlur: () => {
          M.onBlur(), C("email", b);
        }
      }));
    }
  }), /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0 },
    name: "phone_country_code",
    control: l,
    render: ({ field: M }) => /* @__PURE__ */ n.createElement(pt, {
      countryCode: u,
      onChange: (b) => {
        M.onChange(b);
      }
    })
  }), /* @__PURE__ */ n.createElement(k, {
    rules: {
      required: !0,
      pattern: P
    },
    name: "phone",
    control: l,
    render: ({ field: M, fieldState: b }) => {
      var E;
      return /* @__PURE__ */ n.createElement(Fe, Ge(Xe({}, M), {
        title: d("pipo_common_payin_phone_number"),
        placeholder: d("pipo_common_payin_ph_phone_number"),
        error: m.phone,
        errorMessage: f(
          (E = m.phone) == null ? void 0 : E.type,
          d("pipo_common_payin_phone_number")
        ),
        countryCode: u,
        countryOrRegion: y,
        value: o.phone,
        onChange: (O, T) => {
          M.onChange(O), i(Ge(Xe({}, o), {
            phone: O,
            phone_country_code: T
          }));
        },
        onBlur: () => {
          M.onBlur(), C("phone", b);
        },
        maxLength: $,
        minLength: x
      }));
    }
  }), /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, pattern: K.RomajiNameRegex },
    name: "holder_first_name",
    control: l,
    render: ({ field: M, fieldState: b }) => {
      var E;
      return /* @__PURE__ */ n.createElement(we, Ge(Xe({}, M), {
        value: o.holder_first_name,
        onChange: (O) => {
          M.onChange(O), i(Ge(Xe({}, o), { holder_first_name: O }));
        },
        error: m.holder_first_name,
        errorMessage: N(
          (E = m.holder_first_name) == null ? void 0 : E.type,
          d("pipo_common_payin_firstname")
        ),
        maxLength: 128,
        title: d("pipo_common_payin_firstname"),
        placeholder: d("pipo_common_payin_firstname_romaji"),
        onBlur: () => {
          M.onBlur(), C("holder_first_name", b);
        }
      }));
    }
  }), /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, pattern: K.KatakanaNameRegex },
    name: "holder_first_name_katakana",
    control: l,
    render: ({ field: M, fieldState: b }) => {
      var E;
      return /* @__PURE__ */ n.createElement(we, Ge(Xe({}, M), {
        value: o.holder_first_name_katakana,
        onChange: (O) => {
          M.onChange(O), i(Ge(Xe({}, o), { holder_first_name_katakana: O }));
        },
        maxLength: 128,
        error: m.holder_first_name_katakana,
        errorMessage: N(
          (E = m.holder_first_name_katakana) == null ? void 0 : E.type,
          d("pipo_common_payin_error_katakana_firstname")
        ),
        placeholder: d("pipo_common_payin_firstname_katakana"),
        onBlur: () => {
          M.onBlur(), C("holder_first_name_katakana", b);
        }
      }));
    }
  }), /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, pattern: K.RomajiNameRegex },
    name: "holder_last_name",
    control: l,
    render: ({ field: M, fieldState: b }) => {
      var E;
      return /* @__PURE__ */ n.createElement(we, Ge(Xe({}, M), {
        value: o.holder_last_name,
        onChange: (O) => {
          M.onChange(O), i(Ge(Xe({}, o), { holder_last_name: O }));
        },
        error: m.holder_last_name,
        errorMessage: N(
          (E = m.holder_last_name) == null ? void 0 : E.type,
          d("pipo_common_payin_lastname")
        ),
        maxLength: 128,
        title: d("pipo_common_payin_lastname"),
        placeholder: d("pipo_common_payin_firstname_romaji"),
        onBlur: () => {
          M.onBlur(), C("holder_last_name", b);
        }
      }));
    }
  }), /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, pattern: K.KatakanaNameRegex },
    name: "holder_last_name_katakana",
    control: l,
    render: ({ field: M, fieldState: b }) => {
      var E;
      return /* @__PURE__ */ n.createElement(we, Ge(Xe({}, M), {
        value: o.holder_last_name_katakana,
        onChange: (O) => {
          M.onChange(O), i(Ge(Xe({}, o), { holder_last_name_katakana: O }));
        },
        error: m.holder_last_name_katakana,
        errorMessage: N(
          (E = m.holder_last_name_katakana) == null ? void 0 : E.type,
          d("pipo_common_payin_error_katakana_lastname")
        ),
        maxLength: 128,
        placeholder: d("pipo_common_payin_firstname_katakana"),
        onBlur: () => {
          M.onBlur(), C("holder_last_name_katakana", b);
        }
      }));
    }
  })));
};
var ty = Object.defineProperty, ry = Object.defineProperties, ny = Object.getOwnPropertyDescriptors, Go = Object.getOwnPropertySymbols, ay = Object.prototype.hasOwnProperty, oy = Object.prototype.propertyIsEnumerable, Ko = (t, e, r) => e in t ? ty(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, sn = (t, e) => {
  for (var r in e || (e = {}))
    ay.call(e, r) && Ko(t, r, e[r]);
  if (Go)
    for (var r of Go(e))
      oy.call(e, r) && Ko(t, r, e[r]);
  return t;
}, cn = (t, e) => ry(t, ny(e));
const ly = "pipo-mobile-cascader", iy = (t) => {
  const { t: e, getErrorText: r, isFlip: a } = I.useContext(), { item: o, onValidate: i, onSendEvent: l } = t, { elements: c } = o, [s = {}, p] = Q(t), {
    control: _,
    getValues: m,
    formState: { errors: d, isValid: f, touchedFields: g }
  } = ce({
    mode: "all"
  }), h = de({
    touchedFields: g,
    errors: d
  }), [y, u] = R(!1), v = ge(
    () => {
      var $;
      return e(($ = gr[s.bank_code || ""]) == null ? void 0 : $.i18nKey);
    },
    [s.bank_code]
  ), P = ($, x) => {
    const N = {
      paymentMethodType: Jr.paymentMethodType.paymentMethodType,
      paymentMethod: Jr.paymentMethod.paymentMethod,
      paymentMethodId: Jr.paymentMethod.paymentMethodId
    };
    ie({
      event: "fp_sdk_checkout_fill_in",
      scenario: $,
      fieldState: x,
      getValues: m,
      onSendEvent: l,
      paymentMethodInfo: N
    });
  };
  return j(
    () => {
      p(s), i(f);
    },
    [s, f]
  ), /* @__PURE__ */ n.createElement("div", {
    style: a ? { marginRight: "44px" } : { marginLeft: "44px" }
  }, /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0 },
    name: "bank_code",
    control: _,
    render: ({ field: $ }) => {
      var x;
      return /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(zs, {
        title: e("pipo_payin_state_cashier_title_bank"),
        placeholder: e("pipo_payin_state_cashier_content_select"),
        end: /* @__PURE__ */ n.createElement(jr, null),
        value: v,
        onClick: () => u(!0),
        hasError: Boolean(h.bank_code),
        errorMessage: r(
          (x = h.bank_code) == null ? void 0 : x.type,
          e("pipo_payin_state_cashier_title_bank")
        )
      }), /* @__PURE__ */ n.createElement(ti, {
        header: /* @__PURE__ */ n.createElement(ri, {
          title: e("pipo_payin_state_cashier_title_bank"),
          endActions: {
            actionVariant: "icon",
            icon: /* @__PURE__ */ n.createElement(Ql, null),
            onClick: () => u(!1)
          },
          showSeparator: !0
        }),
        isVisible: y,
        onDismiss: () => u(!1)
      }, /* @__PURE__ */ n.createElement("div", {
        className: ae(`${ly}-content-panel-list`)
      }, c == null ? void 0 : c.map((N, C) => {
        const M = gr[N], b = e(M.i18nKey) || M.name, E = M.bankCode, O = M.icon.iconUrl;
        return /* @__PURE__ */ n.createElement("div", {
          key: C,
          onClick: (T) => {
            T == null || T.preventDefault(), $.onChange(E), p(cn(sn({}, s), { bank_code: E })), u(!1);
          }
        }, /* @__PURE__ */ n.createElement("div", {
          className: "box-border",
          style: { top: 0, left: 0, right: 0 }
        }, /* @__PURE__ */ n.createElement("header", {
          className: "flex items-center overflow-hidden relative background-color-BGSecondary",
          role: "navigation",
          style: { height: "52px", paddingLeft: "16px" }
        }, /* @__PURE__ */ n.createElement("img", {
          src: O,
          style: { height: 20, width: 32, marginRight: 12 }
        }), /* @__PURE__ */ n.createElement("div", {
          className: "inline-flex items-center justify-start flex-1 h-full"
        }, /* @__PURE__ */ n.createElement("button", {
          className: "tux-nav-bar-text-action h-40 p-0 H4-Regular text-color-TextPrimary"
        }, b)), /* @__PURE__ */ n.createElement("div", {
          className: "truncate flex-3 px-4 text-center H3-Bold text-color-TextPrimary",
          style: { lineHeight: "52px" }
        }), /* @__PURE__ */ n.createElement("div", {
          className: "inline-flex items-center justify-end h-full pr-8"
        }, /* @__PURE__ */ n.createElement("button", {
          className: "tux-nav-bar-icon-action h-40 w-40 p-0 text-color-TextPrimary flex items-center justify-center"
        }, /* @__PURE__ */ n.createElement(bn, {
          checked: s.bank_code === E,
          size: "medium"
        }))))));
      }))));
    }
  }), /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, pattern: K.nameRegex },
    name: "holder_name",
    control: _,
    render: ({ field: $, fieldState: x }) => {
      var N;
      return /* @__PURE__ */ n.createElement(we, cn(sn({}, $), {
        value: s.holder_name,
        onChange: (C) => {
          $.onChange(C), p(cn(sn({}, s), { holder_name: C }));
        },
        error: h.holder_name,
        errorMessage: r(
          (N = h.holder_name) == null ? void 0 : N.type,
          e("pipo_common_payin_boleto_name")
        ),
        title: e("pipo_common_payin_boleto_name"),
        placeholder: e("pipo_common_payin_boleto_name"),
        maxLength: 10,
        onBlur: () => {
          $.onBlur(), P("holder_name", x);
        }
      }));
    }
  }));
};
var sy = Object.defineProperty, Wo = Object.getOwnPropertySymbols, cy = Object.prototype.hasOwnProperty, py = Object.prototype.propertyIsEnumerable, Jo = (t, e, r) => e in t ? sy(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Kt = (t, e) => {
  for (var r in e || (e = {}))
    cy.call(e, r) && Jo(t, r, e[r]);
  if (Wo)
    for (var r of Wo(e))
      py.call(e, r) && Jo(t, r, e[r]);
  return t;
};
const my = (t) => {
  const { item: e } = t, { state: r } = I.useContext(), { countryOrRegion: a } = r;
  switch (e.paymentMethod.paymentMethodId) {
    case "pm_pi_bt_banktransfer_c_d":
      switch (a) {
        case "TR":
          return /* @__PURE__ */ n.createElement(Gu, Kt({}, t));
        case "JP":
          return /* @__PURE__ */ n.createElement(ey, Kt({}, t));
        default:
          return /* @__PURE__ */ n.createElement(Du, Kt({}, t));
      }
    case "pm_pi_bt_payeasy_c_r":
      return /* @__PURE__ */ n.createElement(Hu, Kt({}, t));
    case "pm_pi_bt_banktransfertoss_c_d":
      return /* @__PURE__ */ n.createElement(iy, Kt({}, t));
    default:
      return /* @__PURE__ */ n.createElement(fe, null);
  }
}, dy = (t) => {
  const { onBindSubmit: e, isSubmitting: r } = t, a = vt(), { control: o } = a;
  return /* @__PURE__ */ n.createElement("div", {
    className: "mb-16"
  }, /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0 },
    name: "bind_required",
    control: o,
    render: () => /* @__PURE__ */ n.createElement("div", null)
  }), /* @__PURE__ */ n.createElement(Je, {
    onClick: e,
    intro: !0,
    isLoading: r
  }));
}, _y = () => {
  const { isFlip: t, t: e } = I.useContext();
  return /* @__PURE__ */ n.createElement("div", {
    className: "background-color-BGView py-16",
    style: {
      display: "flex",
      boxSizing: "border-box",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column"
    }
  }, /* @__PURE__ */ n.createElement("img", {
    width: 142,
    height: 74,
    src: "https://lf16-co.g-p-static.com/obj/pipo-sg/checkout_card/svg/paypal-extral.svg",
    alt: ""
  }), /* @__PURE__ */ n.createElement("p", {
    className: ae(
      "m-0 mt-8 px-48 H4-Regular text-color-TextQuaternary",
      t ? "text-right" : "text-left"
    )
  }, e("payin_pay_with_PayPal_redirect")));
};
var uy = Object.defineProperty, Zo = Object.getOwnPropertySymbols, yy = Object.prototype.hasOwnProperty, hy = Object.prototype.propertyIsEnumerable, Qo = (t, e, r) => e in t ? uy(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, fy = (t, e) => {
  for (var r in e || (e = {}))
    yy.call(e, r) && Qo(t, r, e[r]);
  if (Zo)
    for (var r of Zo(e))
      hy.call(e, r) && Qo(t, r, e[r]);
  return t;
};
const fr = (t) => {
  const { bindButtonProps: e, className: r } = t, a = vt(), { control: o } = a;
  return /* @__PURE__ */ n.createElement("div", {
    className: ae("mb-16", r)
  }, /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0 },
    name: "bind_required",
    control: o,
    render: () => /* @__PURE__ */ n.createElement("div", null)
  }), /* @__PURE__ */ n.createElement(Je, fy({}, e)));
};
var vy = Object.defineProperty, gy = Object.defineProperties, Ey = Object.getOwnPropertyDescriptors, el = Object.getOwnPropertySymbols, Py = Object.prototype.hasOwnProperty, by = Object.prototype.propertyIsEnumerable, tl = (t, e, r) => e in t ? vy(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, xy = (t, e) => {
  for (var r in e || (e = {}))
    Py.call(e, r) && tl(t, r, e[r]);
  if (el)
    for (var r of el(e))
      by.call(e, r) && tl(t, r, e[r]);
  return t;
}, My = (t, e) => gy(t, Ey(e));
const Ni = (t) => {
  var e;
  const { onBindSubmit: r, isSubmitting: a, onSendEvent: o } = t, i = vt(), {
    control: l,
    formState: { errors: c },
    getValues: s,
    setValue: p
  } = i, { errors: _ } = Br({
    control: l
  }), { t: m, getErrorText: d, state: f, isFlip: g, noBindButton: h } = I.useContext(), { amount: y } = f, { countryOrRegion: u } = f, v = (e = ue.list[u]) == null ? void 0 : e.code, { phone: P = {} } = ue.list[u], {
    pattern: $,
    minLength: x,
    maxLength: N
  } = P;
  p("phone_country_code", v);
  const C = (M, b) => {
    const E = {
      paymentMethodType: Zr.paymentMethodType.paymentMethodType,
      paymentMethod: Zr.paymentMethod.paymentMethod,
      paymentMethodId: Zr.paymentMethod.paymentMethodId
    };
    ie({
      event: y != null && y.value ? "fp_sdk_checkout_fill_in" : "fp_sdk_checkout_pi_management_fill_in",
      scenario: M,
      fieldState: b,
      getValues: s,
      onSendEvent: o,
      paymentMethodInfo: E
    });
  };
  return /* @__PURE__ */ n.createElement("div", {
    className: "payment-ewallet-shopeepay",
    "data-sel": "pipo-mobile-payment-ewallet-shopeepay"
  }, /* @__PURE__ */ n.createElement("div", {
    className: "payment-ewallet-shopeepay-form mb-24"
  }, !h && /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0 },
    name: "bind_required",
    control: l,
    render: (M) => /* @__PURE__ */ n.createElement("div", null)
  }), /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0 },
    name: "phone_country_code",
    control: l,
    render: ({ field: M }) => /* @__PURE__ */ n.createElement(pt, {
      countryCode: v,
      onChange: M.onChange
    })
  }), /* @__PURE__ */ n.createElement(k, {
    rules: {
      required: !0,
      pattern: $
    },
    name: "phone",
    control: l,
    render: ({ field: M, fieldState: b }) => {
      var E;
      return /* @__PURE__ */ n.createElement("div", {
        className: "pl-4",
        style: g ? { marginRight: "44px" } : { marginLeft: "44px" }
      }, /* @__PURE__ */ n.createElement(Fe, My(xy({}, M), {
        title: m("pipo_common_payin_phone_number"),
        placeholder: m("pipo_common_link_ewallet_need_info"),
        error: c.phone,
        errorMessage: d(
          (E = c.phone) == null ? void 0 : E.type,
          m("pipo_common_payin_phone_number")
        ),
        countryCode: v,
        countryOrRegion: u,
        minLength: x,
        maxLength: N,
        autoFocus: !0,
        onBlur: () => {
          M.onBlur(), C("phone", b);
        }
      })));
    }
  })), !h && /* @__PURE__ */ n.createElement(Je, {
    onClick: r,
    disabled: !gn({ items: ["phone"], errors: _, getValues: s }),
    isLoading: a
  }));
};
var Oy = Object.defineProperty, Cy = Object.defineProperties, wy = Object.getOwnPropertyDescriptors, rl = Object.getOwnPropertySymbols, $y = Object.prototype.hasOwnProperty, Sy = Object.prototype.propertyIsEnumerable, nl = (t, e, r) => e in t ? Oy(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, pn = (t, e) => {
  for (var r in e || (e = {}))
    $y.call(e, r) && nl(t, r, e[r]);
  if (rl)
    for (var r of rl(e))
      Sy.call(e, r) && nl(t, r, e[r]);
  return t;
}, mn = (t, e) => Cy(t, wy(e));
const ky = (t) => {
  const { getErrorText: e, state: r, isFlip: a, useOldEvent: o } = I.useContext(), { countryOrRegion: i } = r, l = ue.list[i].code, { phone: c = {} } = ue.list[i], { pattern: s, maxLength: p } = c, { t: _ } = I.useContext(), { onValidate: m, onSendEvent: d } = t, [f = {}, g] = Q(t), {
    control: h,
    getValues: y,
    formState: { errors: u, isValid: v, touchedFields: P }
  } = ce({
    mode: "all"
  }), $ = de({
    touchedFields: P,
    errors: u
  }), x = (C, M) => {
    const b = {
      paymentMethodType: Qr.paymentMethodType.paymentMethodType,
      paymentMethod: Qr.paymentMethod.paymentMethod,
      paymentMethodId: Qr.paymentMethod.paymentMethodId
    };
    ie({
      event: "fp_sdk_checkout_fill_in",
      scenario: C,
      fieldState: M,
      getValues: y,
      onSendEvent: d,
      paymentMethodInfo: b
    });
  }, N = (C) => {
    d && (d({
      name: "fp_sdk_checkout_dropin_element_click",
      categories: {
        click_scenario: C ? "save_for_next_time" : "unsave_for_next_time"
      }
    }), o && d({
      name: "fp_sdk_checkout_page_click",
      categories: {
        click_method: C ? "save_for_next_time" : "unsave_for_next_time"
      }
    }));
  };
  return j(
    () => {
      g(f), m(v);
    },
    [f, v]
  ), /* @__PURE__ */ n.createElement("div", {
    className: "payment-ewallet-qiwi",
    style: a ? { marginRight: "44px" } : { marginLeft: "44px" }
  }, /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0 },
    name: "phone_country_code",
    control: h,
    render: ({ field: C }) => /* @__PURE__ */ n.createElement(pt, {
      countryCode: l,
      onChange: (M) => {
        C.onChange(M);
      }
    })
  }), /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, pattern: s },
    name: "phone",
    control: h,
    render: ({ field: C, fieldState: M }) => {
      var b;
      return /* @__PURE__ */ n.createElement("div", {
        className: "pl-4"
      }, /* @__PURE__ */ n.createElement(Fe, mn(pn({}, C), {
        title: _("pipo_common_payin_phone_number"),
        footer: _("pipo_qiwi_phone_number_rule"),
        autoFocus: !0,
        addBefore: "+7",
        maxLength: p,
        error: $.phone,
        errorMessage: e(
          (b = $.phone) == null ? void 0 : b.type,
          _("pipo_payin_dropin_cashier_qiwi_errow")
        ),
        placeholder: _("pipo_common_ewallet_enter_account"),
        countryCode: l,
        countryOrRegion: i,
        value: f.phone,
        onChange: (E, O) => {
          C.onChange(E), g(mn(pn({}, f), {
            phone: E,
            phone_country_code: O
          }));
        },
        onBlur: () => {
          C.onBlur(), x("phone", M);
        }
      })));
    }
  }), /* @__PURE__ */ n.createElement(mt, {
    title: _("pipo_common_payin_save_card"),
    value: f.storeCard,
    onChange: (C) => {
      g(mn(pn({}, f), { storeCard: C })), N(C);
    }
  }));
}, Ty = (t) => {
  const { onBindSubmit: e, isSubmitting: r } = t, a = vt(), { control: o } = a;
  return /* @__PURE__ */ n.createElement("div", {
    className: "mb-16"
  }, /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0 },
    name: "bind_required",
    control: o,
    render: () => /* @__PURE__ */ n.createElement("div", null)
  }), /* @__PURE__ */ n.createElement(Je, {
    onClick: e,
    intro: !0,
    isLoading: r
  }));
};
var Iy = Object.defineProperty, Ny = Object.defineProperties, By = Object.getOwnPropertyDescriptors, al = Object.getOwnPropertySymbols, Dy = Object.prototype.hasOwnProperty, Vy = Object.prototype.propertyIsEnumerable, ol = (t, e, r) => e in t ? Iy(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Wt = (t, e) => {
  for (var r in e || (e = {}))
    Dy.call(e, r) && ol(t, r, e[r]);
  if (al)
    for (var r of al(e))
      Vy.call(e, r) && ol(t, r, e[r]);
  return t;
}, Jt = (t, e) => Ny(t, By(e));
const jy = (t) => {
  const { getErrorText: e, isFlip: r } = I.useContext(), { t: a, useOldEvent: o } = I.useContext(), { onValidate: i, onSendEvent: l } = t, [c = {}, s] = Q(t), {
    control: p,
    getValues: _,
    formState: { errors: m, isValid: d, touchedFields: f }
  } = ce({
    mode: "all"
  }), g = de({
    touchedFields: f,
    errors: m
  }), h = (u, v) => {
    const P = {
      paymentMethodType: en.paymentMethodType.paymentMethodType,
      paymentMethod: en.paymentMethod.paymentMethod,
      paymentMethodId: en.paymentMethod.paymentMethodId
    };
    ie({
      event: "fp_sdk_checkout_fill_in",
      scenario: u,
      fieldState: v,
      getValues: _,
      onSendEvent: l,
      paymentMethodInfo: P
    });
  }, y = (u) => {
    l && (l({
      name: "fp_sdk_checkout_dropin_element_click",
      categories: {
        click_scenario: u ? "save_for_next_time" : "unsave_for_next_time"
      }
    }), o && l({
      name: "fp_sdk_checkout_page_click",
      categories: {
        click_method: u ? "save_for_next_time" : "unsave_for_next_time"
      }
    }));
  };
  return j(
    () => {
      s(c), i(d);
    },
    [c, d]
  ), /* @__PURE__ */ n.createElement("div", {
    style: r ? { marginRight: "44px" } : { marginLeft: "44px" }
  }, /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, pattern: K.nameRegex },
    name: "holder_name",
    control: p,
    render: ({ field: u, fieldState: v }) => {
      var P;
      return /* @__PURE__ */ n.createElement(we, Jt(Wt({}, u), {
        value: c.holder_name,
        onChange: ($) => {
          u.onChange($), s(Jt(Wt({}, c), { holder_name: $ }));
        },
        error: g.holder_name,
        errorMessage: e(
          (P = g.holder_name) == null ? void 0 : P.type,
          a("pipo_common_payin_boleto_name")
        ),
        title: a("pipo_common_payin_boleto_name"),
        placeholder: a("pipo_common_payin_boleto_name"),
        onBlur: () => {
          u.onBlur(), h("holder_name", v);
        }
      }));
    }
  }), /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, pattern: K.emailRegex },
    name: "email",
    control: p,
    render: ({ field: u, fieldState: v }) => {
      var P;
      return /* @__PURE__ */ n.createElement(Ae, Jt(Wt({}, u), {
        value: c.email,
        onChange: ($) => {
          u.onChange($), s(Jt(Wt({}, c), { email: $ }));
        },
        title: a("pipo_common_payin_Email"),
        placeholder: a("pipo_common_payin_ph_email"),
        error: g.email,
        errorMessage: e(
          (P = g.email) == null ? void 0 : P.type,
          a("pipo_common_payin_Email")
        ),
        onBlur: () => {
          u.onBlur(), h("email", v);
        }
      }));
    }
  }), /* @__PURE__ */ n.createElement(mt, {
    title: a("pipo_common_payin_save_card"),
    value: c.storeCard,
    onChange: (u) => {
      s(Jt(Wt({}, c), { storeCard: u })), y(u);
    }
  }));
}, Ly = (t) => {
  const { onBindSubmit: e, isSubmitting: r } = t, a = vt(), { control: o } = a;
  return /* @__PURE__ */ n.createElement("div", {
    className: "mb-16"
  }, /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0 },
    name: "bind_required",
    control: o,
    render: () => /* @__PURE__ */ n.createElement("div", null)
  }), /* @__PURE__ */ n.createElement(Je, {
    onClick: e,
    intro: !0,
    isLoading: r
  }));
}, Ry = () => {
  const { isFlip: t, t: e } = I.useContext();
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("p", {
    className: ae(
      "H4-Regular text-color-TextQuaternary",
      t ? "text-right" : "text-left"
    )
  }, e("pipo_payin_state_cashier_Payco_notice_maximumamount")));
};
var Fy = Object.defineProperty, Ay = Object.defineProperties, Hy = Object.getOwnPropertyDescriptors, ll = Object.getOwnPropertySymbols, qy = Object.prototype.hasOwnProperty, Uy = Object.prototype.propertyIsEnumerable, il = (t, e, r) => e in t ? Fy(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Zt = (t, e) => {
  for (var r in e || (e = {}))
    qy.call(e, r) && il(t, r, e[r]);
  if (ll)
    for (var r of ll(e))
      Uy.call(e, r) && il(t, r, e[r]);
  return t;
}, Qt = (t, e) => Ay(t, Hy(e));
const Yy = (t) => {
  const { getErrorText: e, isFlip: r, t: a, useOldEvent: o } = I.useContext(), { onValidate: i, onSendEvent: l } = t, [c = {}, s] = Q(t), {
    control: p,
    getValues: _,
    formState: { errors: m, isValid: d, touchedFields: f }
  } = ce({
    mode: "all"
  }), g = de({
    touchedFields: f,
    errors: m
  }), h = (u, v) => {
    const P = {
      paymentMethodType: Lt.paymentMethodType.paymentMethodType,
      paymentMethod: Lt.paymentMethod.paymentMethod,
      paymentMethodId: Lt.paymentMethod.paymentMethodId
    };
    ie({
      event: "fp_sdk_checkout_fill_in",
      scenario: u,
      fieldState: v,
      getValues: _,
      onSendEvent: l,
      paymentMethodInfo: P
    });
  }, y = (u) => {
    l && (l({
      name: "fp_sdk_checkout_dropin_element_click",
      categories: {
        click_scenario: u ? "save_for_next_time" : "unsave_for_next_time"
      }
    }), o && l({
      name: "fp_sdk_checkout_page_click",
      categories: {
        click_method: u ? "save_for_next_time" : "unsave_for_next_time"
      }
    }));
  };
  return j(
    () => {
      s(c), i(d);
    },
    [c, d]
  ), /* @__PURE__ */ n.createElement("div", {
    style: r ? { marginRight: "44px" } : { marginLeft: "44px" }
  }, /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0 },
    name: "wallet_id",
    control: p,
    render: ({ field: u, fieldState: v }) => {
      var P;
      return /* @__PURE__ */ n.createElement(Od, Qt(Zt({}, u), {
        value: c.wallet_id,
        onChange: ($) => {
          u.onChange($), s(Qt(Zt({}, c), { wallet_id: $ }));
        },
        error: g.wallet_id,
        errorMessage: e(
          (P = g.wallet_id) == null ? void 0 : P.type,
          a("pipo_common_payin_account_number")
        ),
        maxLength: 10,
        title: a("pipo_common_payin_account_number"),
        placeholder: a("pipo_common_payin_account_number"),
        onBlur: () => {
          u.onBlur(), h("wallet_id", v);
        }
      }));
    }
  }), /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0 },
    name: "pin",
    control: p,
    render: ({ field: u, fieldState: v }) => {
      var P;
      return /* @__PURE__ */ n.createElement(Pi, Qt(Zt({}, u), {
        value: c.pin,
        onChange: ($) => {
          u.onChange($), s(Qt(Zt({}, c), { pin: $ }));
        },
        title: a("pipo_common_payin_password") || "Password",
        placeholder: a("pipo_common_payin_password") || "Password",
        error: g.pin || g.pin,
        errorMessage: e(
          (P = g.pin) == null ? void 0 : P.type,
          a("pipo_common_payin_password") || "Password"
        ),
        onBlur: () => {
          u.onBlur(), h("pin", v);
        }
      }));
    }
  }), /* @__PURE__ */ n.createElement(mt, {
    title: a("pipo_common_payin_save_card"),
    value: c.storeCard,
    onChange: (u) => {
      s(Qt(Zt({}, c), { storeCard: u })), y(u);
    }
  }));
};
var zy = Object.defineProperty, Xy = Object.defineProperties, Gy = Object.getOwnPropertyDescriptors, sl = Object.getOwnPropertySymbols, Ky = Object.prototype.hasOwnProperty, Wy = Object.prototype.propertyIsEnumerable, cl = (t, e, r) => e in t ? zy(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Ct = (t, e) => {
  for (var r in e || (e = {}))
    Ky.call(e, r) && cl(t, r, e[r]);
  if (sl)
    for (var r of sl(e))
      Wy.call(e, r) && cl(t, r, e[r]);
  return t;
}, wt = (t, e) => Xy(t, Gy(e));
const Jy = (t) => {
  const { onValidate: e, onSendEvent: r, onSendOTP: a } = t, [o = {}, i] = Q(
    t
  ), { state: l, getErrorText: c, isFlip: s, useOldEvent: p } = I.useContext(), { t: _ } = I.useContext(), { countryOrRegion: m } = l, { seconds: d, start: f, reset: g } = ni(1e3 * 60), h = ue.list[m].code, {
    control: y,
    getValues: u,
    formState: { errors: v, isValid: P, touchedFields: $ }
  } = ce({
    mode: "all"
  });
  j(
    () => {
      i(o), e(P);
    },
    [o, P]
  ), j(
    () => {
      g(!0, 0);
    },
    []
  );
  const x = de({
    touchedFields: $,
    errors: v
  }), N = (b, E) => {
    const O = {
      paymentMethodType: jt.paymentMethodType.paymentMethodType,
      paymentMethod: jt.paymentMethod.paymentMethod,
      paymentMethodId: jt.paymentMethod.paymentMethodId
    };
    ie({
      event: "fp_sdk_checkout_fill_in",
      scenario: b,
      fieldState: E,
      getValues: u,
      onSendEvent: r,
      paymentMethodInfo: O
    });
  }, C = (b) => {
    r && (r({
      name: "fp_sdk_checkout_dropin_element_click",
      categories: {
        click_scenario: b ? "save_for_next_time" : "unsave_for_next_time"
      }
    }), p && r({
      name: "fp_sdk_checkout_page_click",
      categories: {
        click_method: b ? "save_for_next_time" : "unsave_for_next_time"
      }
    }));
  }, M = parseInt(d) > 0 || !(u().identity && u().phone) || "identity" in x || "phone" in x;
  return /* @__PURE__ */ n.createElement("div", {
    style: s ? { marginRight: "44px" } : { marginLeft: "44px" }
  }, /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, pattern: K.OVOIdRegex },
    name: "identity",
    control: y,
    render: ({ field: b, fieldState: E }) => {
      var O;
      return /* @__PURE__ */ n.createElement(Sn, wt(Ct({}, b), {
        error: x.identity,
        title: _("pipo_payin_state_cashier_Birlesik_Odeme_national_id"),
        placeholder: _(
          "pipo_payin_state_cashier_Birlesik_Odeme_national_id"
        ),
        errorMessage: c(
          (O = x.identity) == null ? void 0 : O.type,
          _("pipo_payin_state_cashier_Birlesik_Odeme_national_id")
        ),
        value: o.identity,
        onChange: (T) => {
          b.onChange(T), i(wt(Ct({}, o), {
            identity: T
          }));
        },
        onBlur: () => {
          b.onBlur(), N("identity", E);
        }
      }));
    }
  }), /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, pattern: K.PaycellPhoneRegex },
    name: "phone",
    control: y,
    render: ({ field: b, fieldState: E }) => {
      var O;
      return /* @__PURE__ */ n.createElement(Fe, wt(Ct({}, b), {
        error: x.phone,
        countryCode: h,
        countryOrRegion: m,
        value: o.phone,
        maxLength: 10,
        onChange: (T, W) => {
          b.onChange(T), i(wt(Ct({}, o), {
            phone: T,
            mobile_phone: `90${T}`,
            phone_country_code: "90"
          }));
        },
        title: _("pipo_common_payin_phone_number"),
        placeholder: _("pipo_common_payin_phone_number"),
        errorMessage: c(
          (O = x.phone) == null ? void 0 : O.type,
          _("pipo_common_payin_phone_number")
        ),
        onBlur: () => {
          b.onBlur(), N("phone", E);
        }
      }));
    }
  }), /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, pattern: K.PaycellOTPRegex },
    name: "otp_code",
    control: y,
    render: ({ field: b, fieldState: E }) => {
      var O;
      return /* @__PURE__ */ n.createElement(ki, wt(Ct({}, b), {
        error: x.otp_code,
        value: o.otp_code,
        onChange: (T) => {
          b.onChange(T), i(wt(Ct({}, o), {
            otp_code: T
          }));
        },
        title: _("pipo_payin_state_cashier_otp_notice"),
        requestTitle: _("pipo_payin_state_cashier_otp_notice_retry"),
        placeholder: "123456",
        maxLength: 6,
        disabled: M,
        cooldown: parseInt(d),
        errorMessage: c(
          (O = x.otp_code) == null ? void 0 : O.type,
          _("pipo_payin_state_cashier_otp_notice")
        ),
        onBlur: () => {
          b.onBlur(), N("otp_code", E);
        },
        onClick: () => {
          a && a(), g(!0), f();
        }
      }));
    }
  }), /* @__PURE__ */ n.createElement(k, {
    rules: { required: !1 },
    name: "storeCard",
    control: y,
    render: ({ field: b }) => /* @__PURE__ */ n.createElement(mt, {
      title: _("pipo_common_payin_save_payment_method"),
      value: o.storeCard,
      onChange: (E) => {
        b.onChange(E), i(wt(Ct({}, o), { storeCard: E })), C(E);
      }
    })
  }));
};
var Zy = Object.defineProperty, Qy = Object.defineProperties, eh = Object.getOwnPropertyDescriptors, pl = Object.getOwnPropertySymbols, th = Object.prototype.hasOwnProperty, rh = Object.prototype.propertyIsEnumerable, ml = (t, e, r) => e in t ? Zy(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, nh = (t, e) => {
  for (var r in e || (e = {}))
    th.call(e, r) && ml(t, r, e[r]);
  if (pl)
    for (var r of pl(e))
      rh.call(e, r) && ml(t, r, e[r]);
  return t;
}, ah = (t, e) => Qy(t, eh(e));
const oh = (t) => {
  var e, r;
  const { onSendEvent: a } = t, { getErrorText: o, state: i, isFlip: l, t: c, noBindButton: s } = I.useContext(), { amount: p } = i, _ = vt(), {
    control: m,
    formState: { errors: d },
    setValue: f,
    getValues: g
  } = _;
  Br({
    control: m
  });
  const { countryOrRegion: h } = i, y = ue.list[h].code, u = (r = (e = ue.list[h]) == null ? void 0 : e.phone) == null ? void 0 : r.pattern;
  f("phone_country_code", y);
  const v = (P, $) => {
    const x = {
      paymentMethodType: tn.paymentMethodType.paymentMethodType,
      paymentMethod: tn.paymentMethod.paymentMethod,
      paymentMethodId: tn.paymentMethod.paymentMethodId
    };
    ie({
      event: p != null && p.value ? "fp_sdk_checkout_fill_in" : "fp_sdk_checkout_pi_management_fill_in",
      scenario: P,
      fieldState: $,
      getValues: g,
      onSendEvent: a,
      paymentMethodInfo: x
    });
  };
  return /* @__PURE__ */ n.createElement("div", {
    className: "payment-ewallet-ovo-redirect"
  }, /* @__PURE__ */ n.createElement("div", {
    className: "payment-ewallet-ovo-redirect-form mb-24"
  }, /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, pattern: u },
    name: "phone",
    control: m,
    render: ({ field: P, fieldState: $ }) => {
      var x;
      return /* @__PURE__ */ n.createElement("div", {
        className: "pl-4",
        style: l ? { marginRight: "44px" } : { marginLeft: "44px" }
      }, /* @__PURE__ */ n.createElement(Fe, ah(nh({}, P), {
        title: c("pipo_common_payin_phone_number"),
        error: d.phone,
        errorMessage: o(
          (x = d.phone) == null ? void 0 : x.type,
          c("pipo_common_payin_phone_number")
        ),
        placeholder: c("pipo_common_payin_phone_number"),
        countryCode: y,
        autoFocus: !0,
        onBlur: () => {
          P.onBlur(), v("phone", $);
        }
      })));
    }
  })));
};
var lh = Object.defineProperty, ih = Object.defineProperties, sh = Object.getOwnPropertyDescriptors, dl = Object.getOwnPropertySymbols, ch = Object.prototype.hasOwnProperty, ph = Object.prototype.propertyIsEnumerable, _l = (t, e, r) => e in t ? lh(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, it = (t, e) => {
  for (var r in e || (e = {}))
    ch.call(e, r) && _l(t, r, e[r]);
  if (dl)
    for (var r of dl(e))
      ph.call(e, r) && _l(t, r, e[r]);
  return t;
}, mh = (t, e) => ih(t, sh(e));
const dh = (t) => {
  const { selected: e, onBindSubmit: r, isSubmitting: a, onSendEvent: o, value: i, onChange: l } = t, { t: c, noBindButton: s } = I.useContext(), p = ge(() => {
    var _;
    const m = e == null ? void 0 : e[0], d = (_ = m == null ? void 0 : m.paymentMethod) == null ? void 0 : _.paymentMethodId;
    switch (d) {
      case "pm_pi_ew_paypal_c_r":
        return /* @__PURE__ */ n.createElement(_y, null);
      case "pm_pi_ew_paypal_c_d": {
        if (!s)
          return /* @__PURE__ */ n.createElement(dy, it({}, t));
        break;
      }
      case "pm_pi_ew_touchngo_c_r":
        return /* @__PURE__ */ n.createElement(ir, null, /* @__PURE__ */ n.createElement(mt, {
          title: c("pipo_common_payin_save_paymentmethod", {
            value: c("pipo_payin_cashier_dropin_payment_TNG")
          }),
          value: i == null ? void 0 : i.storeCard,
          onChange: (f) => l(mh(it({}, i), { storeCard: f }))
        }));
      case "pm_pi_ew_ovo_c_d":
        return /* @__PURE__ */ n.createElement(n_, it({}, t));
      case "pm_pi_ew_rabbitlinepay_c_d":
      case "pm_pi_ew_paymaya_c_r":
      case "pm_pi_ew_dana_c_r":
      case "pm_pi_ew_dana_c_d":
      case "pm_pi_ew_zalopay_c_r":
        return "model" in m && m.model === "pay_on_token" && !s ? /* @__PURE__ */ n.createElement(fr, {
          bindButtonProps: {
            intro: !0,
            onClick: r,
            isLoading: a
          },
          className: `payment-ewallet-${d}`
        }) : /* @__PURE__ */ n.createElement(fe, null);
      case "pm_pi_ew_ovo_c_r":
        return /* @__PURE__ */ n.createElement(Si, it({}, t));
      case "pm_pi_ew_gopay_c_d":
        return /* @__PURE__ */ n.createElement(oh, it({}, t));
      case "pm_pi_ew_venmo_c_d": {
        if (!s)
          return /* @__PURE__ */ n.createElement(Ty, {
            onBindSubmit: r,
            isSubmitting: a
          });
        break;
      }
      case "pm_pi_ew_momo_c_r": {
        if ("model" in m && m.model === "pay_on_token" && r && !s)
          return /* @__PURE__ */ n.createElement(Ly, {
            onBindSubmit: r,
            isSubmitting: a
          });
        break;
      }
      case "pm_pi_ew_qiwi_c_r":
        return /* @__PURE__ */ n.createElement(ky, it({}, t));
      case "pm_pi_ew_kakaopay_c_r": {
        if (s)
          break;
        return /* @__PURE__ */ n.createElement(fr, {
          bindButtonProps: {
            intro: !0,
            onClick: r,
            isLoading: a
          },
          className: "payment-ewallet-kakaopay"
        });
      }
      case "pm_pi_ew_shopeepay_c_r": {
        const f = Ul(m, [
          /* @__PURE__ */ n.createElement(Ni, {
            onBindSubmit: r,
            key: "ShopeepayForm",
            onSendEvent: o,
            isSubmitting: a
          }),
          s ? null : /* @__PURE__ */ n.createElement(fr, {
            bindButtonProps: {
              onClick: r,
              isLoading: a
            },
            key: "BindRequiredButton"
          }),
          null
        ]);
        if (f)
          return f;
        break;
      }
      case "pm_pi_ew_mercadopago_c_r":
        return /* @__PURE__ */ n.createElement(jy, it({}, t));
      case "pm_pi_ew_payco_c_r":
        return /* @__PURE__ */ n.createElement(Ry, null);
      case "pm_pi_ew_paycell_c_d":
        return /* @__PURE__ */ n.createElement(Jy, it({}, t));
      case "pm_pi_ew_todito_c_d":
        return /* @__PURE__ */ n.createElement(Yy, it({}, t));
      default:
        return /* @__PURE__ */ n.createElement(fe, null);
    }
    return /* @__PURE__ */ n.createElement(fe, null);
  }, [
    s,
    a,
    r,
    l,
    o,
    t,
    e,
    c,
    i
  ]);
  return /* @__PURE__ */ n.createElement(n.Fragment, null, p);
}, _h = (t) => {
  const { data: e, selectObj: r, onSelect: a } = t, o = e.subPaymentMethodList || [], i = e.subUnavailablePaymentMethodList || [], { isFlip: l } = I.useContext();
  return t.onlyReturnForm ? /* @__PURE__ */ n.createElement(n.Fragment, null) : /* @__PURE__ */ n.createElement("div", {
    className: "py-2",
    style: l ? { marginRight: "44px" } : { marginLeft: "44px" }
  }, /* @__PURE__ */ n.createElement(fe, null), o.map((c, s) => {
    var p, _;
    return /* @__PURE__ */ n.createElement(Sr, {
      onClick: () => {
        a(c);
      },
      isSelected: ((_ = (p = r == null ? void 0 : r[0]) == null ? void 0 : p.paymentMethod) == null ? void 0 : _.paymentMethodId) === c.paymentMethod.paymentMethodId,
      value: c.paymentMethod.paymentMethodId,
      key: s,
      iconUrl: c.paymentMethod.icon.iconUrl,
      title: c.paymentMethod.displayName || c.paymentMethod.paymentMethod
    });
  }), i.map((c) => /* @__PURE__ */ n.createElement(Sr, {
    disabled: !0,
    onClick: () => {
    },
    isSelected: !1,
    value: c.paymentMethod.paymentMethodId,
    key: c.paymentMethod.paymentMethodId,
    iconUrl: c.paymentMethod.icon.iconUrl,
    title: c.paymentMethod.displayName || c.paymentMethod.paymentMethod,
    errorMsg: c.unavailableErrorCode
  })), /* @__PURE__ */ n.createElement(fe, null));
};
var uh = Object.defineProperty, yh = Object.defineProperties, hh = Object.getOwnPropertyDescriptors, kr = Object.getOwnPropertySymbols, Bi = Object.prototype.hasOwnProperty, Di = Object.prototype.propertyIsEnumerable, ul = (t, e, r) => e in t ? uh(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Ce = (t, e) => {
  for (var r in e || (e = {}))
    Bi.call(e, r) && ul(t, r, e[r]);
  if (kr)
    for (var r of kr(e))
      Di.call(e, r) && ul(t, r, e[r]);
  return t;
}, Le = (t, e) => yh(t, hh(e)), fh = (t, e) => {
  var r = {};
  for (var a in t)
    Bi.call(t, a) && e.indexOf(a) < 0 && (r[a] = t[a]);
  if (t != null && kr)
    for (var a of kr(t))
      e.indexOf(a) < 0 && Di.call(t, a) && (r[a] = t[a]);
  return r;
}, vh = (t, e, r) => new Promise((a, o) => {
  var i = (s) => {
    try {
      c(r.next(s));
    } catch (p) {
      o(p);
    }
  }, l = (s) => {
    try {
      c(r.throw(s));
    } catch (p) {
      o(p);
    }
  }, c = (s) => s.done ? a(s.value) : Promise.resolve(s.value).then(i, l);
  c((r = r.apply(t, e)).next());
});
const Bn = (t) => {
  const { state: e, t: r, getErrorText: a, useOldEvent: o, noSavingBox: i } = I.useContext(), { countryOrRegion: l, config: c = {}, amount: s } = e, {
    showSavingBox: p = !i,
    onFetchDistrict: _,
    onFetchAddressAutocomplete: m,
    onFetchPlaceDetail: d,
    onValidate: f,
    onSendEvent: g
  } = t, [h = {}, y] = Q(t), {
    watch: u,
    control: v,
    getValues: P,
    unregister: $,
    formState: { errors: x, isValid: N, touchedFields: C }
  } = ce({
    mode: "all"
  }), M = de({
    touchedFields: C,
    errors: x
  }), { pix: b = {} } = c, { hasCNPJ: E = !0, hasBillingAddress: O = !1 } = Ce(Ce({}, b), t), [T, W] = R(!O), {
    defaultProxyType: re,
    proxyTypeTitle: J,
    proxyTypeValidator: F,
    onProxyTypeChange: ee
  } = Pn($), [pe, _e] = R(re), G = u("proxy_type") === "individual", q = u("proxy_type") === "company", z = ue.list[l].code, { phone: H = {} } = ue.list[l], { pattern: Ee } = H, ke = Ne(
    () => {
      h.proxy_type = pe;
      const D = h, { storeCard: B = !1 } = D, L = fh(D, ["storeCard"]), U = Dr(
        L,
        as
      ), { paymentMethodType: Z, paymentMethod: xe } = ur;
      y(h, {
        formData: L,
        paymentMethod: {
          paymentMethod: xe.paymentMethod,
          paymentMethodId: xe.paymentMethodId
        },
        paymentMethodType: Z.paymentMethodType,
        paymentParams: U,
        storeCard: B
      });
    },
    [h]
  ), oe = (D, B) => {
    const L = {
      paymentMethodType: ur.paymentMethodType.paymentMethodType,
      paymentMethod: ur.paymentMethod.paymentMethod,
      paymentMethodId: ur.paymentMethod.paymentMethodId
    };
    ie({
      event: s != null && s.value ? "fp_sdk_checkout_fill_in" : "fp_sdk_checkout_pi_management_fill_in",
      scenario: D,
      fieldState: B,
      getValues: P,
      onSendEvent: g,
      paymentMethodInfo: L
    });
  }, ve = (D) => {
    g && (g({
      name: "fp_sdk_checkout_dropin_element_click",
      categories: {
        click_scenario: D ? "save_for_next_time" : "unsave_for_next_time"
      }
    }), o && g({
      name: "fp_sdk_checkout_page_click",
      categories: {
        click_method: D ? "save_for_next_time" : "unsave_for_next_time"
      }
    }));
  };
  return j(
    () => {
      ke(), f(N && T);
    },
    [h, N, T]
  ), /* @__PURE__ */ n.createElement("div", {
    className: "w-full"
  }, /* @__PURE__ */ n.createElement("div", {
    style: { overflowX: "unset", position: "relative" },
    className: "w-full box-border"
  }, /* @__PURE__ */ n.createElement("div", {
    className: "w-full",
    style: {
      overflowY: "auto",
      position: "relative",
      height: "auto",
      overflowX: "unset"
    }
  }, /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, pattern: K.nameRegex },
    name: "holder_name",
    control: v,
    render: ({ field: D, fieldState: B }) => {
      var L;
      return /* @__PURE__ */ n.createElement(we, Le(Ce({}, D), {
        value: h.holder_name,
        onChange: (U) => {
          D.onChange(U), y(Le(Ce({}, h), { holder_name: U }));
        },
        error: M.holder_name,
        errorMessage: a(
          (L = M.holder_name) == null ? void 0 : L.type,
          r("pipo_common_payin_boleto_name")
        ),
        title: r("pipo_common_payin_boleto_name"),
        placeholder: r("pipo_common_payin_boleto_name"),
        onBlur: () => {
          D.onBlur(), oe("holder_name", B);
        }
      }));
    }
  }), /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, pattern: K.emailRegex },
    name: "email",
    control: v,
    render: ({ field: D, fieldState: B }) => {
      var L;
      return /* @__PURE__ */ n.createElement(Ae, Le(Ce({}, D), {
        value: h.email,
        onChange: (U) => {
          D.onChange(U), y(Le(Ce({}, h), { email: U }));
        },
        title: r("pipo_common_payin_Email"),
        placeholder: r("pipo_common_payin_ph_email"),
        error: M.email,
        errorMessage: a(
          (L = M.email) == null ? void 0 : L.type,
          r("pipo_common_payin_Email")
        ),
        onBlur: () => {
          D.onBlur(), oe("email", B);
        }
      }));
    }
  }), /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0 },
    name: "phone_country_code",
    control: v,
    render: ({ field: D }) => /* @__PURE__ */ n.createElement(pt, {
      countryCode: z,
      onChange: (B) => {
        D.onChange(B);
      }
    })
  }), /* @__PURE__ */ n.createElement(k, {
    rules: {
      required: !0,
      pattern: Ee
    },
    name: "phone",
    control: v,
    render: ({ field: D, fieldState: B }) => {
      var L;
      return /* @__PURE__ */ n.createElement(Fe, Le(Ce({}, D), {
        title: r("pipo_common_payin_phone_number"),
        placeholder: r("pipo_common_payin_ph_phone_number"),
        error: M.phone,
        errorMessage: a(
          (L = M.phone) == null ? void 0 : L.type,
          r("pipo_common_payin_phone_number")
        ),
        countryCode: z,
        countryOrRegion: l,
        value: h.phone,
        onChange: (U, Z) => {
          D.onChange(U), y(Le(Ce({}, h), {
            phone: U,
            phone_country_code: Z
          }));
        },
        onBlur: () => {
          D.onBlur(), oe("phone", B);
        }
      }));
    }
  }), /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0 },
    name: "proxy_type",
    control: v,
    defaultValue: re,
    render: ({ field: D }) => /* @__PURE__ */ n.createElement($n, Le(Ce({}, D), {
      show: E,
      title: J,
      value: pe,
      proxyTypeValidator: F,
      onChange: (B) => {
        _e(B), ee(B, D.onChange);
      },
      "data-sel": "pipo-mobile-pix-proxy-type"
    }))
  }), G && /* @__PURE__ */ n.createElement(k, {
    rules: {
      required: !0,
      validate: {
        cpf: (D) => ar.isValid(D || "")
      }
    },
    name: "identity",
    control: v,
    defaultValue: "",
    render: ({ field: D, fieldState: B }) => {
      var L;
      return /* @__PURE__ */ n.createElement(On, Le(Ce({}, D), {
        title: r("pipo_common_payin_CPF"),
        value: h.identity,
        onChange: (U) => {
          D.onChange(U), y(Le(Ce({}, h), { identity: U }));
        },
        error: M.identity,
        errorMessage: a(
          (L = M.identity) == null ? void 0 : L.type,
          r("pipo_common_payin_CPF")
        ),
        onBlur: () => {
          D.onBlur(), oe("identity", B);
        }
      }));
    }
  }), q && /* @__PURE__ */ n.createElement(k, {
    rules: {
      required: !0,
      validate: {
        cnpj: (D) => nr.isValid(D || "")
      }
    },
    name: "company_id",
    control: v,
    defaultValue: "",
    render: ({ field: D, fieldState: B }) => {
      var L;
      return /* @__PURE__ */ n.createElement(Mn, Le(Ce({}, D), {
        title: r("pipo_common_payin_CNPJ"),
        value: h.company_id,
        onChange: (U) => {
          D.onChange(U), y(Le(Ce({}, h), { company_id: U }));
        },
        error: M.company_id,
        errorMessage: a(
          (L = M.company_id) == null ? void 0 : L.type,
          r("pipo_common_payin_CNPJ")
        ),
        onBlur: () => {
          D.onBlur(), oe("company_id", B);
        }
      }));
    }
  }), O && /* @__PURE__ */ n.createElement(Tn, {
    onFetchDistrict: _,
    onFetchAddressAutocomplete: m,
    onFetchPlaceDetail: d,
    value: h,
    onChange: (D) => {
      y(Ce(Ce({}, h), D));
    },
    onValidate: (D) => W(D),
    handleBlur: oe
  }), p && /* @__PURE__ */ n.createElement(mt, {
    title: r("pipo_common_payin_save_card"),
    value: h.storeCard,
    onChange: (D) => {
      y(Le(Ce({}, h), { storeCard: D })), ve(D);
    }
  }))));
};
Ft(
  (t, e) => {
    const { onRedirectPP: r, onSubmit: a, onSendEvent: o } = t, [i, l] = R(), [c, s] = R(!1), { isSubmitting: p, formSubmitState: _ } = Rt(), m = (d) => vh(void 0, null, function* () {
      if (d == null || d.preventDefault(), !a || !i)
        return;
      const f = i.paymentMethodType, { paymentMethod: g, paymentMethodId: h } = i.paymentMethod;
      _.setTrue(), o && o({
        name: "fp_sdk_checkout_pi_management_click",
        metrics: Ce({}, {}),
        categories: {
          click_method: "confirm",
          pi_type_1: f,
          pi_type_2: g,
          pi_type_3: "",
          pm_id: h,
          saved_pi: "other"
        }
      }), yield a(i), _.setFalse();
    });
    return sr(e, {
      initPath: "boleto",
      initParams: {},
      instanceMethods: {}
    }), /* @__PURE__ */ n.createElement("div", {
      className: "pipo-mobile w-full h-full"
    }, /* @__PURE__ */ n.createElement("div", {
      style: { overflowX: "unset", position: "relative" },
      className: "w-full h-full box-border"
    }, /* @__PURE__ */ n.createElement("form", {
      onSubmit: m,
      className: "w-full h-full",
      onKeyDown: (d) => {
        d.keyCode === 13 && d.preventDefault();
      }
    }, /* @__PURE__ */ n.createElement("div", {
      className: "pt-24 pb-24 pl-16 pr-16 w-full h-full",
      style: {
        overflowY: "auto",
        position: "relative",
        overflowX: "unset"
      }
    }, /* @__PURE__ */ n.createElement(Bn, Le(Ce({}, t), {
      onChange: (d, f) => l(f),
      onValidate: (d) => s(d)
    })), /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(qt, {
      type: "bind",
      onRedirectPP: r
    }), /* @__PURE__ */ n.createElement("div", {
      className: "w-full mt-16"
    }, /* @__PURE__ */ n.createElement(Lr, {
      isValid: c,
      isLoading: p
    })))))));
  }
);
var gh = Object.defineProperty, Eh = Object.defineProperties, Ph = Object.getOwnPropertyDescriptors, yl = Object.getOwnPropertySymbols, bh = Object.prototype.hasOwnProperty, xh = Object.prototype.propertyIsEnumerable, hl = (t, e, r) => e in t ? gh(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, ht = (t, e) => {
  for (var r in e || (e = {}))
    bh.call(e, r) && hl(t, r, e[r]);
  if (yl)
    for (var r of yl(e))
      xh.call(e, r) && hl(t, r, e[r]);
  return t;
}, ft = (t, e) => Eh(t, Ph(e));
const Mh = (t) => {
  const { onValidate: e, onSendEvent: r } = t, [a = {}, o] = Q(t), i = n.createRef(), {
    control: l,
    getValues: c,
    formState: { errors: s, isValid: p, touchedFields: _ }
  } = ce({
    mode: "all"
  }), m = de({
    touchedFields: _,
    errors: s
  }), { t: d, getErrorText: f, isFlip: g } = I.useContext(), h = (y, u) => {
    const v = {
      paymentMethodType: ct.paymentMethodType.paymentMethodType,
      paymentMethod: ct.paymentMethod.paymentMethod,
      paymentMethodId: ct.paymentMethod.paymentMethodId
    };
    ie({
      event: "fp_sdk_checkout_fill_in",
      scenario: y,
      fieldState: u,
      getValues: c,
      onSendEvent: r,
      paymentMethodInfo: v
    });
  };
  return j(
    () => {
      o(a), e(p);
    },
    [a, p]
  ), /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", {
    style: g ? { marginRight: "25px" } : { marginLeft: "25px" }
  }, /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, validate: os },
    name: "iban",
    control: l,
    render: ({ field: y, fieldState: u }) => {
      var v;
      return /* @__PURE__ */ n.createElement(Ei, ft(ht({}, y), {
        ref: i,
        title: d(
          "pipo_payin_PC_cashier_payment_gocardless_cell_IBAN_placeholder"
        ),
        value: a.iban,
        onChange: (P) => Hl(
          P,
          ($) => o(ft(ht({}, a), { iban: $ })),
          y.onChange
        ),
        placeholder: d(
          "pipo_payin_PC_cashier_payment_gocardless_cell_IBAN_placeholder"
        ),
        error: m.iban,
        errorMessage: ql(
          (v = m.iban) == null ? void 0 : v.type,
          d(
            "pipo_payin_PC_cashier_payment_gocardless_cell_IBAN_placeholder"
          ),
          f,
          d
        ),
        onBlur: () => {
          y.onBlur(), h("iban", u);
        },
        bankList: ls,
        setDisplayBankIcon: vn,
        supportBank: is
      }));
    }
  }), /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, pattern: K.nationalIDRegex },
    name: "identity",
    control: l,
    render: ({ field: y, fieldState: u }) => {
      var v;
      return /* @__PURE__ */ n.createElement(Sn, ft(ht({}, y), {
        title: d("pipo_payin_state_cashier_Birlesik_Odeme_national_id"),
        value: a.identity,
        onChange: (P) => {
          y.onChange(P), o(ft(ht({}, a), { identity: P }));
        },
        placeholder: d(
          "pipo_payin_state_cashier_Birlesik_Odeme_national_id"
        ),
        error: m.identity,
        errorMessage: f(
          (v = m.identity) == null ? void 0 : v.type,
          d("pipo_payin_state_cashier_Birlesik_Odeme_national_id")
        ),
        onBlur: () => {
          y.onBlur(), h("identity", u);
        }
      }));
    }
  }), /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, pattern: K.LatinNameRegex },
    name: "holder_first_name",
    control: l,
    render: ({ field: y, fieldState: u }) => {
      var v;
      return /* @__PURE__ */ n.createElement(we, ft(ht({}, y), {
        value: a.holder_first_name,
        onChange: (P) => {
          y.onChange(P), o(ft(ht({}, a), { holder_first_name: P }));
        },
        error: m.holder_first_name,
        errorMessage: f(
          (v = m.holder_first_name) == null ? void 0 : v.type,
          d("pipo_common_payin_firstname")
        ),
        maxLength: 255,
        title: d("pipo_common_payin_firstname"),
        placeholder: d("pipo_common_payin_firstname"),
        onBlur: () => {
          y.onBlur(), h("holder_first_name", u);
        }
      }));
    }
  }), /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, pattern: K.LatinNameRegex },
    name: "holder_last_name",
    control: l,
    render: ({ field: y, fieldState: u }) => {
      var v;
      return /* @__PURE__ */ n.createElement(we, ft(ht({}, y), {
        value: a.holder_last_name,
        onChange: (P) => {
          y.onChange(P), o(ft(ht({}, a), { holder_last_name: P }));
        },
        error: m.holder_last_name,
        errorMessage: f(
          (v = m.holder_last_name) == null ? void 0 : v.type,
          d("pipo_common_payin_lastname")
        ),
        maxLength: 255,
        title: d("pipo_common_payin_lastname"),
        placeholder: d("pipo_common_payin_lastname"),
        onBlur: () => {
          y.onBlur(), h("holder_last_name", u);
        }
      }));
    }
  }), /* @__PURE__ */ n.createElement("div", {
    className: "H4-SemiBold text-color-TextPrimary mt-12"
  }, 'This service is provided by Birle\u015Fik \xD6deme Hizmetleri ve Elektronik Para A.\u015E. audited by Central Bank of the Republic of Turkey ("CBRT").'), /* @__PURE__ */ n.createElement("div", {
    className: "H4-SemiBold text-color-TextPrimary mt-12"
  }, '\u0130\u015Fbu hizmet, T\xFCrkiye Cumhuriyeti Merkez Bankas\u0131 ("TCMB") taraf\u0131ndan denetlenen Birle\u015Fik \xD6deme Hizmetleri ve Elektronik Para A.\u015E taraf\u0131ndan olarak verilmektedir. This service is provided by Birle\u015Fik \xD6deme Hizmetleri ve Elektronik Para A.\u015E. audited by Central Bank of the Republic of Turkey ("CBRT").')));
};
var Oh = Object.defineProperty, fl = Object.getOwnPropertySymbols, Ch = Object.prototype.hasOwnProperty, wh = Object.prototype.propertyIsEnumerable, vl = (t, e, r) => e in t ? Oh(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Bt = (t, e) => {
  for (var r in e || (e = {}))
    Ch.call(e, r) && vl(t, r, e[r]);
  if (fl)
    for (var r of fl(e))
      wh.call(e, r) && vl(t, r, e[r]);
  return t;
};
const $h = (t) => {
  const { item: e, selected: r, onSelect: a } = t;
  switch (e.paymentMethodType.paymentMethodType) {
    case "CCDC":
      if (e.paymentMethod.paymentMethod !== "CARD_QIWI")
        return /* @__PURE__ */ n.createElement(ir, null, /* @__PURE__ */ n.createElement(Nn, Bt({}, t)));
      break;
    case "BANK_ACCOUNT_PROXY":
      if (e.paymentMethod.paymentMethod === "PIX")
        return /* @__PURE__ */ n.createElement(ir, null, /* @__PURE__ */ n.createElement(Bn, Bt({}, t)));
      break;
    case "E_WALLET":
      return /* @__PURE__ */ n.createElement(dh, Bt({}, t));
    case "BANK_TRANSFER":
      return /* @__PURE__ */ n.createElement(my, Bt({}, t));
    case "CASH_PIN":
      return /* @__PURE__ */ n.createElement(Cu, Bt({}, t));
    case "INTERNET_BANKING":
      if (e.needMerge)
        return /* @__PURE__ */ n.createElement(_h, {
          data: e,
          selectObj: r,
          onSelect: a,
          onlyReturnForm: t.onlyReturnForm
        });
      if (e.paymentMethod.paymentMethod === "Birlesik Odeme Internet Banking")
        return /* @__PURE__ */ n.createElement(Mh, Bt({}, t));
  }
  return /* @__PURE__ */ n.createElement(fe, null);
}, Sh = ({
  icon: t,
  label: e,
  isPrimary: r,
  errorCode: a,
  balance: o
}) => {
  const { t: i } = I.useContext();
  return /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("div", {
    className: "my-16 pipo-mobile-pi pipo-mobile-pi-unavailable"
  }, /* @__PURE__ */ n.createElement("div", {
    className: "flex flex-col"
  }, /* @__PURE__ */ n.createElement("div", {
    className: "flex justify-between items-center"
  }, /* @__PURE__ */ n.createElement("div", {
    className: "flex justify-start items-center"
  }, /* @__PURE__ */ n.createElement("img", {
    className: "w-32 h-20",
    src: t
  }), /* @__PURE__ */ n.createElement("div", {
    className: "w-12"
  }), /* @__PURE__ */ n.createElement("span", {
    className: "H4-Regular text-color-TextPrimary truncate",
    style: {
      direction: "ltr",
      maxWidth: r ? 194 : 255
    }
  }, e), r && /* @__PURE__ */ n.createElement(Jp, {
    text: i("pipo_payin_primary_title")
  })), o && /* @__PURE__ */ n.createElement("div", {
    className: "text-color-TextTertiary  H4-Regular mt-4"
  }, `${i("pipo_payin_pi_balance") ? `${i("pipo_payin_pi_balance")}: ` : ""}${o}`)), /* @__PURE__ */ n.createElement("div", {
    className: "flex mt-6 P3-Regular"
  }, /* @__PURE__ */ n.createElement("div", {
    className: "w-40 ml-4 flex-shrink-0"
  }), /* @__PURE__ */ n.createElement("div", {
    className: "truncate text-color-TextPrimary"
  }, i(En(a)) || "NEED_I18N")))), /* @__PURE__ */ n.createElement(lr, null));
}, Tr = n.memo(Sh);
var kh = Object.defineProperty, Th = Object.defineProperties, Ih = Object.getOwnPropertyDescriptors, Ir = Object.getOwnPropertySymbols, Vi = Object.prototype.hasOwnProperty, ji = Object.prototype.propertyIsEnumerable, gl = (t, e, r) => e in t ? kh(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, et = (t, e) => {
  for (var r in e || (e = {}))
    Vi.call(e, r) && gl(t, r, e[r]);
  if (Ir)
    for (var r of Ir(e))
      ji.call(e, r) && gl(t, r, e[r]);
  return t;
}, yr = (t, e) => Th(t, Ih(e)), Nh = (t, e) => {
  var r = {};
  for (var a in t)
    Vi.call(t, a) && e.indexOf(a) < 0 && (r[a] = t[a]);
  if (t != null && Ir)
    for (var a of Ir(t))
      e.indexOf(a) < 0 && ji.call(t, a) && (r[a] = t[a]);
  return r;
}, hr = (t, e, r) => new Promise((a, o) => {
  var i = (s) => {
    try {
      c(r.next(s));
    } catch (p) {
      o(p);
    }
  }, l = (s) => {
    try {
      c(r.throw(s));
    } catch (p) {
      o(p);
    }
  }, c = (s) => s.done ? a(s.value) : Promise.resolve(s.value).then(i, l);
  c((r = r.apply(t, e)).next());
});
const Bh = "pipo-mobile-payment", Dh = Ft(
  (t, e) => {
    const {
      mergedPaymentMethodsList: r,
      paymentMethodsList: a,
      onSubmit: o,
      onQueryOrder: i,
      onValidate: l,
      onFetchDistrict: c,
      onFetchAddressAutocomplete: s,
      onFetchPlaceDetail: p,
      onRedirectPP: _,
      onSelectPaymentMethod: m,
      onBind: d,
      onScanCard: f,
      onSendEvent: g,
      paymentMethodItemsMap: h,
      onGetUnifiedBinDetail: y,
      isManage: u,
      manageSearch: v,
      sendOtpDisabled: P
    } = t, {
      onFormStateChange: $,
      isValid: x,
      onElementSubmit: N
    } = Ms(), [C, M] = R({}), [b, E] = R(), [O, T] = R(!1), W = ce({ mode: "all" }), {
      reset: re,
      getValues: J,
      formState: { isValid: F, errors: ee, touchedFields: pe }
    } = W, _e = de({
      touchedFields: pe,
      errors: ee
    }), G = yr(et({}, W), {
      formState: yr(et({}, W.formState), { errors: _e })
    }), {
      t: q,
      isFlip: z,
      state: H,
      defaultSendEvent: Ee,
      useOldEvent: ke,
      paymentType: oe,
      renewType: ve
    } = I.useContext(), { config: D = {}, countryOrRegion: B, cardType: L } = H, { showPayBtn: U = !0, showPP: Z = !0 } = D, {
      formatPaymentMethodList: xe,
      formatStoredPaymentMethodList: $e,
      formatUnavailableStoredPaymentMethodList: Be,
      formatUnavailableOtherPaymentMethodList: Ze
    } = Kl(t), {
      uiStoredPaymentMethodList: Te,
      uiOtherPaymentMethodList: rt,
      uiPaymentMethodsList: kt,
      uiOtherUnavailablePaymentMethodList: gt
    } = Wl({
      paymentMethodItemsMap: h,
      formatPaymentMethodList: xe,
      formatStoredPaymentMethodList: $e,
      mergeList: r,
      formatUnavailableOtherPaymentMethodList: Ze
    }), { hasSaved: Et, hasOther: w } = ge(() => ({
      hasSaved: Boolean(Te.length),
      hasOther: Boolean(
        rt.length + Be.length + gt.length
      )
    }), [
      Be,
      Te,
      rt,
      gt
    ]), A = (S) => {
      g == null || g(S), Ee == null || Ee(S);
    }, Ie = () => {
      let S = "", X = "", me = "", se = "";
      const Y = Te.map((ye, Nt) => {
        const Gt = ye.paymentMethodType.paymentMethodType, Dn = ye.paymentMethod.paymentMethod, Fr = ye.token || "";
        return ye.isPrimary && (S = Fr), ye.defaultSelected && X.length === 0 && (X = Dn, se = Gt, me = Fr), `${Nt}, ${Gt}, ${Dn}, ${Fr}`;
      }), ot = rt.map((ye, Nt) => {
        var Gt;
        return ye.defaultSelected && X.length === 0 && (X = ye.paymentMethod.paymentMethod, se = ye.paymentMethodType.paymentMethodType), ye.needMerge ? `${Nt}, ${q(((Gt = ye.paymentMethodType.title) == null ? void 0 : Gt.payment) || "") || ye.paymentMethodType.paymentMethodType}` : `${Nt}, ${ye.paymentMethod.paymentMethod}`;
      }), lt = {
        name: "fp_sdk_checkout_dropin_element_show",
        metrics: {
          enter_timestamp: Se
        },
        categories: {
          primary_method: S,
          saved_method_array: Y.join("; "),
          other_method_array: ot.join("; "),
          default_payment_method: X,
          default_pi: me,
          default_payment_type: se
        }
      };
      A(lt);
    }, nt = (S) => {
      const X = Date.now();
      A({
        name: "fp_sdk_checkout_dropin_stay_time",
        metrics: {
          enter_timestamp: Se,
          leave_timestamp: X
        },
        categories: {
          quit_type: S
        }
      });
    };
    j(
      () => {
        const S = () => {
          nt("leave_page");
        };
        return Ie(), window.addEventListener("beforeunload", S), () => {
          window.removeEventListener("beforeunload", S), nt("close_pipo");
        };
      },
      []
    );
    const { isSelected: Qe, select: Ut, selected: Pe } = Jl({
      list: kt,
      onSelectPaymentMethod: m
    }), Yt = ge(() => F && O && Pe.length > 0, [O, F, Pe]), [Rr] = R(!1), Se = Date.now();
    j(
      () => {
        var S;
        if (re(), !Pe[0])
          return;
        const X = Pe[0].type, me = Pe[0].paymentMethod.paymentMethodId;
        (X === "others" && !ss.find(
          (se) => se.paymentMethod.paymentMethodId === me
        ) || X === "stored" && !cs.find(
          (se) => se.paymentMethod.paymentMethodId === me
        ) || X === "stored" && ((S = Pe[0]) == null ? void 0 : S.isAgreementBound)) && T(!0), E(void 0);
      },
      [Pe]
    );
    const Pt = Rt(), Tt = Rt(), dt = (S) => hr(void 0, null, function* () {
      if (S == null || S.preventDefault(), Pe.length === 0)
        return;
      if (b) {
        Pt.formSubmitState.setTrue(), yield o(b), Pt.formSubmitState.setFalse();
        return;
      }
      const X = C, { storeCard: me = !1 } = X, se = Nh(X, ["storeCard"]), [Y] = Pe;
      A({
        name: "fp_sdk_checkout_dropin_element_click",
        metrics: {
          time_cost_to_pay: Date.now() - Se
        },
        categories: {
          click_scenario: "pay",
          payment_type: Y.paymentMethodType.paymentMethodType,
          payment_method: Y.paymentMethod.paymentMethod,
          bank_code: se.bank_code || "",
          payment_method_id: Y.paymentMethod.paymentMethodId,
          pi: Y.token || "",
          saved_pi: Y.token ? "saved" : "other"
        }
      }), ke && A({
        name: "fp_sdk_checkout_page_click",
        metrics: {
          time_cost_to_pay: Date.now() - Se
        },
        categories: {
          click_method: "confirm",
          pi_type_1: Y.paymentMethodType.paymentMethodType,
          pi_type_2: Y.paymentMethod.paymentMethod,
          pi_type_3: se.bank_code || "",
          pm_id: Y.paymentMethod.paymentMethodId,
          saved_pi: Y.token ? "saved" : "other",
          is_save_for_next_time: Y.token ? "" : me ? "1" : "0"
        }
      }), Pt.formSubmitState.setTrue(), yield o(et({
        formData: se,
        paymentMethodType: Y.paymentMethodType.paymentMethodType,
        paymentMethod: Y.paymentMethod,
        storeCard: me,
        token: Y.token,
        isAgreementBound: Boolean(Y.token) && (Y == null ? void 0 : Y.isAgreementBound) || !1,
        paymentParams: fn({
          paymentMethodType: Y.paymentMethodType.paymentMethodType,
          paymentMethod: Y.paymentMethod.paymentMethod,
          paymentMethodId: Y.paymentMethod.paymentMethodId,
          data: se
        })
      }, ms({
        paymentMethodId: Y.paymentMethod.paymentMethodId,
        data: se
      }))), Pt.formSubmitState.setFalse();
    }), zt = () => hr(void 0, null, function* () {
      if (!d || Pe.length === 0)
        return;
      const [S] = Pe, X = J();
      A({
        name: "fp_sdk_checkout_dropin_element_click",
        metrics: {
          time_cost_to_pay: Date.now() - Se
        },
        categories: {
          click_scenario: "link_now",
          payment_type: S.paymentMethodType.paymentMethodType,
          payment_method: S.paymentMethod.paymentMethod,
          bank_code: X.bank_code || "",
          payment_method_id: S.paymentMethod.paymentMethodId,
          pm_id: S.paymentMethod.paymentMethodId
        }
      }), ke && A({
        name: "fp_sdk_checkout_page_click",
        metrics: {
          time_cost_to_pay: Date.now() - Se
        },
        categories: {
          click_method: "link_now",
          pi_type_1: S.paymentMethodType.paymentMethodType,
          pi_type_2: S.paymentMethod.paymentMethod,
          pi_type_3: "",
          pm_id: S.paymentMethod.paymentMethodId
        }
      }), Tt.formSubmitState.setTrue(), yield d({
        paymentMethodType: S.paymentMethodType.paymentMethodType,
        paymentMethod: {
          paymentMethod: S.paymentMethod.paymentMethod,
          paymentMethodId: S.paymentMethod.paymentMethodId
        },
        paymentParams: fn({
          paymentMethodType: S.paymentMethodType.paymentMethodType,
          paymentMethod: S.paymentMethod.paymentMethod,
          paymentMethodId: S.paymentMethod.paymentMethodId,
          data: X
        }),
        formData: X
      }), Tt.formSubmitState.setFalse();
    }), bt = (S, X) => {
      function me(se, Y) {
        return Y === "PaymentMethodItem";
      }
      me(S, X) && S.needMerge && yn(S, Pe) || Qe(S) || (A({
        name: "fp_sdk_checkout_dropin_element_click",
        metrics: {
          time_cost_to_pay: Date.now() - Se
        },
        categories: {
          click_scenario: me(S, X) && !Qe(S) ? S.token ? "choose_saved_pi" : "choose_other_pi" : "choose_sec_pi",
          payment_type: S.paymentMethodType.paymentMethodType,
          payment_method: S.paymentMethod.paymentMethod,
          bank_code: "",
          payment_method_id: S.paymentMethod.paymentMethodId,
          pi: S.token || "",
          saved_pi: S.token ? "saved" : "other"
        }
      }), ke && A({
        name: "fp_sdk_checkout_page_click",
        metrics: {
          time_cost_to_pay: Date.now() - Se
        },
        categories: {
          click_method: me(S, X) && !Qe(S) ? "pi_choose" : "sec_pi_choose",
          pi_type_1: S.paymentMethodType.paymentMethodType,
          pi_type_2: S.paymentMethod.paymentMethod,
          pi_type_3: "",
          pm_id: S.paymentMethod.paymentMethodId,
          saved_pi: S.token ? "saved" : "other"
        }
      }), m == null || m(S), M({}), Ut(S));
    }, He = () => {
      A({
        name: "fp_sdk_checkout_dropin_element_click",
        metrics: {
          time_cost_to_pay: Date.now() - Se
        },
        categories: {
          click_scenario: "pi_management"
        }
      }), ke && A({
        name: "fp_sdk_checkout_page_click",
        metrics: {
          time_cost_to_pay: Date.now() - Se
        },
        categories: {
          click_method: "pi_management"
        }
      });
    }, mr = (S) => {
      var X, me;
      const se = ds(S), Y = {
        isSelected: Qe(S),
        onSelect: () => bt(S, "PaymentMethodItem"),
        isPrimary: Boolean(S.isPrimary),
        isExpired: se,
        disabled: se,
        icon: S.paymentMethod.icon.iconUrl,
        label: $t(S, q),
        balance: S.balance,
        marketingTextList: Ln(S),
        "data-sel": `pipo-mobile-pi-${(me = (X = S.paymentMethod) == null ? void 0 : X.paymentMethod) == null ? void 0 : me.toLowerCase()}`
      }, ot = {
        item: S,
        selected: Pe,
        onSelect: (lt) => bt(lt, "PaymentMethodExtra"),
        value: C,
        onChange: M,
        onValidate: T,
        paymentMethodsList: a,
        onFetchDistrict: c,
        onBindSubmit: zt,
        isSubmitting: Tt.isSubmitting,
        onSendEvent: A,
        onSendOTP: dt,
        sendOtpDisabled: P
      };
      if (S.paymentMethod.paymentMethodId !== "pm_pi_ew_ovo_c_r" && zl(S)) {
        const lt = S.formRender;
        return /* @__PURE__ */ n.createElement(lt, yr(et({
          key: S.token
        }, Y), {
          extraProps: ot,
          onFormStateChange: $,
          onSubmit: o,
          onBind: d,
          eventLogExtra: { startTime: Se }
        }));
      }
      return /* @__PURE__ */ n.createElement(rr, et({
        key: S.token
      }, Y), D_(ot));
    }, V = xn(!1), { showList: ne, hiddenList: te, handleClickSeeMore: le } = ge(
      () => {
        const S = Te.length > 3, X = [], me = [], se = () => {
          _s({
            eventTrackingFunc: A,
            showHiddenItems: V.state,
            startTime: Se,
            useOldEvent: ke
          }), V.toggle();
        };
        return Te.forEach((Y, ot) => {
          (S ? ot < 2 : !0) ? X.push(mr(Y)) : me.push(mr(Y));
        }), { showList: X, hiddenList: me, handleClickSeeMore: se };
      },
      [Te, V]
    );
    Os({
      handleSelect: bt,
      uiPaymentMethodsList: kt,
      uiStoredPaymentMethodList: Te
    });
    const { activePath: at, routerParams: Xt } = sr(e, {
      initPath: "payment-methods",
      initParams: {
        onSubmit: o,
        onValidate: l,
        onQueryOrder: i,
        paymentMethodList: t.paymentMethodsList,
        isValid: Yt,
        onScanCard: f,
        onSendEvent: A
      },
      instanceMethods: {
        submit: It,
        bindSubmit: () => hr(void 0, null, function* () {
          return yield zt();
        })
      }
    });
    function It() {
      return hr(this, null, function* () {
        yield dt();
      });
    }
    return at === "voucher" ? /* @__PURE__ */ n.createElement(jp, et({}, Xt)) : /* @__PURE__ */ n.createElement("div", {
      className: "pipo-mobile w-full h-full",
      style: { direction: z ? "rtl" : "ltr" },
      "data-sel": "pipo-mobile-payment-methods-wrapper"
    }, /* @__PURE__ */ n.createElement("div", {
      style: { overflowX: "unset", position: "relative" },
      className: "w-full h-full box-border"
    }, /* @__PURE__ */ n.createElement(jl, et({}, G), /* @__PURE__ */ n.createElement("form", {
      className: "w-full h-full",
      onKeyDown: (S) => {
        S.keyCode === 13 && S.preventDefault();
      }
    }, /* @__PURE__ */ n.createElement("div", {
      className: "pt-24 pb-24 pl-16 pr-16 w-full h-full",
      style: {
        overflowY: "auto",
        position: "relative",
        height: "calc(100% - 96px)",
        overflowX: "unset"
      }
    }, /* @__PURE__ */ n.createElement("div", {
      className: ae(
        `${oe === "agreement" || oe === "subscription" && ve === "auto" ? "H3-SemiBold text-color-TextPrimary" : "P2-SemiBold text-color-TextTertiary"} mb-24`,
        `${Bh}-saved-cards`
      )
    }, oe === "agreement" || oe === "subscription" && ve === "auto" ? Et && q("pipo_payin_saveagreemnetdeductionassett") : (Et || w) && q("pipo_payin_select_payment_method"), u && (Te.length || (Be == null ? void 0 : Be.length)) ? /* @__PURE__ */ n.createElement("span", {
      className: "pc-payment-manage"
    }, /* @__PURE__ */ n.createElement("a", {
      className: "mobile-payment-manage",
      href: v,
      target: "_blank",
      rel: "noreferrer noopener",
      onClick: He
    }, "Manage")) : null), /* @__PURE__ */ n.createElement("div", null, ne.map((S) => S), /* @__PURE__ */ n.createElement("div", {
      className: `pipo-checkout-mobile-stored-list-${V.state ? "show" : "hide"}`
    }, te.map((S) => S)), te.length !== 0 && !V.state && /* @__PURE__ */ n.createElement(Nd, {
      onClick: le
    })), (oe === "agreement" || oe === "subscription" && ve === "auto") && w ? /* @__PURE__ */ n.createElement("div", {
      className: `H3-SemiBold text-color-TextPrimary mb-24 pipo-mobile-agreement-subtitle ${Et ? "mt-32" : ""}`
    }, q("pipo_payin_addnewagreementdeductionassets")) : null, rt.map((S, X) => {
      var me, se;
      const Y = S;
      if (Y.paymentMethod.paymentMethodId === "pm_pi_bt_banktransfer_c_d" && B === "TR" && (Y.paymentMethod.icon.iconUrl = "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/bointernetbankinggrey_a1ec03.png", Y.paymentMethod.starling_key = "pipo_payin_logo_Birlesik_Odeme_bank_transfer"), ps.includes(
        Y.paymentMethod.paymentMethodId
      ))
        return null;
      const ot = {
        item: Y,
        selected: Pe,
        onSelect: (ye) => bt(ye, "PaymentMethodExtra"),
        onSubmit: dt,
        value: C,
        onChange: (ye, Nt) => {
          M(ye), E(Nt);
        },
        onValidate: (ye) => T(ye),
        paymentMethodsList: a,
        onFetchDistrict: c,
        onFetchAddressAutocomplete: s,
        onFetchPlaceDetail: p,
        onBindSubmit: zt,
        onSendOTP: dt,
        isSubmitting: Tt.isSubmitting,
        onSendEvent: A,
        onScanCard: f,
        onGetUnifiedBinDetail: y,
        sendOtpDisabled: P
      }, lt = {
        type: "select",
        onSelect: () => bt(Y, "PaymentMethodItem"),
        isSelected: S.needMerge ? yn(S, Pe) : Qe(S),
        icon: Y.needMerge ? Y.paymentMethodType.icon.iconUrl : Y.paymentMethod.icon.iconUrl,
        label: Yl({ item: Y, t: q, cardType: L }),
        marketingTextList: Ln(S),
        "data-sel": `pipo-mobile-pi-other-${(se = (me = Y.paymentMethod) == null ? void 0 : me.paymentMethod) == null ? void 0 : se.toLowerCase()}`
      };
      if (hn(S)) {
        const ye = S.formRender;
        return /* @__PURE__ */ n.createElement(ye, yr(et({
          key: `${Y.paymentMethod.paymentMethodId}${X}`
        }, lt), {
          extraProps: ot,
          onFormStateChange: $,
          onSubmit: o,
          onBind: d,
          eventLogExtra: { startTime: Se }
        }));
      }
      return /* @__PURE__ */ n.createElement(rr, et({
        key: `${Y.paymentMethod.paymentMethodId}${X}`
      }, lt), /* @__PURE__ */ n.createElement($h, et({}, ot)));
    }), Be.map((S) => /* @__PURE__ */ n.createElement(Tr, {
      key: S.token,
      errorCode: S.unavailableErrorCode,
      icon: S.paymentMethod.icon.iconUrl,
      label: $t(S, q),
      balance: S.balance
    })), gt.map((S, X) => /* @__PURE__ */ n.createElement(Tr, {
      key: `${S.paymentMethod.paymentMethodId}${X}`,
      errorCode: S.unavailableErrorCode,
      icon: S.paymentMethod.icon.iconUrl,
      label: $t(S, q)
    })), Z && /* @__PURE__ */ n.createElement(qt, {
      type: "payment",
      onRedirectPP: _
    })), U && /* @__PURE__ */ n.createElement("div", {
      style: { position: "absolute", bottom: 0 },
      className: "w-full"
    }, /* @__PURE__ */ n.createElement(Lr, {
      onClick: N || dt,
      isValid: x !== void 0 ? x : Yt,
      isLoading: Pt.isSubmitting,
      toExtend: Rr,
      selectedType: Pe[0] ? Pe[0].type : "others"
    }))))));
  }
);
Dh.displayName = "PaymentMethods";
var Vh = Object.defineProperty, jh = Object.defineProperties, Lh = Object.getOwnPropertyDescriptors, El = Object.getOwnPropertySymbols, Rh = Object.prototype.hasOwnProperty, Fh = Object.prototype.propertyIsEnumerable, Pl = (t, e, r) => e in t ? Vh(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Ah = (t, e) => {
  for (var r in e || (e = {}))
    Rh.call(e, r) && Pl(t, r, e[r]);
  if (El)
    for (var r of El(e))
      Fh.call(e, r) && Pl(t, r, e[r]);
  return t;
}, Hh = (t, e) => jh(t, Lh(e));
const qh = ({
  onSendEvent: t,
  onBindSubmit: e,
  isSubmitting: r
}) => {
  var a, o;
  const i = vt(), {
    control: l,
    formState: { errors: c },
    getValues: s,
    setValue: p
  } = i, { errors: _ } = Br({
    control: l
  }), {
    t: m,
    getErrorText: d,
    state: { amount: f, countryOrRegion: g },
    noBindButton: h
  } = I.useContext(), y = (o = (a = ue.list) == null ? void 0 : a[g]) == null ? void 0 : o.code, { phone: u = {} } = ue.list[g], { pattern: v, maxLength: P } = u;
  p("phone_country_code", y);
  const $ = (x, N) => {
    const C = {
      paymentMethodType: rn.paymentMethodType.paymentMethodType,
      paymentMethod: rn.paymentMethod.paymentMethod,
      paymentMethodId: rn.paymentMethod.paymentMethodId
    };
    ie({
      event: f != null && f.value ? "fp_sdk_checkout_fill_in" : "fp_sdk_checkout_pi_management_fill_in",
      scenario: x,
      fieldState: N,
      getValues: s,
      onSendEvent: t,
      paymentMethodInfo: C
    });
  };
  return /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("div", {
    className: "payment-installment-akulaku-form mb-24"
  }, !h && /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0 },
    name: "bind_required",
    control: l,
    render: (x) => /* @__PURE__ */ n.createElement("div", null)
  }), /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0 },
    name: "phone_country_code",
    control: l,
    render: ({ field: x }) => /* @__PURE__ */ n.createElement(pt, {
      countryCode: y,
      onChange: x.onChange
    })
  }), /* @__PURE__ */ n.createElement(k, {
    rules: { required: !0, pattern: v },
    name: "phone",
    control: l,
    render: ({ field: x, fieldState: N }) => {
      var C;
      return /* @__PURE__ */ n.createElement("div", {
        className: "flex"
      }, /* @__PURE__ */ n.createElement("div", {
        className: "flex-shrink-0",
        style: { width: "44px" }
      }), /* @__PURE__ */ n.createElement("div", {
        className: "flex-grow"
      }, /* @__PURE__ */ n.createElement(Fe, Hh(Ah({}, x), {
        title: m("pipo_common_payin_phone_number"),
        error: c.phone,
        errorMessage: d(
          (C = c.phone) == null ? void 0 : C.type,
          m("pipo_common_payin_phone_number")
        ),
        placeholder: m("pipo_common_link_ewallet_need_info"),
        autoFocus: !0,
        onBlur: () => {
          x.onBlur(), $("phone", N);
        },
        maxLength: P
      }))));
    }
  })), !h && /* @__PURE__ */ n.createElement(Je, {
    onClick: e,
    intro: !1,
    disabled: !gn({ items: ["phone"], errors: _, getValues: s }),
    isLoading: r
  }));
};
var Uh = Object.defineProperty, Yh = Object.defineProperties, zh = Object.getOwnPropertyDescriptors, Nr = Object.getOwnPropertySymbols, Li = Object.prototype.hasOwnProperty, Ri = Object.prototype.propertyIsEnumerable, bl = (t, e, r) => e in t ? Uh(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Xh = (t, e) => {
  for (var r in e || (e = {}))
    Li.call(e, r) && bl(t, r, e[r]);
  if (Nr)
    for (var r of Nr(e))
      Ri.call(e, r) && bl(t, r, e[r]);
  return t;
}, Gh = (t, e) => Yh(t, zh(e)), Kh = (t, e) => {
  var r = {};
  for (var a in t)
    Li.call(t, a) && e.indexOf(a) < 0 && (r[a] = t[a]);
  if (t != null && Nr)
    for (var a of Nr(t))
      e.indexOf(a) < 0 && Ri.call(t, a) && (r[a] = t[a]);
  return r;
};
const Wh = (t) => {
  var e = t, {
    subPaymentMethodList: r,
    onBindSubmit: a
  } = e, o = Kh(e, [
    "subPaymentMethodList",
    "onBindSubmit"
  ]);
  const { t: i } = I.useContext(), [l, c] = n.useState(r[0]), s = () => {
    a(l);
  };
  return /* @__PURE__ */ n.createElement("div", {
    className: "payment-installment-extra"
  }, r.map((p) => {
    const {
      paymentMethod: {
        displayName: _,
        starling_key: m,
        paymentMethodId: d,
        icon: { iconUrl: f }
      }
    } = p;
    return /* @__PURE__ */ n.createElement(Sr, {
      onClick: () => {
        c(p);
      },
      isSelected: l.paymentMethod.paymentMethodId === d,
      value: "",
      key: d,
      iconUrl: f,
      title: i(m) || _ || ""
    });
  }), l.paymentMethod.paymentMethodId === "pm_pi_ins_akulaku_c_r" && /* @__PURE__ */ n.createElement(qh, Gh(Xh({}, o), {
    onBindSubmit: s
  })));
};
var Jh = Object.defineProperty, Zh = Object.defineProperties, Qh = Object.getOwnPropertyDescriptors, xl = Object.getOwnPropertySymbols, ef = Object.prototype.hasOwnProperty, tf = Object.prototype.propertyIsEnumerable, Ml = (t, e, r) => e in t ? Jh(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, rf = (t, e) => {
  for (var r in e || (e = {}))
    ef.call(e, r) && Ml(t, r, e[r]);
  if (xl)
    for (var r of xl(e))
      tf.call(e, r) && Ml(t, r, e[r]);
  return t;
}, nf = (t, e) => Zh(t, Qh(e));
const af = (t) => {
  const { isFlip: e } = I.useContext(), [r, a] = R(!1);
  return /* @__PURE__ */ n.createElement("div", {
    className: "w-full"
  }, /* @__PURE__ */ n.createElement("div", {
    style: e ? { marginRight: "44px" } : { marginLeft: "44px" }
  }, /* @__PURE__ */ n.createElement(Nn, nf(rf({}, t), {
    onValidate: (o) => {
      a(o);
    },
    showSavingBox: !1
  }))), /* @__PURE__ */ n.createElement("div", {
    className: "mt-24"
  }, /* @__PURE__ */ n.createElement(Je, {
    onClick: t.onBindSubmit,
    intro: !1,
    disabled: !r,
    isLoading: t.isSubmitting
  })));
};
var of = Object.defineProperty, lf = Object.defineProperties, sf = Object.getOwnPropertyDescriptors, Ol = Object.getOwnPropertySymbols, cf = Object.prototype.hasOwnProperty, pf = Object.prototype.propertyIsEnumerable, Cl = (t, e, r) => e in t ? of(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, mf = (t, e) => {
  for (var r in e || (e = {}))
    cf.call(e, r) && Cl(t, r, e[r]);
  if (Ol)
    for (var r of Ol(e))
      pf.call(e, r) && Cl(t, r, e[r]);
  return t;
}, df = (t, e) => lf(t, sf(e));
const _f = (t) => {
  const { isFlip: e } = I.useContext(), [r, a] = R(!1);
  return /* @__PURE__ */ n.createElement("div", {
    className: "w-full"
  }, /* @__PURE__ */ n.createElement("div", {
    style: e ? { marginRight: "44px" } : { marginLeft: "44px" }
  }, /* @__PURE__ */ n.createElement(In, df(mf({}, t), {
    onValidate: (o) => {
      a(o);
    },
    showSavingBox: !1
  }))), /* @__PURE__ */ n.createElement(qt, {
    type: "bind"
  }), /* @__PURE__ */ n.createElement("div", {
    className: "mt-24"
  }, /* @__PURE__ */ n.createElement(Je, {
    onClick: t.onBindSubmit,
    intro: !1,
    disabled: !r,
    isLoading: t.isSubmitting
  })));
};
var uf = Object.defineProperty, yf = Object.defineProperties, hf = Object.getOwnPropertyDescriptors, wl = Object.getOwnPropertySymbols, ff = Object.prototype.hasOwnProperty, vf = Object.prototype.propertyIsEnumerable, $l = (t, e, r) => e in t ? uf(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, gf = (t, e) => {
  for (var r in e || (e = {}))
    ff.call(e, r) && $l(t, r, e[r]);
  if (wl)
    for (var r of wl(e))
      vf.call(e, r) && $l(t, r, e[r]);
  return t;
}, Ef = (t, e) => yf(t, hf(e));
const Pf = (t) => {
  const { isFlip: e } = I.useContext(), [r, a] = R(!1);
  return /* @__PURE__ */ n.createElement("div", {
    className: "w-full"
  }, /* @__PURE__ */ n.createElement("div", {
    style: e ? { marginRight: "44px" } : { marginLeft: "44px" }
  }, /* @__PURE__ */ n.createElement(Bn, Ef(gf({}, t), {
    onValidate: (o) => {
      a(o);
    },
    showSavingBox: !1
  }))), /* @__PURE__ */ n.createElement(qt, {
    type: "bind"
  }), /* @__PURE__ */ n.createElement("div", {
    className: "mt-24"
  }, /* @__PURE__ */ n.createElement(Je, {
    onClick: t.onBindSubmit,
    intro: !1,
    disabled: !r,
    isLoading: t.isSubmitting
  })));
};
var bf = Object.defineProperty, Sl = Object.getOwnPropertySymbols, xf = Object.prototype.hasOwnProperty, Mf = Object.prototype.propertyIsEnumerable, kl = (t, e, r) => e in t ? bf(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, dn = (t, e) => {
  for (var r in e || (e = {}))
    xf.call(e, r) && kl(t, r, e[r]);
  if (Sl)
    for (var r of Sl(e))
      Mf.call(e, r) && kl(t, r, e[r]);
  return t;
};
const Of = (t) => {
  const { item: e, onBindSubmit: r, isSubmitting: a, onSendEvent: o } = t;
  switch (e.paymentMethodType.paymentMethodType) {
    case "INSTALLMENT":
      return /* @__PURE__ */ n.createElement(Wh, {
        subPaymentMethodList: e.subPaymentMethodList,
        onBindSubmit: r,
        isSubmitting: a,
        onSendEvent: o
      });
    case "CCDC": {
      if (e.paymentMethod.paymentMethod !== "CARD_QIWI")
        return /* @__PURE__ */ n.createElement(af, dn({}, t));
      break;
    }
  }
  switch (e.paymentMethod.paymentMethodId) {
    case "pm_pi_ew_ovo_c_r": {
      if (r)
        return /* @__PURE__ */ n.createElement(Si, {
          onBindSubmit: r,
          isSubmitting: a,
          onSendEvent: o
        });
      break;
    }
    case "pm_pi_ew_shopeepay_c_r": {
      if (r) {
        const i = Ul(e, [
          /* @__PURE__ */ n.createElement(Ni, {
            onBindSubmit: r,
            key: "ShopeepayForm",
            onSendEvent: o,
            isSubmitting: a
          }),
          /* @__PURE__ */ n.createElement(fr, {
            bindButtonProps: {
              onClick: r,
              isLoading: a
            },
            key: "BindRequiredButton"
          }),
          null
        ]);
        if (i)
          return i;
      }
      break;
    }
    case "pm_pi_cp_boleto_c_d":
      return /* @__PURE__ */ n.createElement(_f, dn({}, t));
    case "pm_pi_bap_pix_c_d":
      return /* @__PURE__ */ n.createElement(Pf, dn({}, t));
  }
  return /* @__PURE__ */ n.createElement(lr, null);
}, Cf = {
  set_primary: {
    title: "pipo_payin_sgpimanage_primarypopup_buttonm",
    icon: /* @__PURE__ */ n.createElement(ec, null),
    modal: {
      title: "pipo_payin_sgpimanage_primarypopup_title",
      tipsFirst: "pipo_payin_sgpimanage_primarypopup_body",
      tipsSecond: "pipo_payin_sgpimanage_primarypopup_body1",
      btnPrimary: {
        title: "pipo_payin_sgpimanage_primarypopup_buttonm",
        onDismiss: !1
      },
      btnSecondary: {
        title: "pipo_payin_sgpimanage_primarypopup_buttons",
        onDismiss: !0
      }
    }
  },
  remove: {
    title: "pipo_payin_sgpimanage_unbindpopup_buttons",
    icon: /* @__PURE__ */ n.createElement(tc, null),
    modal: {
      title: "pipo_payin_sgpimanage_unbindpopup_title",
      tipsFirst: "pipo_payin_sgpimanage_unbindpopup_body",
      tipsSecond: "",
      btnPrimary: {
        title: "pipo_payin_sgpimanage_unbindpopup_buttonm",
        onDismiss: !0
      },
      btnSecondary: {
        title: "pipo_payin_sgpimanage_unbindpopup_buttons",
        onDismiss: !1
      }
    }
  },
  terminate: {
    title: "pipo_payin_state_pi_terminate",
    icon: /* @__PURE__ */ n.createElement(rc, null),
    modal: {
      title: "pipo_payin_state_pi_mobile_title_terminate",
      tipsFirst: "pipo_payin_instruction_pi_mobile_confirm_terminate",
      tipsSecond: "",
      btnPrimary: {
        title: "pipo_payin_sgpimanage_unbindpopup_buttonm",
        onDismiss: !0
      },
      btnSecondary: {
        title: "pipo_payin_state_pi_button_terminate",
        onDismiss: !1
      }
    }
  }
}, _n = (t) => {
  const { btnType: e, onClick: r, detail: a, onSendEvent: o } = t, i = Cf[e], [l, c] = R(!1), s = Ne(
    () => {
      o && o({
        name: "fp_sdk_checkout_popup_click",
        categories: {
          scenario: e,
          click_method: "cancel",
          pi_type_1: a.paymentMethodType.paymentMethodType,
          pi_type_2: a.paymentMethod.paymentMethod,
          pi_type_3: "",
          pm_id: a.paymentMethod.paymentMethodId
        }
      }), c(!1);
    },
    []
  ), p = () => {
    o && o({
      name: "fp_sdk_checkout_popup_click",
      categories: {
        scenario: e,
        click_method: "confirm",
        pi_type_1: a.paymentMethodType.paymentMethodType,
        pi_type_2: a.paymentMethod.paymentMethod,
        pi_type_3: "",
        pm_id: a.paymentMethod.paymentMethodId
      }
    }), r();
  }, { t: _, isFlip: m } = I.useContext();
  return /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("div", {
    className: "box-border",
    "data-sel": "pipo-mobile-piitem-btn-set-primary",
    onClick: () => {
      o && o({
        name: "fp_sdk_checkout_pi_detail_click",
        categories: {
          click_method: e,
          pi_type_1: a.paymentMethodType.paymentMethodType,
          pi_type_2: a.paymentMethod.paymentMethod,
          pi_type_3: "",
          pm_id: a.paymentMethod.paymentMethodId
        }
      }), c(!0), o && o({
        name: "fp_sdk_checkout_popup_show",
        categories: {
          scenario: e,
          pi_type_1: a.paymentMethodType.paymentMethodType,
          pi_type_2: a.paymentMethod.paymentMethod,
          pi_type_3: "",
          pm_id: a.paymentMethod.paymentMethodId
        }
      });
    }
  }, /* @__PURE__ */ n.createElement("div", {
    className: "flex justify-between items-center py-16"
  }, /* @__PURE__ */ n.createElement("div", {
    className: "flex justify-start items-center"
  }, i.icon, /* @__PURE__ */ n.createElement("span", {
    className: ae(
      "H4-Regular text-color-TextPrimary",
      m ? "mr-12" : "ml-12"
    )
  }, _(i.title))), /* @__PURE__ */ n.createElement("div", {
    className: "pipo-mobile-pi-list-item-info-right"
  }, /* @__PURE__ */ n.createElement(Fs, {
    color: "#C4C4C4",
    fontSize: 18
  }))), /* @__PURE__ */ n.createElement("div", {
    className: "background-color-LineSecondary",
    style: { height: 1, transform: "scaleY(0.5)" }
  })), /* @__PURE__ */ n.createElement(ei, {
    isVisible: l,
    title: _(i.modal.title),
    message: /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("p", null, _(i.modal.tipsFirst)), /* @__PURE__ */ n.createElement("p", null, _(i.modal.tipsSecond))),
    onDismiss: s,
    actionVariant: "text",
    actionDirection: "vertical",
    actions: [
      {
        variant: "primary",
        text: `${_(i.modal.btnPrimary.title)}`,
        onClick: i.modal.btnPrimary.onDismiss ? s : p
      },
      {
        variant: "secondary",
        text: `${_(i.modal.btnSecondary.title)}`,
        onClick: i.modal.btnSecondary.onDismiss ? s : p
      }
    ]
  }));
};
var Dt = (t, e, r) => new Promise((a, o) => {
  var i = (s) => {
    try {
      c(r.next(s));
    } catch (p) {
      o(p);
    }
  }, l = (s) => {
    try {
      c(r.throw(s));
    } catch (p) {
      o(p);
    }
  }, c = (s) => s.done ? a(s.value) : Promise.resolve(s.value).then(i, l);
  c((r = r.apply(t, e)).next());
});
const tt = "pipo-mobile-pi-details-card", wf = (t) => {
  var e;
  const {
    showSetPrimaryButton: r = !0,
    detail: a,
    onSetPrimary: o,
    onRemove: i,
    onSendEvent: l,
    onTerminate: c
  } = t, { isExpired: s, balance: p, expiryDate: _ } = a, { t: m, isFlip: d } = I.useContext(), [f, g] = R(a.isPrimary), h = a.paymentMethodType.paymentMethodType !== "CCDC" && a.paymentMethodType.paymentMethodType !== "BANK_ACCOUNT_PROXY", y = () => Dt(void 0, null, function* () {
    if (!o || !a.token)
      return;
    const x = yield o(a.token);
    g(x);
  }), u = () => Dt(void 0, null, function* () {
    !a.token || (yield i(a.token));
  }), v = () => Dt(void 0, null, function* () {
    !a.token || !c || (yield c(a.token));
  });
  j(
    () => {
      l == null || l({
        name: "fp_sdk_checkout_pi_detail_show",
        categories: {
          pi_type_1: a.paymentMethodType.paymentMethodType || "",
          pi_type_2: a.paymentMethod.paymentMethod || "",
          pi_type_3: "",
          pm_id: a.paymentMethod.paymentMethodId
        }
      });
    },
    []
  );
  const P = () => {
    const { title: x } = a;
    if (!x)
      return /* @__PURE__ */ n.createElement("span", {
        className: `${tt}-emptyCode-mask`
      }, m("pipo_payin_state_withoutbindinfo") || "Account linked");
    switch (a.paymentMethodType.paymentMethodType) {
      case "CCDC": {
        const N = x.length > 4 ? x.substring(x.length - 4) : "";
        return /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("div", {
          className: `${tt}-code-mask-ccdc mr-12`
        }, "****"), /* @__PURE__ */ n.createElement("div", {
          className: `${tt}-code-mask-ccdc mr-12`
        }, "****"), /* @__PURE__ */ n.createElement("div", {
          className: `${tt}-code-mask-ccdc mr-12`
        }, "****"), /* @__PURE__ */ n.createElement("div", null, N));
      }
      default: {
        const N = x.replace(/\*+/g, (C) => `<span class="${`${tt}-code-mask`}">${C}</span>`);
        return /* @__PURE__ */ n.createElement("div", {
          style: { overflow: "hidden", textOverflow: "ellipsis" },
          dangerouslySetInnerHTML: { __html: N }
        });
      }
    }
  }, $ = xn(!1);
  return /* @__PURE__ */ n.createElement("div", {
    className: "pipo-mobile box-border h-full px-20 py-16"
  }, /* @__PURE__ */ n.createElement("div", {
    className: `${tt} pipo-mobile-color-reverse rounded-8 text-color-ConstTextInverse mb-8 px-16 py-24 ${s ? "background-color-ConstBGInverse4" : "background-color-ConstBGInverse"} `
  }, /* @__PURE__ */ n.createElement("div", {
    className: "flex items-center"
  }, /* @__PURE__ */ n.createElement("div", {
    className: ae(
      `${tt}-info-left flex items-center justify-center`,
      d ? "ml-12" : "mr-12"
    )
  }, /* @__PURE__ */ n.createElement("img", {
    className: "rounded-2",
    width: 34,
    height: 34,
    style: { objectFit: "contain" },
    onLoad: () => $.setTrue(),
    src: ((e = a.paymentMethod.icon) == null ? void 0 : e.detailIconUrl) || a.paymentMethod.icon.iconUrl
  })), /* @__PURE__ */ n.createElement("div", {
    className: "w-full"
  }, /* @__PURE__ */ n.createElement("div", {
    className: "flex items-center justify-between w-full"
  }, /* @__PURE__ */ n.createElement("div", {
    className: "flex items-center"
  }, /* @__PURE__ */ n.createElement("div", {
    className: "H4-Regular"
  }, /* @__PURE__ */ n.createElement("span", null, a.paymentMethod.displayName)), f && /* @__PURE__ */ n.createElement("div", {
    className: `${tt}-info-primary rounded-2 SmallText2-Regular text-color-TextPrimary background-color-BGPrimary`
  }, /* @__PURE__ */ n.createElement("span", null, m("pipo_payin_primary_title")))), /* @__PURE__ */ n.createElement("div", null, p && /* @__PURE__ */ n.createElement("div", {
    className: "SmallText1-SemiBold text-color-ConstTextInverse"
  }, p))), /* @__PURE__ */ n.createElement("div", {
    className: "flex items-center justify-between w-full mr-2"
  }, /* @__PURE__ */ n.createElement("div", null, h && /* @__PURE__ */ n.createElement("div", {
    className: `${tt}-card-type flex items-center h-12 P3-Regular mt-6`
  }, m(a.paymentMethodType.starling_key))), /* @__PURE__ */ n.createElement("div", null, _ && /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("span", {
    className: "SmallText1-Regular text-color-ConstTextInverse3"
  }, m("pipo_common_payin_expiry_date"), ":", " "), /* @__PURE__ */ n.createElement("span", {
    className: "SmallText1-Regular text-color-ConstTextInverse"
  }, _)))))), /* @__PURE__ */ n.createElement("div", {
    className: `${tt}-code H2-SemiBold flex mt-24 mb-10`
  }, P())), r && !f && !s && /* @__PURE__ */ n.createElement(_n, {
    btnType: "set_primary",
    detail: a,
    onClick: () => Dt(void 0, null, function* () {
      yield y();
    }),
    onSendEvent: l
  }), /* @__PURE__ */ n.createElement(_n, {
    btnType: "remove",
    detail: a,
    onClick: () => Dt(void 0, null, function* () {
      yield u();
    }),
    onSendEvent: l
  }), c && /* @__PURE__ */ n.createElement(_n, {
    btnType: "terminate",
    detail: a,
    onClick: () => Dt(void 0, null, function* () {
      yield v();
    }),
    onSendEvent: l
  }));
};
var $f = Object.defineProperty, Tl = Object.getOwnPropertySymbols, Sf = Object.prototype.hasOwnProperty, kf = Object.prototype.propertyIsEnumerable, Il = (t, e, r) => e in t ? $f(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Tf = (t, e) => {
  for (var r in e || (e = {}))
    Sf.call(e, r) && Il(t, r, e[r]);
  if (Tl)
    for (var r of Tl(e))
      kf.call(e, r) && Il(t, r, e[r]);
  return t;
};
const If = (t) => {
  const { item: e } = t;
  return e.paymentMethodType.paymentMethodType === "CCDC" ? /* @__PURE__ */ n.createElement($i, Tf({}, t)) : /* @__PURE__ */ n.createElement(Je, {
    onClick: () => {
      t.onBindSubmit && t.onBindSubmit();
    },
    intro: !1,
    isLoading: t == null ? void 0 : t.isSubmitting
  });
};
var Nf = Object.defineProperty, Bf = Object.defineProperties, Df = Object.getOwnPropertyDescriptors, Nl = Object.getOwnPropertySymbols, Vf = Object.prototype.hasOwnProperty, jf = Object.prototype.propertyIsEnumerable, Bl = (t, e, r) => e in t ? Nf(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Ke = (t, e) => {
  for (var r in e || (e = {}))
    Vf.call(e, r) && Bl(t, r, e[r]);
  if (Nl)
    for (var r of Nl(e))
      jf.call(e, r) && Bl(t, r, e[r]);
  return t;
}, Vt = (t, e) => Bf(t, Df(e)), er = (t, e, r) => new Promise((a, o) => {
  var i = (s) => {
    try {
      c(r.next(s));
    } catch (p) {
      o(p);
    }
  }, l = (s) => {
    try {
      c(r.throw(s));
    } catch (p) {
      o(p);
    }
  }, c = (s) => s.done ? a(s.value) : Promise.resolve(s.value).then(i, l);
  c((r = r.apply(t, e)).next());
});
const Dl = "pipo-mobile-pi-list", vr = (t) => {
  const e = Xl(t), r = t.paymentMethod.paymentMethod === "BOLETO", a = t.paymentMethod.paymentMethod === "PIX";
  return e ? "ccdc" : r ? "boleto" : a ? "pix" : null;
}, Lf = [
  "INSTALLMENT"
], Vl = (t) => t.type === "others" ? vr(t) || t.paymentMethod.piListForm ? "expand" : "jump" : Xl(t) ? "expand" : "jump", Jf = Ft(
  (t, e) => {
    const {
      formatPaymentMethodList: r,
      formatStoredPaymentMethodList: a,
      formatUnavailableStoredPaymentMethodList: o,
      formatUnavailableOtherPaymentMethodList: i
    } = Kl(Vt(Ke({}, t), {
      type: "bind"
    })), {
      onSubmit: l,
      onValidate: c,
      onSelectPaymentMethod: s,
      onSetPrimary: p,
      onRemove: _,
      onFetchDistrict: m,
      onFetchAddressAutocomplete: d,
      onFetchPlaceDetail: f,
      onRedirectPP: g,
      paymentMethodsList: h,
      showSetPrimaryButton: y,
      onScanCard: u,
      onSendEvent: v,
      paymentMethodItemsMap: P,
      mergedPaymentMethodsList: $ = Lf,
      onGetUnifiedBinDetail: x,
      onTerminate: N,
      showStoredLength: C = 3
    } = t, {
      uiStoredPaymentMethodList: M,
      uiOtherPaymentMethodList: b,
      uiStoredUnboundPaymentMethodList: E
    } = Wl({
      paymentMethodItemsMap: P,
      formatPaymentMethodList: r,
      formatStoredPaymentMethodList: a,
      formatUnavailableOtherPaymentMethodList: i,
      mergeList: $
    }), O = xn(!0), T = () => {
      Z({
        name: "fp_sdk_checkout_dropin_element_click",
        categories: {
          click_scenario: O.state ? "show_all_cards" : "hide"
        }
      }), B && Z({
        name: "fp_sdk_checkout_page_click",
        categories: {
          click_method: O.state ? "show_all_cards" : "hide"
        }
      }), O.toggle();
    }, { hasSaved: W } = ge(() => ({
      hasSaved: M.length + o.length
    }), [o, M]), { isSubmitting: re, formSubmitState: J } = Rt(), [F, ee] = R({}), [pe, _e] = R(), G = ce({ mode: "all" }), {
      getValues: q,
      formState: { errors: z, touchedFields: H }
    } = G, Ee = de({
      touchedFields: H,
      errors: z
    }), ke = Vt(Ke({}, G), {
      formState: Vt(Ke({}, G.formState), { errors: Ee })
    }), { t: oe, isFlip: ve, defaultSendEvent: D, useOldEvent: B, paymentType: L, renewType: U } = I.useContext(), Z = (w) => {
      v == null || v(w), D == null || D(w);
    }, { isSelected: xe, toggle: $e, select: Be, selected: Ze } = Jl({
      list: b
    }), Te = (w) => er(void 0, null, function* () {
      const A = w || Ze[0];
      if (!A)
        return;
      if (pe && vr(A) && A.type === "others") {
        J.setTrue(), yield l(pe), J.setFalse();
        return;
      }
      const Ie = vr(A) ? F : q();
      Z({
        name: "fp_sdk_checkout_pi_management_click",
        categories: {
          click_method: "confirm",
          pi_type_1: A.paymentMethodType.paymentMethodType,
          pi_type_2: A.paymentMethod.paymentMethod,
          pi_type_3: "",
          pm_id: A.paymentMethod.paymentMethodId
        }
      }), J.setTrue(), yield l({
        paymentMethodType: A.paymentMethodType.paymentMethodType,
        paymentMethod: {
          paymentMethod: A.paymentMethod.paymentMethod,
          paymentMethodId: A.paymentMethod.paymentMethodId
        },
        paymentParams: fn({
          paymentMethodType: A.paymentMethodType.paymentMethodType,
          paymentMethod: A.paymentMethod.paymentMethod,
          paymentMethodId: A.paymentMethod.paymentMethodId,
          data: Ie
        }),
        formData: Ie,
        token: A.token
      }), J.setFalse();
    }), rt = (w) => {
      ee({});
      const A = w.isAgreementBound !== void 0 && (w == null ? void 0 : w.isAgreementBound) === !1;
      Z({
        name: "fp_sdk_checkout_pi_management_click",
        categories: {
          click_method: A ? "add_new" : "see_more",
          pi_type_1: w.paymentMethodType.paymentMethodType,
          pi_type_2: w.paymentMethod.paymentMethod,
          pi_type_3: "",
          pm_id: w.paymentMethod.paymentMethodId
        }
      }), A ? $e(w) : s == null || s(w, {
        type: "route",
        paymentMethodItem: w,
        payload: {
          path: "pi-detail",
          params: {
            showSetPrimaryButton: y,
            detail: w,
            onSetPrimary: p,
            onRemove: _,
            onTerminate: N
          }
        }
      });
    }, kt = (w) => er(void 0, null, function* () {
      ee({});
      const A = vr(w), Ie = hn(w);
      if ((A || w.paymentMethod.piListForm) && Ie) {
        $e(w), !xe(w) && (s == null || s(w));
        return;
      }
      A ? (xe(w) || (Z({
        name: "fp_sdk_checkout_pi_management_click",
        categories: {
          click_method: "pi_choose",
          pi_type_1: w.paymentMethodType.paymentMethodType,
          pi_type_2: w != null && w.needMerge ? "" : w.paymentMethod.paymentMethod,
          pi_type_3: "",
          pm_id: w != null && w.needMerge ? "" : w.paymentMethod.paymentMethodId,
          saved_pi: "other"
        }
      }), s == null || s(w)), $e(w)) : us(w) ? (!xe(w) && (s == null || s(w)), $e(w)) : (Be(w), s == null || s(w), yield Te(w));
    });
    j(
      () => {
        const w = {
          name: "fp_sdk_checkout_pi_list_show",
          categories: {
            saved_cards_num: `${a.length}`,
            other_pi_num: `${r.length}`
          }
        };
        Z(w);
      },
      []
    );
    const { activePath: gt, routerParams: Et } = sr(e, {
      initPath: "pi-list",
      initParams: {
        onSubmit: l,
        onValidate: c,
        onFetchDistrict: m,
        onFetchAddressAutocomplete: d,
        onFetchPlaceDetail: f,
        onRedirectPP: g,
        paymentMethodList: h,
        onScanCard: u,
        onSendEvent: Z,
        onGetUnifiedBinDetail: x
      }
    });
    return gt === "pi-detail" ? /* @__PURE__ */ n.createElement(wf, Ke({}, Et)) : /* @__PURE__ */ n.createElement("div", {
      className: "pipo-mobile w-full h-full",
      style: { direction: ve ? "rtl" : "ltr" },
      "data-sel": "pipo-mobile-pilist-wrapper"
    }, /* @__PURE__ */ n.createElement("div", {
      style: { overflowX: "unset", position: "relative" },
      className: "w-full h-full box-border"
    }, /* @__PURE__ */ n.createElement(jl, Ke({}, ke), /* @__PURE__ */ n.createElement("form", {
      className: "w-full h-full",
      onKeyDown: (w) => {
        w.keyCode === 13 && w.preventDefault();
      }
    }, /* @__PURE__ */ n.createElement("div", {
      className: "pt-24 pb-24 pl-16 pr-16 w-full h-full",
      style: {
        overflowY: "auto",
        position: "relative",
        overflowX: "unset"
      }
    }, W ? /* @__PURE__ */ n.createElement("div", {
      className: ae(
        "H3-SemiBold text-color-TextPrimary mb-24",
        `${Dl}-saved-cards`
      )
    }, oe(L === "agreement" || L === "subscription" && U === "auto" ? "pipo_payin_saveagreemnetdeductionassett" : "pipo_payin_checkout_saved_pm")) : null, (() => {
      const w = o[0];
      return w != null && w.isPrimary ? /* @__PURE__ */ n.createElement(Tr, {
        key: w.token,
        errorCode: w.unavailableErrorCode,
        icon: w.paymentMethod.icon.iconUrl,
        label: $t(w, oe),
        isPrimary: w.isPrimary,
        balance: w.balance
      }) : null;
    })(), M.map((w, A) => !O.state || A < C ? /* @__PURE__ */ n.createElement(rr, {
      key: w.token,
      type: "jump",
      "data-sel": `pipo-mobile-stored-payment-method-${w.paymentMethod.paymentMethod.toLowerCase()}`,
      onSelect: () => rt(w),
      isPrimary: Boolean(w.isPrimary),
      isExpired: Boolean(w.isExpired),
      icon: w.paymentMethod.icon.iconUrl,
      label: $t(w, oe)
    }, /* @__PURE__ */ n.createElement(n.Fragment, null)) : null), o.map((w, A) => w.isPrimary ? null : !O.state || A + M.length < C ? /* @__PURE__ */ n.createElement(Tr, {
      key: w.token,
      errorCode: w.unavailableErrorCode,
      icon: w.paymentMethod.icon.iconUrl,
      label: $t(w, oe),
      balance: w.balance
    }) : null), M.length + (o == null ? void 0 : o.length) > C && /* @__PURE__ */ n.createElement("div", {
      className: "pipo-mobile-seeMore"
    }, /* @__PURE__ */ n.createElement("div", {
      className: "pipo-mobile-seeMore-button",
      onClick: T
    }, /* @__PURE__ */ n.createElement("span", {
      className: "pipo-mobile-seeMore-text text-color-TextPrimary P2-Semibold"
    }, O.state ? oe("pipo_payin_show_card") : oe("pipo_payin_put_cards_hide")), O.state ? /* @__PURE__ */ n.createElement(nc, null) : /* @__PURE__ */ n.createElement(ac, null))), (Boolean(E == null ? void 0 : E.length) || Boolean(b == null ? void 0 : b.length)) && /* @__PURE__ */ n.createElement("div", {
      className: ae(
        "H3-SemiBold text-color-TextPrimary mb-24",
        { "mt-32": W },
        `${Dl}-add-payment-method`
      )
    }, oe(L === "agreement" || L === "subscription" && U === "auto" ? "pipo_payin_addnewagreementdeductionassets" : "pipo_payin_checkout_other_payment_methods")), (E == null ? void 0 : E.length) !== 0 && (E == null ? void 0 : E.map((w) => {
      const A = {
        type: Vl(w),
        "data-sel": `pipo-mobile-stored-payment-method-${w.paymentMethod.paymentMethod.toLowerCase()}`,
        onSelect: () => rt(w),
        isSelected: xe(w),
        isPrimary: Boolean(w.isPrimary),
        isExpired: Boolean(w.isExpired),
        icon: w.paymentMethod.icon.iconUrl,
        label: $t(w, oe)
      }, Ie = {
        item: w,
        selected: Ze,
        value: F,
        onChange: ee,
        onSelect: () => null,
        onValidate: () => null,
        paymentMethodsList: h,
        onFetchDistrict: m,
        onBindSubmit: () => er(void 0, null, function* () {
          yield Te();
        }),
        isSubmitting: re,
        onSendEvent: Z
      };
      if (zl(w)) {
        const nt = w.formRender;
        return /* @__PURE__ */ n.createElement(nt, Vt(Ke({
          key: w.token
        }, A), {
          extraProps: Ie,
          onSubmit: () => Promise.resolve(),
          onBind: l,
          piManageExtra: {}
        }));
      }
      return /* @__PURE__ */ n.createElement(rr, Ke({
        key: w.token
      }, A), /* @__PURE__ */ n.createElement(If, Ke({}, Ie)));
    })), b.map((w, A) => {
      const Ie = {
        item: w,
        selected: Ze,
        value: F,
        onChange: (Qe, Ut) => {
          ee(Qe), _e(Ut);
        },
        paymentMethodsList: h,
        onFetchDistrict: m,
        onGetUnifiedBinDetail: x,
        onFetchAddressAutocomplete: d,
        onFetchPlaceDetail: f,
        onBindSubmit: () => er(void 0, null, function* () {
          yield Te();
        }),
        isSubmitting: re,
        onSendEvent: Z
      }, nt = {
        type: Vl(w),
        "data-sel": `pipo-mobile-add-payment-method-${A}`,
        onSelect: () => er(void 0, null, function* () {
          yield kt(w);
        }),
        isSelected: w.needMerge ? yn(w, Ze) : xe(w),
        icon: w.needMerge ? w.paymentMethodType.icon.iconUrl : w.paymentMethod.icon.iconUrl,
        label: Yl({ item: w, t: oe, scene: "piListLong" })
      };
      if (hn(w)) {
        const Qe = w.formRender;
        return /* @__PURE__ */ n.createElement(Qe, Vt(Ke({
          key: A
        }, nt), {
          extraProps: Vt(Ke({}, Ie), {
            onSelect: () => null,
            onValidate: () => null
          }),
          onSubmit: () => Promise.resolve(),
          onBind: l,
          piManageExtra: { onRedirectPP: g }
        }));
      }
      return /* @__PURE__ */ n.createElement(rr, Ke({
        key: A
      }, nt), /* @__PURE__ */ n.createElement(Of, Ke({}, Ie)));
    }))))));
  }
);
export {
  Tn as AddressInfoForm,
  In as BoletoForm,
  Wf as CCDC,
  Nn as CCDCForm,
  $i as CCDCTokenExtra,
  fu as FamilymartForm,
  n_ as OVODirectForm,
  $h as OtherExtra,
  bu as OxxoForm,
  wf as PIDetail,
  Jf as PIList,
  Lr as PayButton,
  Hu as PayEasyForm,
  rr as PaymentMethodItem,
  Dh as PaymentMethods,
  ev as PipoProvider,
  Bn as PixForm,
  ky as QIWIForm
};
